import { getCachedCycle } from '../utils/cycleCache';

export const weeklyContent = [
  {
    day: 1,
    topic: "Travel ✈️",
    imageKeywords: [
      "person packing suitcase travel",
      "airport departure board travelers",
      "tourist map city street",
      "family boarding airplane",
      "backpacker hiking mountain trail"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Itinerary", meaning: "A detailed plan of a journey", meaningAZ: "Səyahət üçün ətraflı plan", meaningTR: "Bir yolculuğun ayrıntılı planı", example: "We stuck to our itinerary and saw everything." },
      { word: "Layover", meaning: "A stop between flights", meaningAZ: "Uçuşlar arasında dayanacaq", meaningTR: "Uçuşlar arasındaki bekleme, aktarma", example: "We had a 4-hour layover in Istanbul." },
      { word: "Backpacker", meaning: "A budget traveller who carries a backpack", meaningAZ: "Sırt çantası daşıyan büdcəli səyahətçi", meaningTR: "Sırt çantasıyla gezen bütçeli gezgin", example: "She spent a year as a backpacker in Asia." },
      { word: "Jet lag", meaning: "Tiredness after a long flight across time zones", meaningAZ: "Saat qurşağı üzrə uzun uçuşdan sonra yorğunluq", meaningTR: "Saat dilimlerini aşan uzun uçuştan sonraki yorgunluk", example: "Jet lag made me sleep all day after landing." },
      { word: "Customs", meaning: "The border control where bags are checked", meaningAZ: "Çantaların yoxlanıldığı sərhəd nəzarəti", meaningTR: "Bagajların kontrol edildiği sınır kapısı, gümrük", example: "We waited an hour at customs." },
      { word: "Boarding pass", meaning: "The card that lets you get on a plane", meaningAZ: "Təyyarəyə minməyə icazə verən kart", meaningTR: "Uçağa binmeni sağlayan kart", example: "I lost my boarding pass at the gate." },
      { word: "Sightseeing", meaning: "Visiting the interesting places of a city", meaningAZ: "Şəhərin maraqlı yerlərini gəzmək", meaningTR: "Bir şehrin ilginç yerlerini gezmek", example: "We spent the whole day sightseeing." },
      { word: "Homesick", meaning: "Sad because you are far from home", meaningAZ: "Evdən uzaq olduğu üçün darıxan", meaningTR: "Evden uzak olduğu için özlem duyan", example: "By day four I was homesick." },
    ],
    idioms: [
      { phrase: "Hit the road", meaning: "To begin a journey", meaningAZ: "Səyahətə başlamaq üçün", meaningTR: "Yola çıkmak", example: "Let's hit the road before sunrise." },
      { phrase: "Off the beaten track", meaning: "A place away from tourist crowds", meaningAZ: "Turist izdihamından uzaq bir yer", meaningTR: "Turist kalabalığından uzak bir yer", example: "We found a beautiful café off the beaten track." },
      { phrase: "Travel light", meaning: "To pack minimal luggage", meaningAZ: "Minimum baqaj yığmaq üçün", meaningTR: "Az eşyayla seyahat etmek", example: "I always travel light on short trips." },
    ],
    questions: {
      easy: [
        "What is your favourite country to visit and why?",
        "Do you prefer travelling alone or with friends?",
        "What do you always pack when you travel?",
        "Have you ever been on a plane? How was it?",
        "What is the best food you tried while travelling?",
        "Where did you go on your last holiday?",
        "Do you prefer the sea, the mountains or the city?",
        "How do you usually book your trips?",
        "What is one place in your country every visitor should see?",
        "Who do you normally travel with?",
      ],
      hard: [
        "How does travelling abroad change a person's perspective on life?",
        "Do you think budget travel is better than luxury travel? Why?",
        "What are the pros and cons of solo travel?",
        "How has social media changed the way people travel?",
        "Should governments invest more in tourism? Discuss.",
        "Is mass tourism destroying the places people love to visit?",
        "Should countries limit the number of tourists they accept each year?",
        "Do you learn more from travelling or from reading about a place?",
        "How should travellers behave in a culture very different from their own?",
        "Will virtual reality ever replace real travel? Why or why not?",
      ],
    },
  },
  {
    day: 2,
    topic: "Technology 💻",
    imageKeywords: [
      "person typing laptop modern office",
      "smartphone app screen interaction",
      "virtual reality headset gamer",
      "server room technician working",
      "smart home technology tablet"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Artificial Intelligence", meaning: "Machines that simulate human thinking", meaningAZ: "İnsan düşüncəsini simulyasiya edən maşınlar", meaningTR: "İnsan düşüncesini taklit eden makineler", example: "AI is transforming healthcare." },
      { word: "Algorithm", meaning: "A set of rules for solving problems", meaningAZ: "Problemlərin həlli üçün qaydalar toplusu", meaningTR: "Sorun çözmek için kurallar dizisi", example: "Instagram's algorithm decides what you see." },
      { word: "Cybersecurity", meaning: "Protection of computer systems from attacks", meaningAZ: "Kompüter sistemlərinin hücumlardan qorunması", meaningTR: "Bilgisayar sistemlerinin saldırılardan korunması", example: "Cybersecurity is a growing career field." },
      { word: "Cloud storage", meaning: "Saving data on remote internet servers", meaningAZ: "Uzaq internet serverlərində məlumatların saxlanması", meaningTR: "Verilerin uzak internet sunucularında saklanması", example: "I back up my photos to cloud storage." },
      { word: "Automation", meaning: "Using machines to do tasks without humans", meaningAZ: "İnsanlar olmadan tapşırıqları yerinə yetirmək üçün maşınlardan istifadə", meaningTR: "İşleri insansız yapmak için makine kullanımı", example: "Automation replaced many factory jobs." },
      { word: "Update", meaning: "A newer version of software", meaningAZ: "Proqramın daha yeni versiyası", meaningTR: "Yazılımın daha yeni sürümü", example: "The update broke my camera app." },
      { word: "Password", meaning: "A secret word that protects an account", meaningAZ: "Hesabı qoruyan gizli söz", meaningTR: "Hesabı koruyan gizli sözcük", example: "Change that password, it is too simple." },
      { word: "Crash", meaning: "When a device or program stops suddenly", meaningAZ: "Cihaz və ya proqramın qəfil dayanması", meaningTR: "Cihazın ya da programın aniden durması", example: "My laptop crashed and I lost the file." },
    ],
    idioms: [
      { phrase: "Cutting edge", meaning: "The most modern and advanced", meaningAZ: "Ən müasir və qabaqcıl", meaningTR: "En modern ve ileri olan", example: "This phone uses cutting-edge technology." },
      { phrase: "Pull the plug", meaning: "To stop something completely", meaningAZ: "Bir şeyi tamamilə dayandırmaq", meaningTR: "Bir şeyi tamamen durdurmak", example: "They pulled the plug on the project." },
      { phrase: "Get up to speed", meaning: "To learn the latest information", meaningAZ: "Ən son məlumatları öyrənmək üçün", meaningTR: "En son bilgileri öğrenmek", example: "Let me get you up to speed on the update." },
    ],
    questions: {
      easy: [
        "What technology can you not live without?",
        "How many hours a day do you spend on your phone?",
        "What is your favourite app and why?",
        "Do you prefer texting or calling people?",
        "What was the first device you ever owned?",
        "What do you use your computer for most?",
        "How do you feel when your internet stops working?",
        "Do you play video games? Which ones?",
        "What new gadget would you like to buy?",
        "Do you read instructions or just try a new device?",
      ],
      hard: [
        "Is technology making us more or less social?",
        "Should children under 12 be allowed to use smartphones?",
        "How will AI affect employment in the next 10 years?",
        "Do you think social media does more harm than good?",
        "Should there be global regulations on artificial intelligence?",
        "Should people have the right to disconnect from work technology?",
        "Is our personal data safe with big technology companies?",
        "Does technology make learning easier or just faster?",
        "Should countries build their own technology instead of importing it?",
        "What technology do you think we will regret inventing?",
      ],
    },
  },
  {
    day: 3,
    topic: "Food & Culture 🍽️",
    imageKeywords: [
      "chef cooking busy kitchen",
      "family eating dinner table dining",
      "street food stall night market",
      "person eating fresh salad healthy",
      "waiter serving food restaurant"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Cuisine", meaning: "A style of cooking from a specific region", meaningAZ: "Müəyyən bir bölgədən yemək bişirmə tərzi", meaningTR: "Belirli bir bölgenin yemek kültürü", example: "Italian cuisine is loved worldwide." },
      { word: "Delicacy", meaning: "A rare or special food", meaningAZ: "Nadir və ya xüsusi yemək", meaningTR: "Nadir ya da özel bir yiyecek", example: "Caviar is considered a delicacy." },
      { word: "Staple", meaning: "A basic food eaten regularly", meaningAZ: "Müntəzəm olaraq yeyilən əsas yemək", meaningTR: "Düzenli olarak yenen temel yiyecek", example: "Rice is a staple food in many countries." },
      { word: "Portion", meaning: "The amount of food served at one time", meaningAZ: "Bir anda verilən yemək miqdarı", meaningTR: "Bir seferde servis edilen yemek miktarı", example: "The portions at that restaurant are huge." },
      { word: "Ingredient", meaning: "One item used to make a dish", meaningAZ: "One item used to make a dish", meaningTR: "Bir yemekte kullanılan malzeme", example: "Garlic is a key ingredient in this recipe." },
      { word: "Homemade", meaning: "Made at home, not bought", meaningAZ: "Alınmayıb evdə hazırlanmış", meaningTR: "Satın alınmayıp evde yapılmış", example: "Her homemade bread is famous in the street." },
      { word: "Spicy", meaning: "Having a strong, hot taste", meaningAZ: "Kəskin, acı dadı olan", meaningTR: "Keskin, acı tadı olan", example: "This soup is too spicy for me." },
      { word: "Table manners", meaning: "Polite behaviour while eating", meaningAZ: "Yemək zamanı ədəb qaydaları", meaningTR: "Yemek sırasındaki görgü kuralları", example: "Table manners differ from country to country." },
    ],
    idioms: [
      { phrase: "Food for thought", meaning: "Something worth thinking about seriously", meaningAZ: "Ciddi düşünməyə dəyər bir şey", meaningTR: "Üzerinde ciddi düşünmeye değer şey", example: "Her speech gave me a lot of food for thought." },
      { phrase: "A piece of cake", meaning: "Something very easy", meaningAZ: "Çox asan bir şey", meaningTR: "Çok kolay bir iş", example: "The exam was a piece of cake." },
      { phrase: "Bite off more than you can chew", meaning: "To take on too much at once", meaningAZ: "Bir anda çox şey götürmək", meaningTR: "Kaldırabileceğinden fazlasını üstlenmek", example: "Don't bite off more than you can chew." },
    ],
    questions: {
      easy: [
        "What is your favourite meal and how is it made?",
        "Do you prefer cooking at home or eating out?",
        "What food do you dislike and why?",
        "Have you ever tried food from another country?",
        "How important is food in your culture?",
        "What did you eat yesterday?",
        "Can you cook? What is your best dish?",
        "Do you eat with your family or alone?",
        "What is a popular street food in your country?",
        "Do you prefer sweet or salty food?",
      ],
      hard: [
        "How does food reflect the culture and history of a country?",
        "Should fast food companies be taxed more heavily?",
        "Is veganism a practical lifestyle for everyone?",
        "How has globalisation changed local food traditions?",
        "Should schools teach students how to cook?",
        "Should restaurants be required to show the calories in every dish?",
        "Is expensive food really better than simple home cooking?",
        "How does the food we eat affect the environment?",
        "Should traditional recipes be protected by law?",
        "Why do people connect food so strongly with memory and family?",
      ],
    },
  },
  {
    day: 4,
    topic: "Education 📚",
    imageKeywords: [
      "students classroom raising hands",
      "teacher writing chalkboard school",
      "university library studying books",
      "graduation ceremony students throwing hats",
      "person taking online course laptop"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Curriculum", meaning: "The subjects taught in a course of study", meaningAZ: "Tədris kursunda tədris olunan fənlər", meaningTR: "Bir eğitim programında okutulan dersler", example: "The school updated its curriculum last year." },
      { word: "Scholarship", meaning: "Financial support given for education", meaningAZ: "Təhsilə maddi dəstək verilir", meaningTR: "Eğitim için verilen maddi destek, burs", example: "She won a scholarship to study in the UK." },
      { word: "Critical thinking", meaning: "The ability to analyse information carefully", meaningAZ: "Məlumatı diqqətlə təhlil etmək bacarığı", meaningTR: "Bilgiyi dikkatle çözümleyebilme becerisi", example: "Critical thinking is essential in today's world." },
      { word: "Literacy", meaning: "The ability to read and write", meaningAZ: "Oxumaq və yazmaq bacarığı", meaningTR: "Okuma yazma bilme", example: "Literacy rates have improved globally." },
      { word: "Tuition", meaning: "Teaching given to a student or group", meaningAZ: "Tələbə və ya qrupa verilən tədris", meaningTR: "Bir öğrenciye ya da gruba verilen ders", example: "He pays for private tuition in maths." },
      { word: "Revise", meaning: "To study again before an exam", meaningAZ: "İmtahandan əvvəl təkrar etmək", meaningTR: "Sınavdan önce tekrar çalışmak", example: "I revised for three nights." },
      { word: "Deadline", meaning: "The last day work can be handed in", meaningAZ: "İşin təhvil verilə biləcəyi son gün", meaningTR: "İşin teslim edilebileceği son gün", example: "The essay deadline is Friday." },
      { word: "Drop out", meaning: "To leave a course before finishing", meaningAZ: "Təhsili bitirmədən tərk etmək", meaningTR: "Eğitimi bitirmeden bırakmak", example: "He dropped out in the second year." },
    ],
    idioms: [
      { phrase: "Hit the books", meaning: "To study hard", meaningAZ: "Çox oxumaq", meaningTR: "Sıkı ders çalışmak", example: "I need to hit the books before the exam." },
      { phrase: "Learn the ropes", meaning: "To learn how to do something", meaningAZ: "Bir şeyi necə etməyi öyrənmək", meaningTR: "Bir işin nasıl yapıldığını öğrenmek", example: "It took time to learn the ropes at university." },
      { phrase: "Pass with flying colours", meaning: "To succeed very easily", meaningAZ: "Çox asanlıqla uğur qazanmaq üçün", meaningTR: "Çok başarılı biçimde geçmek", example: "She passed her exam with flying colours." },
    ],
    questions: {
      easy: [
        "What was your favourite subject at school?",
        "Do you prefer studying alone or in a group?",
        "How do you study for an exam?",
        "Who was your favourite teacher and why?",
        "Do you think homework is useful?",
        "How long did you spend at school each day?",
        "What subject was hardest for you?",
        "Do you learn better in the morning or at night?",
        "What is something new you learned recently?",
        "Do you like exams or projects more?",
      ],
      hard: [
        "Is university education necessary for success in life?",
        "How should schools prepare students for the modern world?",
        "Should education be free for everyone globally?",
        "Does the current education system encourage creativity?",
        "How has online learning permanently changed education?",
        "Should students choose their own subjects from the age of 14?",
        "Are grades a fair way to measure a student's ability?",
        "Should teachers be paid according to their students' results?",
        "Is it better to study what you love or what pays well?",
        "How much should parents be involved in a child's education?",
      ],
    },
  },
  {
    day: 5,
    topic: "Health & Wellbeing 🏃",
    imageKeywords: [
      "person running park morning exercise",
      "doctor examining patient stethoscope",
      "yoga class meditation studio",
      "healthy breakfast fresh fruit",
      "therapist talking to patient clinic"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Nutrition", meaning: "Eating the right foods to stay healthy", meaningAZ: "Sağlam qalmaq üçün düzgün qidalar yeyin", meaningTR: "Sağlıklı kalmak için doğru beslenme", example: "Good nutrition is key to a long life." },
      { word: "Mental health", meaning: "Emotional and psychological wellbeing", meaningAZ: "Emosional və psixoloji rifah", meaningTR: "Duygusal ve psikolojik iyilik hâli", example: "Mental health is just as important as physical." },
      { word: "Sedentary", meaning: "Spending too much time sitting, not moving", meaningAZ: "Hərəkət etməmək, oturaraq çox vaxt keçirmək", meaningTR: "Çok oturan, hareketsiz", example: "A sedentary lifestyle increases health risks." },
      { word: "Immunity", meaning: "The body's natural ability to fight illness", meaningAZ: "Bədənin təbii xəstəliklərlə mübarizə qabiliyyəti", meaningTR: "Vücudun hastalıkla savaşma gücü, bağışıklık", example: "Exercise boosts your immunity." },
      { word: "Burnout", meaning: "Extreme exhaustion from overwork or stress", meaningAZ: "Həddindən artıq işdən və ya stresdən həddindən artıq tükənmə", meaningTR: "Aşırı çalışma ya da stresten tükenme", example: "She took a break to recover from burnout." },
      { word: "Checkup", meaning: "A regular medical examination", meaningAZ: "Müntəzəm tibbi müayinə", meaningTR: "Düzenli sağlık kontrolü", example: "I go for a checkup once a year." },
      { word: "Painkiller", meaning: "Medicine that reduces pain", meaningAZ: "Ağrını azaldan dərman", meaningTR: "Ağrıyı azaltan ilaç", example: "Take a painkiller and rest." },
      { word: "Stretch", meaning: "To extend your muscles gently", meaningAZ: "Əzələləri yumşaq şəkildə uzatmaq", meaningTR: "Kasları hafifçe germek", example: "Stretch before you run." },
    ],
    idioms: [
      { phrase: "Under the weather", meaning: "Feeling ill or unwell", meaningAZ: "Xəstə və ya pis hiss", meaningTR: "Kendini hasta hissetmek", example: "I'm feeling a bit under the weather today." },
      { phrase: "Back on your feet", meaning: "To recover from illness", meaningAZ: "Xəstəlikdən sağalmaq üçün", meaningTR: "Hastalıktan sonra toparlanmak", example: "She was back on her feet within a week." },
      { phrase: "Burn the candle at both ends", meaning: "To work too hard and sleep too little", meaningAZ: "Çox işləmək və çox az yatmaq", meaningTR: "Çok çalışıp az uyumak", example: "He's burning the candle at both ends." },
    ],
    questions: {
      easy: [
        "How do you stay healthy in your daily life?",
        "Do you exercise regularly? What do you do?",
        "What do you eat for breakfast?",
        "How many hours do you sleep each night?",
        "What do you do when you feel stressed?",
        "How often do you walk during the day?",
        "What is your favourite way to relax?",
        "Do you drink enough water?",
        "When did you last see a doctor?",
        "What habit would you like to change?",
      ],
      hard: [
        "Should governments ban junk food advertising to children?",
        "How can societies better support people with mental health issues?",
        "Is a work-life balance achievable in today's world?",
        "Should employers be responsible for employees' mental health?",
        "How has modern life negatively affected human health?",
        "Should healthcare be completely free for everyone?",
        "Is the fitness industry helping people or selling insecurity?",
        "How much responsibility does a person have for their own health?",
        "Should mental health days count as sick days at work?",
        "Do social media beauty standards damage people's wellbeing?",
      ],
    },
  },
  {
    day: 6,
    topic: "Environment 🌍",
    imageKeywords: [
      "planting tree volunteer nature",
      "recycling bin sorting plastic glass",
      "solar panels roof sunlight",
      "electric car charging station",
      "cleaning beach volunteers trash"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Sustainability", meaning: "Using resources without damaging the future", meaningAZ: "Gələcəyə zərər vermədən resurslardan istifadə etmək", meaningTR: "Geleceğe zarar vermeden kaynak kullanımı", example: "Sustainability is central to modern business." },
      { word: "Carbon footprint", meaning: "The CO2 produced by a person or activity", meaningAZ: "Bir şəxs və ya fəaliyyət tərəfindən istehsal olunan CO2", meaningTR: "Bir kişinin ya da faaliyetin ürettiği karbon miktarı", example: "Flying greatly increases your carbon footprint." },
      { word: "Renewable energy", meaning: "Energy from unlimited natural sources", meaningAZ: "Sərhədsiz təbii mənbələrdən enerji", meaningTR: "Tükenmeyen doğal kaynaklardan gelen enerji", example: "Solar panels generate renewable energy." },
      { word: "Deforestation", meaning: "Cutting down large areas of forest", meaningAZ: "Böyük meşə sahələrinin kəsilməsi", meaningTR: "Geniş orman alanlarının kesilmesi", example: "Deforestation destroys animal habitats." },
      { word: "Biodiversity", meaning: "The variety of life in an ecosystem", meaningAZ: "Ekosistemdə həyatın müxtəlifliyi", meaningTR: "Bir ekosistemdeki canlı çeşitliliği", example: "Rainforests have extraordinary biodiversity." },
      { word: "Recycle", meaning: "To turn used materials into new ones", meaningAZ: "İşlənmiş materialı yenidən emal etmək", meaningTR: "Kullanılmış malzemeyi yeniden işlemek", example: "We recycle glass and paper." },
      { word: "Pollution", meaning: "Harmful substances in air, water or land", meaningAZ: "Hava, su və torpaqdakı zərərli maddələr", meaningTR: "Hava, su ya da topraktaki zararlı maddeler", example: "Air pollution is worst in winter." },
      { word: "Single-use", meaning: "Thrown away after being used once", meaningAZ: "Bir dəfə istifadədən sonra atılan", meaningTR: "Bir kez kullanılıp atılan", example: "The café stopped single-use cups." },
    ],
    idioms: [
      { phrase: "Go green", meaning: "To live or work in an eco-friendly way", meaningAZ: "Ekoloji cəhətdən təmiz bir şəkildə yaşamaq və ya işləmək", meaningTR: "Çevreye duyarlı yaşamak ya da çalışmak", example: "Our office decided to go green this year." },
      { phrase: "Drop in the ocean", meaning: "A small effort that has little impact", meaningAZ: "Təsiri az olan kiçik bir səy", meaningTR: "Etkisi çok küçük kalan çaba", example: "Recycling alone is a drop in the ocean." },
      { phrase: "Turn over a new leaf", meaning: "To change behaviour for the better", meaningAZ: "Davranışı yaxşılığa doğru dəyişmək", meaningTR: "Davranışını iyiye doğru değiştirmek", example: "He turned over a new leaf and stopped wasting." },
    ],
    questions: {
      easy: [
        "Do you recycle at home? What do you recycle?",
        "What is the environment like in your city?",
        "Do you use public transport? Why or why not?",
        "Have you seen any environmental problems near you?",
        "What small things can people do to help the planet?",
        "What is the weather usually like where you live?",
        "Do you like spending time in nature?",
        "How do you get to work or school?",
        "Do you turn off the lights when you leave a room?",
        "Is there a park or green space near your home?",
      ],
      hard: [
        "Who is more responsible for climate change — individuals or governments?",
        "Should petrol cars be banned completely?",
        "Is economic growth compatible with environmental protection?",
        "How can developing countries grow without harming the environment?",
        "Should there be a global carbon tax?",
        "Should recycling be made compulsory by law?",
        "Are electric cars really the solution to pollution?",
        "How can we convince people to change their daily habits?",
        "Should rich countries pay poorer countries for climate damage?",
        "Is it fair to ask ordinary people to sacrifice comfort for the planet?",
      ],
    },
  },
  {
    day: 7,
    topic: "Work & Career 💼",
    imageKeywords: [
      "business meeting office colleagues",
      "person working from home laptop",
      "job interview shaking hands professional",
      "construction worker helmet building site",
      "presentation whiteboard office team"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Entrepreneur", meaning: "Someone who starts their own business", meaningAZ: "Öz işinə başlayan kimsə", meaningTR: "Kendi işini kuran kişi, girişimci", example: "She became an entrepreneur at 25." },
      { word: "Networking", meaning: "Building professional relationships", meaningAZ: "Peşəkar əlaqələrin qurulması", meaningTR: "Mesleki ilişkiler kurma", example: "Networking helped him find a great job." },
      { word: "Deadline", meaning: "The latest time to complete something", meaningAZ: "Nəyisə tamamlamaq üçün son vaxt", meaningTR: "Bir işin bitirilmesi gereken son zaman", example: "The deadline is Friday at noon." },
      { word: "Remote work", meaning: "Working from home or outside the office", meaningAZ: "Evdən və ya ofisdən kənarda işləmək", meaningTR: "Evden ya da ofis dışından çalışma", example: "Remote work became common after 2020." },
      { word: "Promotion", meaning: "Moving to a higher position at work", meaningAZ: "İş yerində daha yüksək vəzifəyə keçmək", meaningTR: "İşte daha üst bir göreve geçme, terfi", example: "She received a promotion last month." },
      { word: "Colleague", meaning: "A person you work with", meaningAZ: "Birlikdə işlədiyin həmkar", meaningTR: "Birlikte çalıştığın kişi, meslektaş", example: "A colleague covered my shift." },
      { word: "Resign", meaning: "To leave a job by your own choice", meaningAZ: "Öz istəyi ilə işdən çıxmaq", meaningTR: "Kendi isteğiyle işten ayrılmak", example: "She resigned after six years." },
      { word: "Workload", meaning: "The amount of work you have", meaningAZ: "Üzərinə düşən iş həcmi", meaningTR: "Üstündeki iş yükü", example: "My workload doubled in May." },
    ],
    idioms: [
      { phrase: "Climb the ladder", meaning: "To progress upward in your career", meaningAZ: "Karyeranızda yüksəlmək üçün", meaningTR: "Kariyerde yukarı doğru ilerlemek", example: "He worked hard to climb the ladder." },
      { phrase: "Go the extra mile", meaning: "To do more than what is expected", meaningAZ: "Gözləniləndən daha çox şey etmək", meaningTR: "Beklenenden fazlasını yapmak", example: "Always go the extra mile at work." },
      { phrase: "Back to the drawing board", meaning: "To start again after something fails", meaningAZ: "Bir şey uğursuz olduqdan sonra yenidən başlamaq", meaningTR: "Başarısızlıktan sonra baştan başlamak", example: "The plan failed — back to the drawing board." },
    ],
    questions: {
      easy: [
        "What is your dream job and why?",
        "Do you prefer working indoors or outdoors?",
        "What skills do you think are important for any job?",
        "Would you prefer working for a company or being your own boss?",
        "How do you handle a difficult day at work?",
        "What job did you want as a child?",
        "Do you prefer working alone or in a team?",
        "What time do you usually start your day?",
        "What makes a good boss?",
        "Have you ever had a part-time job?",
      ],
      hard: [
        "Will remote work permanently change office culture?",
        "Should the working week be reduced to 4 days?",
        "How important is job satisfaction compared to salary?",
        "Is it ethical for companies to monitor employees at home?",
        "How should people prepare for job automation in the future?",
        "Is loyalty to one company still valuable today?",
        "Should salaries be public inside a company?",
        "How do you know when it is time to change career?",
        "Are internships fair if they are unpaid?",
        "Does hard work always lead to success? Discuss.",
      ],
    },
  },
  {
    day: 8,
    topic: "Social Media 📱",
    imageKeywords: [
      "person scrolling smartphone social media",
      "influencer recording video phone",
      "friends taking selfie smiling",
      "typing message phone texting",
      "laptop showing social media feed"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Influencer", meaning: "Someone with a large online following who affects opinions", meaningAZ: "Fikirlərə təsir edən böyük onlayn izləyicisi olan biri", meaningTR: "Çok takipçisi olan ve görüşleri etkileyen kişi", example: "She became an influencer after her videos went viral." },
      { word: "Viral", meaning: "Content that spreads very quickly online", meaningAZ: "İnternetdə çox sürətlə yayılan məzmun", meaningTR: "İnternette çok hızlı yayılan içerik", example: "His post went viral overnight." },
      { word: "Engagement", meaning: "Likes, comments, and shares on a post", meaningAZ: "Bir postu bəyənir, şərh edir və paylaşır", meaningTR: "Bir gönderiye gelen beğeni, yorum ve paylaşım", example: "Her videos get high engagement." },
      { word: "Algorithm", meaning: "The system that decides what content you see", meaningAZ: "Hansı məzmunu görəcəyinizə qərar verən sistem", meaningTR: "Hangi içeriği göreceğini belirleyen sistem", example: "The algorithm favours video content now." },
      { word: "Troll", meaning: "A person who posts offensive comments to upset others", meaningAZ: "Başqalarını incitmək üçün təhqiredici şərhlər yazan adam", meaningTR: "İnsanları kızdırmak için saldırgan yorum yazan kişi", example: "She ignored the trolls and kept posting." },
      { word: "Feed", meaning: "The stream of posts you scroll through", meaningAZ: "Sürüşdürdüyün paylaşım axını", meaningTR: "Kaydırarak gezdiğin gönderi akışı", example: "My feed is full of the same thing." },
      { word: "Block", meaning: "To stop someone from contacting you online", meaningAZ: "Kiminsə səninlə onlayn əlaqəsini kəsmək", meaningTR: "Birinin seninle çevrimiçi iletişimini kesmek", example: "I blocked the account and moved on." },
      { word: "Screen time", meaning: "The hours spent looking at a screen", meaningAZ: "Ekrana baxmaqla keçən saatlar", meaningTR: "Ekrana bakarak geçen saatler", example: "My screen time was six hours yesterday." },
    ],
    idioms: [
      { phrase: "In the spotlight", meaning: "Attracting a lot of public attention", meaningAZ: "Çoxlu ictimaiyyətin diqqətini cəlb etmək", meaningTR: "Kamuoyunun ilgi odağında olmak", example: "Social media keeps celebrities in the spotlight." },
      { phrase: "Stir up", meaning: "To cause trouble or controversy", meaningAZ: "Problem və ya mübahisə yaratmaq", meaningTR: "Ortalığı karıştırmak, tartışma yaratmak", example: "His tweet stirred up a huge debate online." },
      { phrase: "Jump on the bandwagon", meaning: "To follow a trend because others do", meaningAZ: "Başqalarının etdiyinə görə bir trendi izləmək", meaningTR: "Başkaları yaptığı için bir akıma katılmak", example: "Everyone jumped on the bandwagon with that challenge." },
    ],
    questions: {
      easy: [
        "Which social media platforms do you use the most?",
        "How much time do you spend on social media each day?",
        "Have you ever posted something that got a lot of attention?",
        "Do you follow any influencers? Who and why?",
        "What is the best thing you have seen on social media recently?",
        "What was the last thing you posted online?",
        "Do you read the comments under posts?",
        "Which app do you open first in the morning?",
        "Do you prefer photos or short videos?",
        "Have you ever taken a break from social media?",
      ],
      hard: [
        "Should social media platforms be held responsible for fake news?",
        "Does social media help or hurt mental health? Give examples.",
        "Should there be an age limit for using social media?",
        "Is the influencer lifestyle realistic or dangerous to promote?",
        "How has social media changed the way we form relationships?",
        "Should social media companies pay users for their content?",
        "Is online popularity a real form of success?",
        "How does comparing ourselves online affect self-confidence?",
        "Should political advertising be banned on social platforms?",
        "Will people eventually get tired of social media? Why?",
      ],
    },
  },
  {
    day: 9,
    topic: "Money & Finances 💰",
    imageKeywords: [
      "person paying card payment store",
      "counting cash money hands",
      "family budget planning table",
      "online banking phone screen",
      "piggy bank savings coins"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Budget", meaning: "A plan for how to spend money", meaningAZ: "Pulun necə xərclənməsi planı", meaningTR: "Parayı nasıl harcayacağına dair plan", example: "I made a monthly budget to save more." },
      { word: "Investment", meaning: "Spending money to earn more in the future", meaningAZ: "Gələcəkdə daha çox qazanmaq üçün pul xərcləmək", meaningTR: "Gelecekte kazanmak için para koyma, yatırım", example: "He made a wise investment in property." },
      { word: "Debt", meaning: "Money you owe to someone else", meaningAZ: "Başqasına borcunuz olan pul", meaningTR: "Başkasına olan para borcu", example: "She paid off her debt after two years." },
      { word: "Inflation", meaning: "A general rise in the price of goods", meaningAZ: "Malların qiymətində ümumi artım", meaningTR: "Fiyatların genel olarak yükselmesi", example: "Inflation made everyday items more expensive." },
      { word: "Salary", meaning: "Fixed regular payment for a job", meaningAZ: "Bir iş üçün sabit müntəzəm ödəniş", meaningTR: "Bir iş için düzenli ödenen sabit ücret", example: "His salary increased after the promotion." },
      { word: "Savings", meaning: "Money kept for the future", meaningAZ: "Gələcək üçün yığılan pul", meaningTR: "Gelecek için biriktirilen para", example: "The repair ate half our savings." },
      { word: "Loan", meaning: "Money borrowed that must be paid back", meaningAZ: "Qaytarılmalı olan borc pul", meaningTR: "Geri ödenmesi gereken ödünç para", example: "They took a loan for the car." },
      { word: "Afford", meaning: "To have enough money for something", meaningAZ: "Bir şeyə pulunun çatması", meaningTR: "Bir şeye parasının yetmesi", example: "We can't afford that this month." },
    ],
    idioms: [
      { phrase: "Break the bank", meaning: "To cost too much money", meaningAZ: "Çox pul xərcləmək", meaningTR: "Çok pahalıya patlamak", example: "Buying that car would break the bank." },
      { phrase: "Tighten your belt", meaning: "To spend less money", meaningAZ: "Daha az pul xərcləmək üçün", meaningTR: "Daha az harcamak, kemer sıkmak", example: "We had to tighten our belts during tough times." },
      { phrase: "On a shoestring", meaning: "With very little money", meaningAZ: "Çox az pulla", meaningTR: "Çok az parayla", example: "They ran the project on a shoestring budget." },
    ],
    questions: {
      easy: [
        "Do you save money regularly? How do you do it?",
        "What would you do if you won a lot of money?",
        "Do you prefer paying by cash or card?",
        "What is something you saved up to buy?",
        "Do you think it is important to talk about money with friends?",
        "What did you last spend money on?",
        "Do you write down what you spend?",
        "Is it easy to save money in your country?",
        "What is a good gift that does not cost much?",
        "Do you lend money to friends?",
      ],
      hard: [
        "Is it better to save money or invest it? Discuss.",
        "Should wealthy people pay more taxes? Why?",
        "How does money affect personal relationships?",
        "Should financial education be taught in schools?",
        "Is it possible to be happy without much money?",
        "Does having more money always bring more freedom?",
        "Should there be a maximum salary as well as a minimum one?",
        "Is buying a home better than renting? Discuss.",
        "How does growing up poor or rich shape a person's view of money?",
        "Should governments give every citizen a basic income?",
      ],
    },
  },
  {
    day: 10,
    topic: "Films & Series 🎬",
    imageKeywords: [
      "watching movie cinema popcorn",
      "family watching tv living room",
      "film set camera crew shooting",
      "actor on stage theatre performing",
      "streaming series laptop bed"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Plot", meaning: "The story or sequence of events in a film", meaningAZ: "Filmdəki hadisələrin hekayəsi və ya ardıcıllığı", meaningTR: "Bir filmdeki olayların örgüsü", example: "The plot had many unexpected twists." },
      { word: "Sequel", meaning: "A film that continues a previous story", meaningAZ: "Əvvəlki hekayəni davam etdirən bir film", meaningTR: "Önceki hikâyeyi sürdüren film, devam filmi", example: "The sequel was better than the original." },
      { word: "Soundtrack", meaning: "The music used in a film or series", meaningAZ: "Film və ya serialda istifadə olunan musiqi", meaningTR: "Bir film ya da dizide kullanılan müzik", example: "The soundtrack won an Oscar." },
      { word: "Binge-watch", meaning: "To watch many episodes in one sitting", meaningAZ: "Bir oturuşda çoxlu epizodlara baxmaq", meaningTR: "Arka arkaya çok bölüm izlemek", example: "I binge-watched the whole series in one weekend." },
      { word: "Cliffhanger", meaning: "An exciting ending that leaves you wondering what happens next", meaningAZ: "Sizi bundan sonra nə olacağını düşünməyə vadar edən maraqlı sonluq", meaningTR: "Merakta bırakan heyecanlı son", example: "The episode ended on a cliffhanger." },
      { word: "Subtitles", meaning: "Written words at the bottom of the screen", meaningAZ: "Ekranın altındakı yazılı mətn, altyazı", meaningTR: "Ekranın altındaki yazı, altyazı", example: "I watch everything with subtitles." },
      { word: "Spoiler", meaning: "Information that ruins the surprise", meaningAZ: "Sürprizi korlayan məlumat", meaningTR: "Sürprizi bozan bilgi", example: "Don't tell me, no spoilers!" },
      { word: "Cast", meaning: "All the actors in a film", meaningAZ: "Filmdəki bütün aktyorlar", meaningTR: "Bir filmdeki tüm oyuncular", example: "The cast is better than the script." },
    ],
    idioms: [
      { phrase: "Steal the show", meaning: "To be the best performer in something", meaningAZ: "Bir işdə ən yaxşı ifaçı olmaq", meaningTR: "En çok beğenilen olmak, gösteriyi çalmak", example: "The child actor stole the show." },
      { phrase: "On the edge of your seat", meaning: "Very excited or nervous", meaningAZ: "Çox həyəcanlı və ya əsəbi", meaningTR: "Heyecandan yerinde duramamak", example: "The thriller kept me on the edge of my seat." },
      { phrase: "Give it a shot", meaning: "To try something", meaningAZ: "Bir şeyi sınamaq üçün", meaningTR: "Bir denemek", example: "I wasn't sure about the series, but I gave it a shot." },
    ],
    questions: {
      easy: [
        "What is your favourite film of all time and why?",
        "Do you prefer watching films at home or at the cinema?",
        "What genre do you enjoy the most — action, comedy, drama?",
        "Have you ever watched a film in another language?",
        "Who is your favourite actor or actress?",
        "What was the last film you watched?",
        "Do you watch films with subtitles?",
        "Do you like watching a series slowly or all at once?",
        "What film have you seen more than twice?",
        "Do you prefer films or series? Why?",
      ],
      hard: [
        "How do films and series influence society's values?",
        "Do you think streaming platforms have killed cinema?",
        "Should violent or explicit content be allowed on streaming platforms?",
        "How do films portray different cultures — fairly or unfairly?",
        "What makes a truly great film?",
        "Are remakes and sequels a sign that creativity is dying?",
        "Should films from other countries be dubbed or subtitled?",
        "Can a film change someone's opinion about a serious issue?",
        "Do awards like the Oscars really reflect quality?",
        "Should streaming platforms show how their algorithm chooses films?",
      ],
    },
  },
  {
    day: 11,
    topic: "Music 🎵",
    imageKeywords: [
      "person playing guitar stage concert",
      "band performing live music audience",
      "listening music headphones smiling",
      "dj playing music festival crowd",
      "choir singing church school"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Genre", meaning: "A category of music with a shared style", meaningAZ: "Paylaşılan üsluba malik musiqi kateqoriyası", meaningTR: "Ortak bir tarzı olan müzik türü", example: "Hip-hop is the most popular genre today." },
      { word: "Lyrics", meaning: "The words of a song", meaningAZ: "Bir mahnının sözləri", meaningTR: "Bir şarkının sözleri", example: "The lyrics of this song are very meaningful." },
      { word: "Chorus", meaning: "The repeated section of a song", meaningAZ: "Mahnının təkrarlanan hissəsi", meaningTR: "Şarkının tekrarlanan bölümü, nakarat", example: "Everyone knew the chorus by heart." },
      { word: "Live performance", meaning: "Music played in front of an audience", meaningAZ: "Tamaşaçılar qarşısında musiqi səsləndi", meaningTR: "Seyirci önünde yapılan müzik performansı", example: "Her live performance was breathtaking." },
      { word: "Collaboration", meaning: "Two or more artists working together", meaningAZ: "İki və ya daha çox rəssamın birlikdə işləməsi", meaningTR: "İki ya da daha fazla sanatçının birlikte çalışması", example: "The collaboration produced a number-one hit." },
      { word: "Melody", meaning: "The main tune of a song", meaningAZ: "Mahnının əsas havası, melodiya", meaningTR: "Şarkının ana ezgisi", example: "The melody stays in your head." },
      { word: "Rehearse", meaning: "To practise before a performance", meaningAZ: "Çıxışdan əvvəl məşq etmək", meaningTR: "Gösteriden önce prova yapmak", example: "The band rehearsed all week." },
      { word: "Tone-deaf", meaning: "Unable to hear differences in musical notes", meaningAZ: "Musiqi notlarını ayırd edə bilməyən", meaningTR: "Müzik notalarını ayırt edemeyen", example: "I love singing but I'm tone-deaf." },
    ],
    idioms: [
      { phrase: "Face the music", meaning: "To accept the consequences of your actions", meaningAZ: "Hərəkətlərinizin nəticələrini qəbul etmək", meaningTR: "Sonuçlarına katlanmak", example: "He made a mistake and now has to face the music." },
      { phrase: "Music to my ears", meaning: "Something you are very happy to hear", meaningAZ: "Eşitməkdən çox xoşbəxt olduğunuz bir şey", meaningTR: "Duymaktan çok memnun olunan söz", example: "The news was music to my ears." },
      { phrase: "Change your tune", meaning: "To change your opinion or attitude", meaningAZ: "Fikrinizi və ya münasibətinizi dəyişdirmək üçün", meaningTR: "Fikrini ya da tavrını değiştirmek", example: "He changed his tune after hearing the facts." },
    ],
    questions: {
      easy: [
        "What type of music do you listen to most?",
        "Who is your favourite singer or band?",
        "Do you play any musical instrument?",
        "What song always puts you in a good mood?",
        "Do you prefer live concerts or recorded music?",
        "When do you listen to music during the day?",
        "What was the first concert you wanted to attend?",
        "Do you sing when you are alone?",
        "What music do people in your family like?",
        "Do you listen to music while studying or working?",
      ],
      hard: [
        "How does music affect your emotions and mental state?",
        "Should music streaming services pay artists more?",
        "Has AI-generated music changed the industry for better or worse?",
        "Do you think lyrics can influence young people's behaviour?",
        "Is music a universal language? Explain your view.",
        "Should song lyrics ever be censored?",
        "Is it fair that some artists become famous through one viral song?",
        "How does music from other countries help you learn a language?",
        "Do concert ticket prices exclude ordinary fans?",
        "Will people still value albums in ten years, or only single songs?",
      ],
    },
  },
  {
    day: 12,
    topic: "Famous People & Celebrities ⭐",
    imageKeywords: [
      "paparazzi taking photos red carpet",
      "celebrity signing autographs fans",
      "famous actor interview microphone",
      "award ceremony giving speech stage",
      "fashion model runway walking"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Celebrity", meaning: "A person who is very famous", meaningAZ: "Çox məşhur olan şəxs", meaningTR: "Çok ünlü kişi", example: "She became a celebrity after her first film." },
      { word: "Role model", meaning: "A person whose behaviour others try to copy", meaningAZ: "Davranışını başqalarının kopyalamağa çalışdığı adam", meaningTR: "Davranışı örnek alınan kişi", example: "Athletes are role models for young people." },
      { word: "Reputation", meaning: "The way others see someone's character", meaningAZ: "Başqalarının kiminsə xarakterini görməsi", meaningTR: "Bir kişinin başkalarınca bilinen karakteri, itibar", example: "His reputation suffered after the scandal." },
      { word: "Paparazzi", meaning: "Photographers who follow famous people", meaningAZ: "Məşhur insanları izləyən fotoqraflar", meaningTR: "Ünlüleri takip eden fotoğrafçılar", example: "The paparazzi waited outside the restaurant." },
      { word: "Legacy", meaning: "What someone leaves behind after their life", meaningAZ: "Bir insanın həyatından sonra geridə qoyduqları şeylər", meaningTR: "Bir insanın ardında bıraktığı miras", example: "Einstein's legacy changed science forever." },
      { word: "Fan", meaning: "Someone who strongly admires a person", meaningAZ: "Kimisə çox bəyənən azarkeş, pərəstişkar", meaningTR: "Birini çok beğenen hayran", example: "He has fans in forty countries." },
      { word: "Scandal", meaning: "A shocking event that damages a reputation", meaningAZ: "Nüfuza zərbə vuran qalmaqal", meaningTR: "İtibarı zedeleyen skandal", example: "The scandal ended his career." },
      { word: "Privacy", meaning: "The right to keep your life to yourself", meaningAZ: "Şəxsi həyatını qorumaq hüququ", meaningTR: "Özel hayatını koruma hakkı", example: "Fame costs you your privacy." },
    ],
    idioms: [
      { phrase: "In the limelight", meaning: "Being the centre of public attention", meaningAZ: "İctimaiyyətin diqqət mərkəzində olmaq", meaningTR: "İlgi odağı olmak", example: "She has been in the limelight since her debut." },
      { phrase: "Fifteen minutes of fame", meaning: "A brief period of being famous", meaningAZ: "Məşhur olmağın qısa bir dövrü", meaningTR: "Kısa süren ün", example: "He had his fifteen minutes of fame on TV." },
      { phrase: "Rise to fame", meaning: "To become very well known", meaningAZ: "Çox məşhur olmaq", meaningTR: "Üne kavuşmak", example: "She rose to fame after the show aired." },
    ],
    questions: {
      easy: [
        "Who is your favourite famous person and why?",
        "Would you like to be a celebrity? Why or why not?",
        "What famous person do you admire the most?",
        "Have you ever met someone famous?",
        "What do you think is the hardest part of being famous?",
        "Which famous person would you invite to dinner?",
        "Do you follow any celebrity news?",
        "Who is the most famous person from your country?",
        "Would you want your face to be recognised everywhere?",
        "What talent would you like to be famous for?",
      ],
      hard: [
        "Do celebrities have a responsibility to be good role models?",
        "Does fame change a person's personality? How?",
        "Should celebrities be involved in politics?",
        "Is the media too invasive when reporting on famous people?",
        "Why do we idolise certain people in modern culture?",
        "Do we expect too much from people who are simply good at their job?",
        "Should celebrities be paid to advertise products they do not use?",
        "Is cancel culture fair to public figures?",
        "How does constant attention affect a young person's mental health?",
        "Are influencers replacing traditional celebrities? Is that better?",
      ],
    },
  },
  {
    day: 13,
    topic: "Hobbies & Free Time 🎨",
    imageKeywords: [
      "person painting canvas studio art",
      "gardening planting flowers backyard",
      "playing chess board game friends",
      "knitting sweater cozy armchair",
      "pottery making clay wheel hands"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Pastime", meaning: "An activity done for enjoyment", meaningAZ: "Zövq üçün edilən bir fəaliyyət", meaningTR: "Zevk için yapılan uğraş", example: "Reading is her favourite pastime." },
      { word: "Creative outlet", meaning: "A way to express thoughts or feelings", meaningAZ: "Düşüncələri və ya hissləri ifadə etmək üçün bir yol", meaningTR: "Düşünce ve duyguları ifade etme yolu", example: "Painting is a great creative outlet." },
      { word: "Dedicated", meaning: "Giving a lot of time and energy to something", meaningAZ: "Bir şeyə çox vaxt və enerji vermək", meaningTR: "Bir şeye çok zaman ve emek veren", example: "She is very dedicated to her hobby." },
      { word: "Leisure", meaning: "Free time away from work or study", meaningAZ: "İşdən və ya təhsildən kənarda boş vaxt", meaningTR: "İş ya da okuldan arta kalan boş zaman", example: "What do you do in your leisure time?" },
      { word: "Skill set", meaning: "A range of abilities a person has", meaningAZ: "Bir insanın bir sıra qabiliyyətləri var", meaningTR: "Bir kişinin sahip olduğu beceriler", example: "Photography improved his skill set." },
      { word: "Collect", meaning: "To gather things of one kind over time", meaningAZ: "Zamanla eyni növ şeyləri yığmaq", meaningTR: "Zamanla aynı türden şeyler toplamak", example: "He collects old postcards." },
      { word: "Beginner", meaning: "Someone who has just started", meaningAZ: "Yeni başlayan", meaningTR: "Yeni başlayan kişi", example: "It is a good class for beginners." },
      { word: "Hooked", meaning: "Unable to stop enjoying something", meaningAZ: "Aludə olmuş, əl çəkə bilməyən", meaningTR: "Kendini kaptırmış, bırakamayan", example: "One lesson and I was hooked." },
    ],
    idioms: [
      { phrase: "Pick up a hobby", meaning: "To start doing a new hobby", meaningAZ: "Yeni hobbi ilə məşğul olmağa başlamaq üçün", meaningTR: "Yeni bir hobiye başlamak", example: "She picked up painting during lockdown." },
      { phrase: "Kill time", meaning: "To do something while waiting", meaningAZ: "Gözləyərkən bir şey etmək", meaningTR: "Beklerken vakit geçirmek", example: "I read to kill time at the airport." },
      { phrase: "Get into something", meaning: "To become interested in an activity", meaningAZ: "Bir fəaliyyətlə maraqlanmaq", meaningTR: "Bir uğraşa ilgi duymaya başlamak", example: "I've really got into running lately." },
    ],
    questions: {
      easy: [
        "What hobbies do you have?",
        "How did you start your favourite hobby?",
        "Do you prefer indoor or outdoor hobbies?",
        "Have you ever tried a hobby and given up?",
        "Would you teach your hobby to others?",
        "What do you do on a free Sunday?",
        "Do you have a hobby that costs nothing?",
        "What hobby would you like to try one day?",
        "Do you share your hobby with anyone?",
        "How much free time do you have each week?",
      ],
      hard: [
        "Can hobbies turn into successful careers? Give examples.",
        "How do hobbies contribute to a person's mental wellbeing?",
        "Do people have enough free time in modern life?",
        "Should schools offer more time for creative hobbies?",
        "Is it better to have one deep hobby or many varied interests?",
        "Is it a problem that we feel guilty about doing nothing?",
        "Should every hobby be turned into income? Why or why not?",
        "Do screens take away time we used to spend on real hobbies?",
        "How do hobbies help people build a social life?",
        "Should companies give employees time for personal projects?",
      ],
    },
  },
  {
    day: 14,
    topic: "Fashion & Style 👗",
    imageKeywords: [
      "shopping clothes store fitting room",
      "fashion designer drawing sketches studio",
      "sewing machine making clothes tailor",
      "model wearing stylish outfit street",
      "closet full of clothes choosing"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Trend", meaning: "A popular style at a particular time", meaningAZ: "Müəyyən bir zamanda məşhur bir üslub", meaningTR: "Belirli bir dönemde popüler olan tarz", example: "Wide trousers are a big trend this year." },
      { word: "Sustainable fashion", meaning: "Clothing made with less harm to the environment", meaningAZ: "Ətraf mühitə daha az zərər verən geyimlər", meaningTR: "Çevreye daha az zarar veren giyim", example: "She only buys sustainable fashion brands." },
      { word: "Accessory", meaning: "An item worn to complete an outfit", meaningAZ: "Paltarı tamamlamaq üçün geyilən əşya", meaningTR: "Bir kıyafeti tamamlayan parça, aksesuar", example: "A scarf can be a great accessory." },
      { word: "Brand", meaning: "A company known for a particular product", meaningAZ: "Müəyyən bir məhsulla tanınan şirkət", meaningTR: "Belirli bir ürünle tanınan şirket, marka", example: "This brand is famous for its quality." },
      { word: "Wardrobe", meaning: "All the clothes a person owns", meaningAZ: "Bir insanın sahib olduğu bütün paltarlar", meaningTR: "Bir kişinin sahip olduğu tüm kıyafetler", example: "I need to update my wardrobe for winter." },
      { word: "Fit", meaning: "How well clothes match your body", meaningAZ: "Paltarın bədənə nə qədər uyğun gəlməsi", meaningTR: "Kıyafetin bedene ne kadar uyduğu", example: "The colour is fine but the fit is wrong." },
      { word: "Outfit", meaning: "A complete set of clothes worn together", meaningAZ: "Birlikdə geyinilən tam geyim dəsti", meaningTR: "Birlikte giyilen tam kıyafet takımı", example: "She planned the outfit for days." },
      { word: "Hand-me-down", meaning: "Clothing passed from an older person", meaningAZ: "Böyükdən qalan geyim", meaningTR: "Büyükten kalan giysi", example: "All my jackets were hand-me-downs." },
    ],
    idioms: [
      { phrase: "Dress to impress", meaning: "To wear your best clothes", meaningAZ: "Ən yaxşı paltarlarınızı geyinmək üçün", meaningTR: "En iyi kıyafetini giymek", example: "She always dresses to impress at interviews." },
      { phrase: "In fashion", meaning: "Currently popular or trendy", meaningAZ: "Hal-hazırda populyar və ya moda", meaningTR: "Şu anda moda olan", example: "Vintage clothing is very much in fashion now." },
      { phrase: "Off the rack", meaning: "Ready-made clothes, not custom-made", meaningAZ: "Hazır paltarlar, sifarişlə deyil", meaningTR: "Hazır alınan, ısmarlama olmayan", example: "He buys everything off the rack." },
    ],
    questions: {
      easy: [
        "How would you describe your personal style?",
        "Do you follow fashion trends? Why or why not?",
        "What is your favourite item of clothing?",
        "How much do you spend on clothes each month?",
        "Do you think what you wear affects how people see you?",
        "What are you wearing today?",
        "Where do you usually buy your clothes?",
        "Do you wear the same style every day?",
        "What colour do you wear most often?",
        "Do you keep old clothes or give them away?",
      ],
      hard: [
        "Is the fashion industry harmful to the environment?",
        "Should we move away from fast fashion? How?",
        "Does fashion reflect a person's identity or just their wealth?",
        "Is it right that fashion models are expected to look a certain way?",
        "How has social media changed the fashion industry?",
        "Should schools and workplaces have a dress code?",
        "Is buying second-hand clothing the future of fashion?",
        "Do people judge others too quickly by appearance?",
        "Should fashion brands show where and how clothes are made?",
        "Is following trends a form of creativity or of pressure?",
      ],
    },
  },
  {
    day: 15,
    topic: "Cartoons & Animation 🎭",
    imageKeywords: [
      "animator drawing tablet computer screen",
      "child watching cartoon tablet happy",
      "voice actor recording studio microphone",
      "colorful cartoon character illustration sketch",
      "parents kids cinema animated film"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Animated", meaning: "Made using drawings or digital images that move", meaningAZ: "Hərəkət edən təsvirlər və ya rəqəmsal şəkillərdən istifadə etməklə hazırlanmışdır", meaningTR: "Hareket eden çizim ya da dijital görüntülerle yapılmış", example: "The animated film won several awards." },
      { word: "Character", meaning: "A person or figure in a story", meaningAZ: "Hekayədəki şəxs və ya fiqur", meaningTR: "Bir hikâyedeki kişi ya da figür", example: "My favourite character is Shrek." },
      { word: "Nostalgia", meaning: "A warm feeling when remembering the past", meaningAZ: "Keçmişi xatırlayanda isti bir hiss", meaningTR: "Geçmişi anarken duyulan tatlı his", example: "Old cartoons bring me nostalgia." },
      { word: "Voiceover", meaning: "A recorded voice giving a character sound", meaningAZ: "Bir xarakter səsi verən qeydə alınmış səs", meaningTR: "Bir karaktere ses veren kayıt, seslendirme", example: "He did the voiceover for the main character." },
      { word: "Storyline", meaning: "The main plot or story", meaningAZ: "Əsas süjet və ya hekayə", meaningTR: "Ana olay örgüsü", example: "The storyline was creative and funny." },
      { word: "Villain", meaning: "The bad character in a story", meaningAZ: "Hekayədəki mənfi qəhrəman", meaningTR: "Hikâyedeki kötü karakter", example: "The villain is more interesting than the hero." },
      { word: "Dubbed", meaning: "With the voices replaced in another language", meaningAZ: "Səsləri başqa dilə dəyişdirilmiş, dublyaj olunmuş", meaningTR: "Sesleri başka dile çevrilmiş, dublajlı", example: "I watched it dubbed as a child." },
      { word: "Frame", meaning: "One single picture of an animation", meaningAZ: "Animasiyanın bir kadrı", meaningTR: "Animasyonun tek bir karesi", example: "Every frame was drawn by hand." },
    ],
    idioms: [
      { phrase: "Larger than life", meaning: "Very dramatic or impressive", meaningAZ: "Çox dramatik və ya təsir edici", meaningTR: "Çok çarpıcı ve abartılı", example: "Cartoon characters are often larger than life." },
      { phrase: "Come to life", meaning: "To appear real or exciting", meaningAZ: "Həqiqi və ya həyəcanlı görünmək üçün", meaningTR: "Canlanmak, gerçekmiş gibi olmak", example: "The animation made the story come to life." },
      { phrase: "Take someone back", meaning: "To remind someone of the past", meaningAZ: "Keçmişi kiməsə xatırlatmaq", meaningTR: "Birine geçmişi hatırlatmak", example: "That cartoon takes me back to my childhood." },
    ],
    questions: {
      easy: [
        "What was your favourite cartoon as a child?",
        "Do you still watch animated films or series? Which ones?",
        "Who is your favourite animated character?",
        "What do you think makes a cartoon funny?",
        "Have you ever watched a cartoon in English?",
        "Did you watch cartoons in the morning as a child?",
        "What cartoon character are you most like?",
        "Do you know any cartoons from other countries?",
        "Do children in your family watch cartoons now?",
        "What cartoon song do you still remember?",
      ],
      hard: [
        "Are modern cartoons better or worse than older ones? Why?",
        "Can animated films teach important life lessons? Give examples.",
        "Is it strange for adults to enjoy cartoons? Discuss.",
        "How do cartoons reflect society's values and problems?",
        "Should cartoons always have a positive message for children?",
        "Can animation tell serious stories better than live action?",
        "Should cartoons show difficult topics like loss or illness?",
        "Do cartoon characters influence how children see gender roles?",
        "Is AI-made animation a threat to real animators?",
        "Why do some cartoons stay popular for generations?",
      ],
    },
  },
  {
    day: 16,
    topic: "Fear & Phobias 😱",
    imageKeywords: [
      "person covering eyes scary movie",
      "fear of heights looking down tall building",
      "spider web close up scary",
      "person speaking public audience nervous",
      "scared face haunted house dark"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Phobia", meaning: "An extreme fear of something specific", meaningAZ: "Xüsusi bir şeydən həddindən artıq qorxu", meaningTR: "Belirli bir şeye duyulan aşırı korku, fobi", example: "She has a phobia of spiders." },
      { word: "Anxiety", meaning: "A feeling of worry or nervousness", meaningAZ: "Narahatlıq və ya əsəbilik hissi", meaningTR: "Endişe ve gerginlik hâli, kaygı", example: "He experiences anxiety in crowded places." },
      { word: "Trigger", meaning: "Something that causes a strong reaction", meaningAZ: "Güclü reaksiyaya səbəb olan bir şey", meaningTR: "Güçlü bir tepkiyi başlatan şey", example: "Loud noises are a trigger for his anxiety." },
      { word: "Irrational", meaning: "Not based on logic or reason", meaningAZ: "Məntiq və ağıl əsasında deyil", meaningTR: "Mantığa dayanmayan", example: "He knows his fear of buttons is irrational." },
      { word: "Overcome", meaning: "To successfully deal with a difficulty", meaningAZ: "Bir çətinliyin öhdəsindən uğurla gəlmək", meaningTR: "Bir zorluğun üstesinden gelmek", example: "She overcame her fear of flying." },
      { word: "Panic attack", meaning: "A sudden wave of intense fear", meaningAZ: "Qəfil gələn şiddətli qorxu dalğası", meaningTR: "Aniden gelen yoğun korku dalgası", example: "She had a panic attack in the lift." },
      { word: "Nightmare", meaning: "A frightening dream", meaningAZ: "Qorxulu yuxu, kabus", meaningTR: "Korkunç rüya, kâbus", example: "The same nightmare came back for years." },
      { word: "Reassure", meaning: "To make someone feel less worried", meaningAZ: "Kiminsə narahatlığını azaltmaq", meaningTR: "Birinin endişesini azaltmak", example: "He reassured her it was normal." },
    ],
    idioms: [
      { phrase: "Scared stiff", meaning: "Extremely frightened", meaningAZ: "Son dərəcə qorxulu", meaningTR: "Korkudan donup kalmak", example: "I was scared stiff during the horror film." },
      { phrase: "Face your fears", meaning: "To confront what frightens you", meaningAZ: "Sizi qorxudan şeylə qarşılaşmaq üçün", meaningTR: "Korkularınla yüzleşmek", example: "She decided to face her fears and travel alone." },
      { phrase: "Get cold feet", meaning: "To become nervous before doing something", meaningAZ: "Bir şey etməzdən əvvəl əsəbləşmək", meaningTR: "Son anda cesaretini yitirmek", example: "He got cold feet before the presentation." },
    ],
    questions: {
      easy: [
        "What are you afraid of?",
        "Have you ever faced a fear? What happened?",
        "Do you enjoy scary films? Why or why not?",
        "What scared you most as a child?",
        "Does anyone in your family have a funny fear?",
        "Are you afraid of the dark?",
        "How do you feel about speaking in front of people?",
        "What do you do when you feel nervous?",
        "Are you afraid of any animal or insect?",
        "Do you like heights?",
      ],
      hard: [
        "Is fear ever a useful emotion? Explain.",
        "How can phobias negatively affect a person's life?",
        "Should people try to overcome their fears or accept them?",
        "Why do some people enjoy being scared, like on rollercoasters?",
        "Can social media create new fears in young people?",
        "Where does the fear of failure come from?",
        "Should children be protected from everything that frightens them?",
        "Can facing a fear in public actually make it worse?",
        "Is fear used too often in news and advertising?",
        "How does the fear of other people's opinions limit our choices?",
      ],
    },
  },
  {
    day: 17,
    topic: "Relationships & Friendship ❤️",
    imageKeywords: [
      "friends hugging laughing cafe",
      "couple holding hands walking beach",
      "family hugging reunion airport",
      "friends drinking coffee chatting table",
      "two people arguing hands gesture"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Loyalty", meaning: "Being faithful and supportive to someone", meaningAZ: "Kiməsə sadiq və dəstək olmaq", meaningTR: "Birine sadık ve destek olur şekilde bağlılık", example: "Loyalty is the foundation of true friendship." },
      { word: "Trust", meaning: "A firm belief in someone's reliability", meaningAZ: "Birinin etibarlılığına möhkəm inam", meaningTR: "Birinin güvenilirliğine duyulan inanç", example: "It takes time to build trust." },
      { word: "Conflict", meaning: "A serious disagreement or argument", meaningAZ: "Ciddi fikir ayrılığı və ya mübahisə", meaningTR: "Ciddi anlaşmazlık ya da tartışma", example: "Every relationship has some conflict." },
      { word: "Compromise", meaning: "Reaching an agreement by each giving something", meaningAZ: "Hər bir şey verməklə razılığa gəlmək", meaningTR: "Her iki tarafın da ödün vererek anlaşması", example: "Compromise is essential in any relationship." },
      { word: "Long-distance", meaning: "A relationship maintained despite distance", meaningAZ: "Məsafələrə baxmayaraq davam edən münasibət", meaningTR: "Uzaklığa rağmen sürdürülen ilişki", example: "They maintained a long-distance relationship for years." },
      { word: "Argue", meaning: "To disagree in an angry way", meaningAZ: "Əsəbi şəkildə mübahisə etmək", meaningTR: "Sinirli biçimde tartışmak", example: "We argue about small things." },
      { word: "Make up", meaning: "To become friends again after a fight", meaningAZ: "Dalaşdıqdan sonra barışmaq", meaningTR: "Kavgadan sonra barışmak", example: "They made up the next morning." },
      { word: "Supportive", meaning: "Giving help and encouragement", meaningAZ: "Dəstək və ruhlandırma verən", meaningTR: "Destek ve cesaret veren", example: "My sister is incredibly supportive." },
    ],
    idioms: [
      { phrase: "Hit it off", meaning: "To quickly become friendly with someone", meaningAZ: "Biri ilə tez dost olmaq", meaningTR: "Hemen kaynaşmak, iyi anlaşmak", example: "We hit it off immediately at the party." },
      { phrase: "Stand by someone", meaning: "To support someone through difficulties", meaningAZ: "Çətinliklərdə kimisə dəstəkləmək", meaningTR: "Zor günlerde birinin yanında olmak", example: "She stood by him through everything." },
      { phrase: "Drift apart", meaning: "To gradually lose contact with someone", meaningAZ: "Tədricən kiminləsə əlaqəni kəsmək", meaningTR: "Zamanla birbirinden uzaklaşmak", example: "We drifted apart after school ended." },
    ],
    questions: {
      easy: [
        "How many close friends do you have?",
        "What do you value most in a friend?",
        "How do you usually meet new people?",
        "Do you prefer spending time with family or friends?",
        "Have you ever had an argument with a close friend?",
        "Who was your first friend?",
        "How often do you see your friends?",
        "What do you and your friends do together?",
        "Is it easy for you to say sorry?",
        "Do you keep in touch with old classmates?",
      ],
      hard: [
        "Can men and women truly be just friends? Discuss.",
        "How has social media changed the nature of friendship?",
        "Is it possible to maintain close friendships as you get older?",
        "What makes a relationship healthy or unhealthy?",
        "Should couples share all their passwords? Why or why not?",
        "Is it better to have a few deep friendships or many light ones?",
        "Can a friendship survive when one person becomes very successful?",
        "Should you always tell a friend an uncomfortable truth?",
        "Do online friendships count as real friendships?",
        "How do you know when a relationship is no longer good for you?",
      ],
    },
  },
  {
    day: 18,
    topic: "Sports & Competition 🏆",
    imageKeywords: [
      "football players match stadium",
      "tennis player hitting ball court",
      "runner crossing finish line marathon",
      "swimmer diving pool competition",
      "coach talking team locker room"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Athlete", meaning: "A person trained in sport", meaningAZ: "İdmanla məşğul olan insan", meaningTR: "Sporda yetişmiş kişi, sporcu", example: "She is a professional athlete." },
      { word: "Stamina", meaning: "The ability to keep going for a long time", meaningAZ: "Uzun müddət davam etmək bacarığı", meaningTR: "Uzun süre devam edebilme gücü, dayanıklılık", example: "Running marathons requires great stamina." },
      { word: "Coach", meaning: "A person who trains others", meaningAZ: "Başqalarını öyrədən insan", meaningTR: "Başkalarını çalıştıran kişi, antrenör", example: "His coach pushed him to work harder." },
      { word: "Tournament", meaning: "A series of games to find a winner", meaningAZ: "Qalib tapmaq üçün bir sıra oyunlar", meaningTR: "Kazananı belirlemek için oynanan maç serisi", example: "They won the regional tournament." },
      { word: "Injury", meaning: "Physical damage to the body", meaningAZ: "Bədənə fiziki ziyan", meaningTR: "Vücutta oluşan yaralanma, sakatlık", example: "The injury ended his season early." },
      { word: "Referee", meaning: "The official who enforces the rules of a game", meaningAZ: "Oyunun qaydalarına nəzarət edən hakim", meaningTR: "Oyunun kurallarını uygulayan hakem", example: "The referee missed the foul." },
      { word: "Warm up", meaning: "To prepare your body before sport", meaningAZ: "İdmandan əvvəl bədəni hazırlamaq", meaningTR: "Spordan önce vücudu hazırlamak", example: "Warm up or you will pull a muscle." },
      { word: "Underdog", meaning: "The team or person expected to lose", meaningAZ: "Uduzacağı gözlənilən tərəf", meaningTR: "Kaybetmesi beklenen taraf", example: "Everyone supports the underdog." },
    ],
    idioms: [
      { phrase: "Jump the gun", meaning: "To act too early before it is right", meaningAZ: "Doğrudan əvvəl çox erkən hərəkət etmək", meaningTR: "Vakti gelmeden erken davranmak", example: "Don't jump the gun — wait for the results." },
      { phrase: "Give it your best shot", meaning: "To try as hard as you can", meaningAZ: "Bacardığınız qədər cəhd etmək", meaningTR: "Elinden gelenin en iyisini yapmak", example: "Just give it your best shot." },
      { phrase: "Raise the bar", meaning: "To set a higher standard", meaningAZ: "Daha yüksək standart təyin etmək üçün", meaningTR: "Standardı yükseltmek", example: "The champion raised the bar for everyone." },
    ],
    questions: {
      easy: [
        "What is your favourite sport to watch or play?",
        "Did you play any sports at school?",
        "Do you think sport is important for children?",
        "Who is your favourite sports player?",
        "Have you ever watched a live sports event?",
        "Do you watch football or another sport on TV?",
        "What sport would you like to learn?",
        "Do you exercise with other people or alone?",
        "What is the most popular sport in your country?",
        "Have you ever won a competition?",
      ],
      hard: [
        "Should professional athletes be paid so much money?",
        "Is competition healthy or harmful for children?",
        "Should performance-enhancing drugs be allowed in sport?",
        "How does sport bring nations together?",
        "Is mental strength more important than physical in sport?",
        "Should hosting the Olympics be worth the cost for a country?",
        "Is it fair to separate sports by gender?",
        "How should sport deal with racism among fans?",
        "Do young athletes give up too much of their childhood?",
        "Is losing more useful than winning? Explain.",
      ],
    },
  },
  {
    day: 19,
    topic: "Animals & Pets 🐾",
    imageKeywords: [
      "person walking dog park playing",
      "veterinarian checking cat clinic pet",
      "feeding street animals cat dog",
      "child holding puppy happy",
      "cat sleeping on lap cozy"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Domesticated", meaning: "Adapted to live with humans", meaningAZ: "İnsanlarla yaşamağa uyğunlaşdırılmışdır", meaningTR: "İnsanla yaşamaya alışmış, evcilleştirilmiş", example: "Dogs were domesticated thousands of years ago." },
      { word: "Endangered", meaning: "At risk of becoming extinct", meaningAZ: "Nəsli kəsilmək təhlükəsi altındadır", meaningTR: "Nesli tükenme tehlikesinde olan", example: "Tigers are an endangered species." },
      { word: "Habitat", meaning: "The natural environment of an animal", meaningAZ: "Heyvanların təbii mühiti", meaningTR: "Bir hayvanın doğal yaşam alanı", example: "Deforestation destroys animal habitats." },
      { word: "Veterinarian", meaning: "A doctor for animals", meaningAZ: "Heyvanlar üçün həkim", meaningTR: "Hayvan doktoru, veteriner", example: "She took her cat to the veterinarian." },
      { word: "Predator", meaning: "An animal that hunts other animals", meaningAZ: "Başqa heyvanları ovlayan heyvan", meaningTR: "Başka hayvanları avlayan hayvan", example: "The lion is a top predator." },
      { word: "Stray", meaning: "An animal with no home", meaningAZ: "Evi olmayan sahibsiz heyvan", meaningTR: "Evi olmayan sokak hayvanı", example: "We feed the strays on our street." },
      { word: "Adopt", meaning: "To take an animal into your home", meaningAZ: "Heyvanı evinə götürmək", meaningTR: "Bir hayvanı evine almak", example: "They adopted a dog from the shelter." },
      { word: "Tame", meaning: "Not wild, safe around people", meaningAZ: "Vəhşi olmayan, insana öyrəşmiş", meaningTR: "Vahşi olmayan, insana alışkın", example: "The bird is completely tame." },
    ],
    idioms: [
      { phrase: "Let the cat out of the bag", meaning: "To reveal a secret accidentally", meaningAZ: "Təsadüfən bir sirri açmaq", meaningTR: "Sırrı yanlışlıkla açığa vurmak", example: "He let the cat out of the bag about the surprise party." },
      { phrase: "The elephant in the room", meaning: "An obvious problem nobody wants to discuss", meaningAZ: "Heç kimin müzakirə etmək istəmədiyi açıq bir problem", meaningTR: "Kimsenin konuşmak istemediği apaçık sorun", example: "Job cuts are the elephant in the room." },
      { phrase: "Hold your horses", meaning: "To slow down and be patient", meaningAZ: "Yavaşlamaq və səbirli olmaq", meaningTR: "Acele etme, sabırlı ol", example: "Hold your horses — we're not ready yet." },
    ],
    questions: {
      easy: [
        "Do you have any pets? What are they like?",
        "What is your favourite animal and why?",
        "Would you prefer a dog or a cat?",
        "Have you ever been to a zoo? What did you think?",
        "What animal would you be if you could choose?",
        "Did you have a pet as a child?",
        "What animal is common where you live?",
        "Are you afraid of any animals?",
        "Would you adopt a street animal?",
        "What animal do you find funny?",
      ],
      hard: [
        "Should keeping animals in zoos be banned?",
        "Is it ethical to have exotic animals as pets?",
        "How should governments protect endangered species?",
        "Do animals have the same rights as humans? Discuss.",
        "Should animal testing for medicine or cosmetics be allowed?",
        "Should cities do more to protect street animals?",
        "Is eating meat morally acceptable? Discuss.",
        "Do pets improve their owners' mental health?",
        "Should people need a licence to keep a pet?",
        "How much should we spend on saving one endangered species?",
      ],
    },
  },
  {
    day: 20,
    topic: "Culture & Traditions 🌐",
    imageKeywords: [
      "traditional dance festival colorful costumes",
      "family celebrating holiday dinner table",
      "wedding ceremony traditional dress bride",
      "people praying temple church mosque",
      "cooking traditional food grandmother"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Heritage", meaning: "Traditions and values passed down through generations", meaningAZ: "Ənənələr və dəyərlər nəsildən-nəslə ötürülür", meaningTR: "Kuşaklar boyunca aktarılan gelenek ve değerler", example: "She is proud of her cultural heritage." },
      { word: "Custom", meaning: "A traditional practice or behaviour", meaningAZ: "Ənənəvi təcrübə və ya davranış", meaningTR: "Geleneksel bir uygulama ya da davranış", example: "It is a custom to bring a gift to a wedding." },
      { word: "Ritual", meaning: "A set of actions done in a specific order", meaningAZ: "Müəyyən bir ardıcıllıqla yerinə yetirilən hərəkətlər toplusu", meaningTR: "Belirli bir sırayla yapılan davranışlar dizisi", example: "Morning tea is a daily ritual for her." },
      { word: "Multicultural", meaning: "Including many different cultures", meaningAZ: "Çox müxtəlif mədəniyyətlər daxil olmaqla", meaningTR: "Birçok farklı kültürü içeren", example: "London is a very multicultural city." },
      { word: "Assimilation", meaning: "Adapting to a new culture", meaningAZ: "Yeni mədəniyyətə uyğunlaşma", meaningTR: "Yeni bir kültüre uyum sağlama", example: "Assimilation can be difficult for immigrants." },
      { word: "Folk", meaning: "Belonging to the ordinary people of a place", meaningAZ: "Bir yerin adi xalqına aid olan", meaningTR: "Bir yerin halkına ait olan", example: "She sings old folk songs." },
      { word: "Ancestor", meaning: "A family member from long ago", meaningAZ: "Çox əvvəlki nəsildən olan qohum, əcdad", meaningTR: "Çok önceki kuşaktan akraba, ata", example: "His ancestors came from the mountains." },
      { word: "Superstition", meaning: "A belief that an action brings luck", meaningAZ: "Hansısa hərəkətin uğur gətirdiyinə inam", meaningTR: "Bir davranışın şans getirdiğine inanma", example: "Every family has its own superstitions." },
    ],
    idioms: [
      { phrase: "When in Rome", meaning: "Follow local customs when visiting a place", meaningAZ: "Bir yerə səfər edərkən yerli adətlərə əməl edin", meaningTR: "Gittiğin yerin âdetine uy", example: "When in Rome, do as the Romans do." },
      { phrase: "Old habits die hard", meaning: "Traditional behaviours are difficult to change", meaningAZ: "Ənənəvi davranışları dəyişdirmək çətindir", meaningTR: "Eski alışkanlıklar zor bırakılır", example: "Old habits die hard — he still follows every custom." },
      { phrase: "Pass something down", meaning: "To give traditions to younger generations", meaningAZ: "Gənc nəsillərə ənənələr bəxş etmək", meaningTR: "Gelenekleri gençlere aktarmak", example: "She passed down the recipes to her children." },
    ],
    questions: {
      easy: [
        "What is a tradition you celebrate in your family?",
        "What is the most important festival in your country?",
        "Have you ever tried a tradition from another culture?",
        "What traditional food do you love?",
        "How do people in your country celebrate weddings?",
        "What tradition do you enjoy the most?",
        "How do people greet each other in your country?",
        "What do families usually do at the weekend where you live?",
        "Is there a tradition you find strange?",
        "What music or dance is traditional in your culture?",
      ],
      hard: [
        "How important is it to preserve traditional culture in modern life?",
        "Should immigrants be expected to adopt the culture of their new country?",
        "Is globalisation destroying local cultures?",
        "Which traditions do you think should be abandoned and why?",
        "How can younger generations keep traditions alive?",
        "Can a tradition ever be a good reason to do something harmful?",
        "How do families pass culture on to children born abroad?",
        "Is national identity becoming weaker in a connected world?",
        "Should tourists be allowed to take part in sacred traditions?",
        "What new tradition would you like your country to create?",
      ],
    },
  },
  {
    day: 21,
    topic: "Science & Space 🚀",
    imageKeywords: [
      "telescope looking stars night sky",
      "scientist laboratory microscope experiment",
      "astronaut space suit floating rocket",
      "rocket launch fire sky space",
      "students science class chemistry experiment"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Galaxy", meaning: "A system of millions of stars", meaningAZ: "Milyonlarla ulduzdan ibarət sistem", meaningTR: "Milyonlarca yıldızdan oluşan sistem, galaksi", example: "Our solar system is inside the Milky Way galaxy." },
      { word: "Orbit", meaning: "The curved path of an object around another", meaningAZ: "Bir obyektin digəri ətrafında əyri yolu", meaningTR: "Bir cismin başka bir cismin çevresindeki yörüngesi", example: "The Moon is in orbit around the Earth." },
      { word: "Experiment", meaning: "A scientific test to discover something", meaningAZ: "Nəyisə kəşf etmək üçün elmi sınaq", meaningTR: "Bir şeyi keşfetmek için yapılan bilimsel deney", example: "The experiment produced unexpected results." },
      { word: "Hypothesis", meaning: "An idea tested through experiment", meaningAZ: "Təcrübə yolu ilə sınaqdan keçirilmiş fikir", meaningTR: "Deneyle sınanan varsayım", example: "The hypothesis was proved correct." },
      { word: "Gravity", meaning: "The force that pulls objects toward each other", meaningAZ: "Cisimləri bir-birinə doğru çəkən qüvvə", meaningTR: "Cisimleri birbirine çeken kuvvet, yer çekimi", example: "Gravity keeps us on the Earth." },
      { word: "Telescope", meaning: "A tube used to see distant objects", meaningAZ: "Uzaq cisimləri görmək üçün cihaz, teleskop", meaningTR: "Uzak cisimleri görmeye yarayan alet, teleskop", example: "We saw the rings through a small telescope." },
      { word: "Launch", meaning: "To send a rocket into space", meaningAZ: "Raketi kosmosa buraxmaq", meaningTR: "Bir roketi uzaya fırlatmak", example: "The launch was delayed by wind." },
      { word: "Discovery", meaning: "Finding something for the first time", meaningAZ: "Bir şeyi ilk dəfə tapmaq, kəşf", meaningTR: "Bir şeyi ilk kez bulma, keşif", example: "The discovery changed the textbooks." },
    ],
    idioms: [
      { phrase: "Reach for the stars", meaning: "To aim very high in life", meaningAZ: "Həyatda çox yüksək hədəflər qoymaq", meaningTR: "Hayatta çok yüksek hedefler koymak", example: "She always told her students to reach for the stars." },
      { phrase: "Light-years ahead", meaning: "Far more advanced than others", meaningAZ: "Başqalarından çox daha inkişaf etmiş", meaningTR: "Diğerlerinden kat kat ileride", example: "Their research is light-years ahead of competitors." },
      { phrase: "Rocket science", meaning: "Something very complicated (often said sarcastically)", meaningAZ: "Çox mürəkkəb bir şey (tez-tez istehza ilə deyilir)", meaningTR: "Çok karmaşık iş (çoğu zaman alaycı söylenir)", example: "It's not rocket science — just follow the steps." },
    ],
    questions: {
      easy: [
        "Are you interested in space? What fascinates you about it?",
        "What was the last scientific fact you found interesting?",
        "Would you travel to space if you had the chance?",
        "Do you believe there is life on other planets?",
        "What invention do you think has changed the world the most?",
        "Did you like science at school?",
        "Have you ever looked at the stars at night?",
        "Do you watch science videos or documentaries?",
        "What machine in your home amazes you most?",
        "Would you like to meet an astronaut?",
      ],
      hard: [
        "Should governments spend more money on space exploration?",
        "Is it ethical to send humans to Mars knowing the risks?",
        "How has scientific progress improved daily life?",
        "Do you think science can answer all of life's questions?",
        "Should private companies like SpaceX control space travel?",
        "Should scientists be allowed to edit human genes?",
        "Why do many people no longer trust scientific experts?",
        "Is space exploration a distraction from problems on Earth?",
        "Who should own the resources found on the Moon?",
        "How should science be explained to ordinary people?",
      ],
    },
  },
  {
    day: 22,
    topic: "City vs Countryside 🏙️",
    imageKeywords: [
      "busy city street traffic crowd",
      "peaceful countryside farm village field",
      "subway train commuters morning rush",
      "farmer tractor green field working",
      "city skyline night lights tall buildings"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Urban", meaning: "Relating to a city or town", meaningAZ: "Bir şəhər və ya qəsəbə ilə əlaqəli", meaningTR: "Şehre ya da kasabaya ait", example: "Urban life is fast and convenient." },
      { word: "Rural", meaning: "Relating to the countryside", meaningAZ: "Kəndlə bağlı", meaningTR: "Kırsala ait", example: "She grew up in a rural village." },
      { word: "Infrastructure", meaning: "Basic systems like roads and transport", meaningAZ: "Yollar və nəqliyyat kimi əsas sistemlər", meaningTR: "Yol ve ulaşım gibi temel sistemler, altyapı", example: "The city has excellent infrastructure." },
      { word: "Commute", meaning: "Travelling to and from work regularly", meaningAZ: "Müntəzəm olaraq işə gedib-gəlmək", meaningTR: "İşe düzenli gidiş geliş", example: "His daily commute takes 90 minutes." },
      { word: "Overcrowding", meaning: "Too many people in one place", meaningAZ: "Bir yerdə çox insan", meaningTR: "Bir yerde çok fazla insan olması", example: "Overcrowding is a major urban problem." },
      { word: "Suburb", meaning: "A residential area outside the city centre", meaningAZ: "Şəhər mərkəzindən kənar yaşayış zonası", meaningTR: "Şehir merkezi dışındaki yerleşim bölgesi", example: "They moved to a quiet suburb." },
      { word: "Skyline", meaning: "The shape of a city against the sky", meaningAZ: "Şəhərin göy fonunda görünən silueti", meaningTR: "Şehrin gökyüzüne karşı silüeti", example: "The skyline changed in five years." },
      { word: "Peaceful", meaning: "Quiet and calm", meaningAZ: "Sakit və dinc", meaningTR: "Sessiz ve huzurlu", example: "Mornings there are peaceful." },
    ],
    idioms: [
      { phrase: "Rat race", meaning: "An exhausting, competitive city lifestyle", meaningAZ: "Yorucu, rəqabətli şəhər həyat tərzi", meaningTR: "Yorucu ve rekabetçi şehir yaşamı", example: "He left the rat race to move to the countryside." },
      { phrase: "Put down roots", meaning: "To settle permanently in a place", meaningAZ: "Bir yerdə daimi məskunlaşmaq", meaningTR: "Bir yere kalıcı olarak yerleşmek", example: "They put down roots in a small village." },
      { phrase: "Green space", meaning: "Open natural areas in or near cities", meaningAZ: "Şəhərlərdə və ya yaxınlığında təbii əraziləri açın", meaningTR: "Şehirdeki ya da yakınındaki açık yeşil alanlar", example: "Parks provide important green space." },
    ],
    questions: {
      easy: [
        "Do you live in a city or a rural area?",
        "What do you like most about where you live?",
        "Would you prefer to live in a big city or a quiet village?",
        "What are three good things about city life?",
        "What do you miss when you are away from home?",
        "How long have you lived in your city or village?",
        "Is your area noisy or quiet?",
        "Where do people meet in your neighbourhood?",
        "Do you know your neighbours?",
        "What is missing in the place where you live?",
      ],
      hard: [
        "What are the biggest challenges facing modern cities?",
        "Is countryside life becoming less attractive to young people? Why?",
        "How should governments manage population growth in cities?",
        "Does where you live affect your happiness and opportunities?",
        "Should cities invest more in public transport? Why?",
        "Why do young people leave villages, and can that be reversed?",
        "Are big cities becoming too expensive to live in?",
        "Should remote work push people back to smaller towns?",
        "Does city life make people lonelier?",
        "How can a city grow without losing its character?",
      ],
    },
  },
  {
    day: 23,
    topic: "Books & Reading 📖",
    imageKeywords: [
      "reading book library quiet studying",
      "person reading novel bed lamp",
      "bookstore buying books shelves",
      "reading e-book tablet cafe",
      "child reading book parent bedtime"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Fiction", meaning: "Writing about imaginary events and people", meaningAZ: "Xəyali hadisələr və insanlar haqqında yazmaq", meaningTR: "Hayalî olay ve kişileri anlatan yazın, kurgu", example: "She reads fiction to relax." },
      { word: "Non-fiction", meaning: "Writing about real events or facts", meaningAZ: "Real hadisələr və ya faktlar haqqında yazmaq", meaningTR: "Gerçek olay ve olguları anlatan yazın", example: "He prefers non-fiction about history." },
      { word: "Author", meaning: "A person who writes books", meaningAZ: "Kitab yazan adam", meaningTR: "Kitap yazan kişi, yazar", example: "The author signed copies of his novel." },
      { word: "Narrative", meaning: "A spoken or written account of events", meaningAZ: "Hadisələrin şifahi və ya yazılı izahı", meaningTR: "Olayların sözlü ya da yazılı anlatımı", example: "The narrative was gripping from the first page." },
      { word: "E-book", meaning: "A book read on a digital device", meaningAZ: "Rəqəmsal cihazda oxunan kitab", meaningTR: "Dijital cihazdan okunan kitap", example: "I read e-books on my tablet." },
      { word: "Chapter", meaning: "One numbered part of a book", meaningAZ: "Kitabın nömrələnmiş hissəsi, fəsil", meaningTR: "Kitabın numaralanmış bölümü", example: "I read one chapter a night." },
      { word: "Bookshelf", meaning: "The shelf where books are kept", meaningAZ: "Kitabların saxlandığı rəf", meaningTR: "Kitapların durduğu raf", example: "Her bookshelf says a lot about her." },
      { word: "Page-turner", meaning: "A book too exciting to put down", meaningAZ: "Əlindən qoya bilmədiyin maraqlı kitab", meaningTR: "Elinden bırakamadığın sürükleyici kitap", example: "It is a real page-turner." },
    ],
    idioms: [
      { phrase: "An open book", meaning: "A person who hides nothing", meaningAZ: "Heç nəyi gizlətməyən insan", meaningTR: "Hiçbir şey saklamayan kişi", example: "He's an open book — very honest and transparent." },
      { phrase: "By the book", meaning: "Strictly following rules", meaningAZ: "Qaydalara ciddi əməl edin", meaningTR: "Kurallara harfiyen uyarak", example: "She always does everything by the book." },
      { phrase: "Lose yourself in a book", meaning: "To be completely absorbed in reading", meaningAZ: "Oxumağa tam hopmaq", meaningTR: "Kitaba tamamen dalmak", example: "I love losing myself in a good novel." },
    ],
    questions: {
      easy: [
        "Do you enjoy reading? What do you like to read?",
        "What is the last book you read?",
        "Do you prefer physical books or e-books?",
        "Who is your favourite author?",
        "How often do you read in a week?",
        "Where do you like to read?",
        "Did you read a lot as a child?",
        "Do you finish every book you start?",
        "What book would you recommend to a friend?",
        "Do you prefer stories or real-life books?",
      ],
      hard: [
        "Is reading becoming less popular in the digital age?",
        "Can books change a person's life? Give an example.",
        "Should schools require students to read more classic literature?",
        "Do you think films based on books are usually better or worse?",
        "How does reading in English help someone improve the language?",
        "Should some books be removed from school libraries?",
        "Is listening to an audiobook the same as reading?",
        "Why do people say reading fiction builds empathy?",
        "Will short online content destroy our ability to read long texts?",
        "Should authors be responsible for how readers use their ideas?",
      ],
    },
  },
  {
    day: 24,
    topic: "Language & Communication 🗣️",
    imageKeywords: [
      "people talking different languages speech bubbles",
      "teacher teaching language classroom pointing",
      "tourist asking directions map local",
      "sign language hands interpreting",
      "dictionary translation book study"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Fluency", meaning: "The ability to speak a language smoothly", meaningAZ: "Bir dildə rəvan danışmaq bacarığı", meaningTR: "Bir dili akıcı konuşabilme", example: "She has full fluency in four languages." },
      { word: "Dialect", meaning: "A regional variety of a language", meaningAZ: "Dilin regional müxtəlifliyi", meaningTR: "Bir dilin bölgesel çeşidi, lehçe", example: "He speaks with a strong northern dialect." },
      { word: "Body language", meaning: "Communication through gestures and posture", meaningAZ: "Jestlər və duruş vasitəsilə ünsiyyət", meaningTR: "Jest ve duruşla kurulan iletişim, beden dili", example: "Body language reveals how someone feels." },
      { word: "Bilingual", meaning: "Able to speak two languages", meaningAZ: "İki dildə danışmağı bacarır", meaningTR: "İki dil konuşabilen", example: "Being bilingual is very useful in business." },
      { word: "Slang", meaning: "Informal words used in everyday speech", meaningAZ: "Gündəlik nitqdə istifadə olunan qeyri-rəsmi sözlər", meaningTR: "Günlük konuşmadaki gayriresmî sözcükler, argo", example: "Young people use slang I don't understand." },
      { word: "Accent", meaning: "The way someone pronounces a language", meaningAZ: "Dili tələffüz etmə tərzi, vurğu", meaningTR: "Bir dili telaffuz etme biçimi, aksan", example: "His accent gives him away." },
      { word: "Mispronounce", meaning: "To say a word incorrectly", meaningAZ: "Sözü səhv tələffüz etmək", meaningTR: "Bir kelimeyi yanlış telaffuz etmek", example: "I mispronounced her name twice." },
      { word: "Small talk", meaning: "Light conversation about unimportant things", meaningAZ: "Əhəmiyyətsiz mövzularda yüngül söhbət", meaningTR: "Önemsiz konularda hafif sohbet", example: "Small talk is harder than grammar." },
    ],
    idioms: [
      { phrase: "Speak your mind", meaning: "To say exactly what you think", meaningAZ: "Düşündüyünüzü dəqiq söyləmək üçün", meaningTR: "Düşündüğünü açıkça söylemek", example: "Don't be afraid to speak your mind." },
      { phrase: "Beat around the bush", meaning: "To avoid saying something directly", meaningAZ: "Birbaşa bir şey söyləməmək üçün", meaningTR: "Lafı dolandırmak", example: "Stop beating around the bush and just say it." },
      { phrase: "Get your point across", meaning: "To successfully communicate an idea", meaningAZ: "Bir fikri uğurla çatdırmaq", meaningTR: "Anlatmak istediğini karşıya geçirebilmek", example: "She struggled to get her point across." },
    ],
    questions: {
      easy: [
        "How many languages can you speak?",
        "Why are you learning English?",
        "What is the hardest thing about learning English?",
        "Do you think you communicate better in writing or speaking?",
        "What language would you most like to learn and why?",
        "When did you start learning English?",
        "Do you speak English outside the classroom?",
        "What English word do you find funny?",
        "Are you shy when you speak a new language?",
        "How do you learn new words?",
      ],
      hard: [
        "Is English becoming the world's only important language?",
        "Should everyone learn a second language at school?",
        "How does language shape the way we think?",
        "Is it possible to fully understand a culture without speaking its language?",
        "Will translation technology ever replace human language learners?",
        "Does making mistakes help you learn faster? Explain.",
        "Should small languages be saved even if few people speak them?",
        "Is an accent something to fix or something to keep?",
        "How does body language change the meaning of our words?",
        "Are we communicating more but understanding each other less?",
      ],
    },
  },
  {
    day: 25,
    topic: "Shopping & Consumerism 🛍️",
    imageKeywords: [
      "shopping mall carrying bags happy",
      "cashier scanning items supermarket checkout",
      "online shopping laptop credit card",
      "window shopping looking store display",
      "customer trying shoes shop"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Consumer", meaning: "A person who buys goods or services", meaningAZ: "Mal və ya xidmət alan şəxs", meaningTR: "Mal ya da hizmet satın alan kişi, tüketici", example: "Today's consumers care more about ethics." },
      { word: "Discount", meaning: "A reduction in the price of something", meaningAZ: "Bir şeyin qiymətində azalma", meaningTR: "Bir şeyin fiyatında indirim", example: "She got a 30% discount on the jacket." },
      { word: "Impulse buy", meaning: "A purchase made without planning", meaningAZ: "Planlaşdırmadan edilən alış", meaningTR: "Plansız yapılan alışveriş", example: "That coffee machine was an impulse buy." },
      { word: "Second-hand", meaning: "Already used by someone else", meaningAZ: "Artıq başqası tərəfindən istifadə olunur", meaningTR: "Daha önce başkası tarafından kullanılmış", example: "He buys second-hand books to save money." },
      { word: "Receipt", meaning: "A printed record of a purchase", meaningAZ: "Satınalmanın çap edilmiş qeydi", meaningTR: "Alışverişin basılı kaydı, fiş", example: "Always keep your receipt in case of returns." },
      { word: "Refund", meaning: "Money returned for goods you bring back", meaningAZ: "Geri qaytarılan mal üçün ödənilən pul", meaningTR: "İade edilen mal için geri ödenen para", example: "They gave a refund without arguing." },
      { word: "Queue", meaning: "A line of people waiting to pay", meaningAZ: "Ödəniş üçün gözləyənlərin növbəsi", meaningTR: "Ödeme için bekleyenlerin sırası", example: "The queue reached the door." },
      { word: "Brand new", meaning: "Completely new, never used", meaningAZ: "Tamamilə yeni, heç istifadə olunmamış", meaningTR: "Hiç kullanılmamış, sıfır", example: "It was brand new and still broke." },
    ],
    idioms: [
      { phrase: "Splurge on something", meaning: "To spend a lot of money on a treat", meaningAZ: "Bir müalicəyə çoxlu pul xərcləmək", meaningTR: "Bir keyif için çok para harcamak", example: "I splurged on new trainers this month." },
      { phrase: "Cost an arm and a leg", meaning: "To be very expensive", meaningAZ: "Çox bahalı olmaq", meaningTR: "Çok pahalıya mal olmak", example: "The new phone cost an arm and a leg." },
      { phrase: "Shop around", meaning: "To compare prices before buying", meaningAZ: "Satın almadan əvvəl qiymətləri müqayisə edin", meaningTR: "Almadan önce fiyatları karşılaştırmak", example: "Always shop around before making big purchases." },
    ],
    questions: {
      easy: [
        "Do you enjoy shopping? What do you like to buy?",
        "Do you prefer shopping in stores or online?",
        "What is the most expensive thing you have ever bought?",
        "Do you ever buy things you don't really need?",
        "What is your favourite place to shop?",
        "What did you buy last week?",
        "Do you make a list before shopping?",
        "Do you compare prices before buying?",
        "What shop do you visit most often?",
        "Do you like shopping with other people?",
      ],
      hard: [
        "Has online shopping harmed local businesses?",
        "Is consumerism making us happier or more unhappy?",
        "Should luxury goods be taxed more heavily?",
        "How can people become more mindful consumers?",
        "Is it wrong to spend a lot on fashion or luxury items?",
        "Do advertisements create needs that we never had?",
        "Should shops be closed one day a week? Why or why not?",
        "Is fast delivery worth its human and environmental cost?",
        "How do sales and discounts change our behaviour?",
        "Would you buy less if products lasted twice as long?",
      ],
    },
  },
  {
    day: 26,
    topic: "Dreams & Ambitions 🌟",
    imageKeywords: [
      "person writing goals notebook desk",
      "graduating student looking future happy",
      "entrepreneur standing new business shop",
      "mountain climber reaching peak success",
      "daydreaming thinking future window"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Ambition", meaning: "A strong desire to achieve something", meaningAZ: "Nəyəsə nail olmaq üçün güclü istək", meaningTR: "Bir şeyi başarma yönündeki güçlü istek", example: "His ambition is to become a doctor." },
      { word: "Motivation", meaning: "The reason for doing something", meaningAZ: "Bir şey etmək üçün səbəb", meaningTR: "Bir şeyi yapma nedeni, güdü", example: "What is your motivation for learning English?" },
      { word: "Determination", meaning: "Firmness in completing a goal", meaningAZ: "Məqsədi tamamlamaqda möhkəmlik", meaningTR: "Bir hedefi tamamlamadaki kararlılık", example: "Her determination helped her succeed." },
      { word: "Aspire", meaning: "To want to achieve something great", meaningAZ: "Böyük bir şeyə nail olmaq istəmək", meaningTR: "Büyük bir şeye ulaşmayı istemek", example: "She aspires to work in international politics." },
      { word: "Perseverance", meaning: "Continuing despite difficulties", meaningAZ: "Çətinliklərə baxmayaraq davam edir", meaningTR: "Zorluklara rağmen sürdürme, azim", example: "Perseverance is the key to long-term success." },
      { word: "Goal", meaning: "Something you are trying to achieve", meaningAZ: "Çatmağa çalışdığın hədəf", meaningTR: "Ulaşmaya çalıştığın hedef", example: "Write the goal down or it stays a wish." },
      { word: "Setback", meaning: "Something that delays your progress", meaningAZ: "İrəliləyişi ləngidən uğursuzluq", meaningTR: "İlerlemeyi geciktiren aksilik", example: "The rejection was a real setback." },
      { word: "Role model", meaning: "A person whose example you follow", meaningAZ: "Nümunə götürdüyün adam", meaningTR: "Örnek aldığın kişi", example: "My first boss became my role model." },
    ],
    idioms: [
      { phrase: "Aim high", meaning: "To set ambitious goals", meaningAZ: "İddialı məqsədlər qoymaq", meaningTR: "Yüksek hedefler koymak", example: "Always aim high and don't limit yourself." },
      { phrase: "Chase your dreams", meaning: "To pursue what you truly want", meaningAZ: "Həqiqətən istədiyinizi həyata keçirmək üçün", meaningTR: "Gerçekten istediğinin peşinden gitmek", example: "She left her job to chase her dreams." },
      { phrase: "Go after something", meaning: "To actively pursue a goal", meaningAZ: "Bir məqsədə fəal şəkildə nail olmaq", meaningTR: "Bir hedefin ardına düşmek", example: "If you want it, go after it." },
    ],
    questions: {
      easy: [
        "What is your biggest dream in life?",
        "What did you want to be when you were a child?",
        "What is one goal you want to achieve this year?",
        "Who inspires you to work hard?",
        "What is your biggest achievement so far?",
        "What do you want to do next year?",
        "What small goal did you finish recently?",
        "Do you write your goals down?",
        "What do you do when you feel lazy?",
        "Who supports your dreams the most?",
      ],
      hard: [
        "Is it better to have realistic goals or dream big?",
        "How much does luck play a role in achieving success?",
        "Do social pressures influence people's ambitions?",
        "Can ambition be harmful? When?",
        "What advice would you give to someone who has lost motivation?",
        "Should you follow your passion or build a stable life first?",
        "How do you deal with a dream that did not come true?",
        "Do parents push their own dreams onto their children?",
        "Is comparing your progress with others ever helpful?",
        "What does success actually mean to you?",
      ],
    },
  },
  {
    day: 27,
    topic: "History & Past Events 🏛️",
    imageKeywords: [
      "museum looking ancient artifacts history",
      "archaeologist digging ruins ancient city",
      "old historical photograph black and white",
      "tourists visiting ancient monument ruins",
      "teacher history class map world"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Revolution", meaning: "A major change in government or society", meaningAZ: "Hökumətdə və ya cəmiyyətdə böyük dəyişiklik", meaningTR: "Yönetimde ya da toplumda büyük değişim, devrim", example: "The French Revolution changed Europe forever." },
      { word: "Era", meaning: "A long period of time in history", meaningAZ: "Tarixdə uzun müddət", meaningTR: "Tarihte uzun bir dönem, çağ", example: "The Victorian era lasted over 60 years." },
      { word: "Empire", meaning: "A large group of states ruled by one power", meaningAZ: "Bir güc tərəfindən idarə olunan böyük dövlətlər qrupu", meaningTR: "Tek bir gücün yönettiği büyük devletler bütünü, imparatorluk", example: "The Roman Empire was vast and powerful." },
      { word: "Artifact", meaning: "An object from a past period", meaningAZ: "Keçmiş dövrə aid obyekt", meaningTR: "Geçmiş bir döneme ait nesne", example: "The museum displayed ancient artifacts." },
      { word: "Colonisation", meaning: "Taking control of another country or territory", meaningAZ: "Başqa bir ölkəyə və ya əraziyə nəzarət etmək", meaningTR: "Başka bir ülkeyi denetim altına alma, sömürgeleştirme", example: "Colonisation had lasting effects worldwide." },
      { word: "Ruins", meaning: "What remains of an old building", meaningAZ: "Köhnə tikilidən qalan xarabalıq", meaningTR: "Eski bir yapıdan kalan harabe", example: "The ruins are two hours from the city." },
      { word: "Ancient", meaning: "From a very long time ago", meaningAZ: "Çox qədim dövrə aid", meaningTR: "Çok eski çağlara ait", example: "The ancient walls are still standing." },
      { word: "Eyewitness account", meaning: "A description by someone who was there", meaningAZ: "Hadisəni görən şəxsin danışdığı", meaningTR: "Olayı gören kişinin anlatımı", example: "The museum plays eyewitness accounts." },
    ],
    idioms: [
      { phrase: "Make history", meaning: "To do something important for the first time", meaningAZ: "İlk dəfə vacib bir şey etmək", meaningTR: "İlk kez önemli bir şey yapmak, tarihe geçmek", example: "She made history as the first woman to lead the team." },
      { phrase: "A blast from the past", meaning: "Something that reminds you of an earlier time", meaningAZ: "Əvvəlki vaxtı xatırladan bir şey", meaningTR: "Geçmişi hatırlatan şey", example: "That song is a real blast from the past." },
      { phrase: "Go down in history", meaning: "To be remembered for a long time", meaningAZ: "Uzun müddət xatırlanmaq üçün", meaningTR: "Uzun süre hatırlanmak, tarihe geçmek", example: "That speech will go down in history." },
    ],
    questions: {
      easy: [
        "What is your favourite period in history?",
        "Have you visited any historical places?",
        "Who is a historical figure you admire?",
        "Do you enjoy watching historical films or documentaries?",
        "What event in history do you find most interesting?",
        "What did you learn about your country's history at school?",
        "Do you know a story about your grandparents' life?",
        "Have you seen an old photo that surprised you?",
        "Is there a museum you would like to visit?",
        "What century would you like to see for one day?",
      ],
      hard: [
        "Should countries apologise for historical wrongs?",
        "How does understanding history help us today?",
        "Do we learn enough history in schools?",
        "Is it possible to view history objectively?",
        "How should nations deal with controversial historical monuments?",
        "Who decides which version of history is taught?",
        "Do people repeat the mistakes of the past? Give examples.",
        "Should old buildings be protected even if they block development?",
        "How does a nation heal after a painful period in its history?",
        "Can we judge people of the past by today's values?",
      ],
    },
  },
  {
    day: 28,
    topic: "Future & Predictions 🔮",
    imageKeywords: [
      "futuristic city flying cars concept",
      "robot helping human artificial intelligence",
      "vr headset virtual world future",
      "hologram projection future technology",
      "future space colony planet concept"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Innovation", meaning: "A new idea, method, or product", meaningAZ: "Yeni ideya, üsul və ya məhsul", meaningTR: "Yeni bir fikir, yöntem ya da ürün, yenilik", example: "Innovation drives the tech industry." },
      { word: "Forecast", meaning: "A prediction about the future", meaningAZ: "Gələcəklə bağlı proqnoz", meaningTR: "Gelecekle ilgili tahmin", example: "The weather forecast says rain tomorrow." },
      { word: "Sustainable", meaning: "Able to continue without causing harm", meaningAZ: "Zərər vermədən davam edə bilir", meaningTR: "Zarar vermeden sürdürülebilen", example: "We need sustainable solutions for energy." },
      { word: "Utopia", meaning: "An imagined perfect society", meaningAZ: "Təsəvvür edilən mükəmməl cəmiyyət", meaningTR: "Hayal edilen kusursuz toplum", example: "Some believe technology will create a utopia." },
      { word: "Disruption", meaning: "A major change that alters how things work", meaningAZ: "İşlərin necə işlədiyini dəyişdirən əsas dəyişiklik", meaningTR: "İşleyişi kökten değiştiren büyük değişim", example: "AI caused disruption in many industries." },
      { word: "Prediction", meaning: "A statement about what will happen", meaningAZ: "Baş verəcəklər barədə fikir, proqnoz", meaningTR: "Olacaklar hakkında söylenen söz, öngörü", example: "His prediction was wrong by ten years." },
      { word: "Generation gap", meaning: "The difference in views between ages", meaningAZ: "Nəsillər arasındakı baxış fərqi", meaningTR: "Kuşaklar arasındaki görüş farkı", example: "The generation gap shows up at dinner." },
      { word: "Obsolete", meaning: "No longer used because something newer exists", meaningAZ: "Yenisi çıxdığı üçün artıq işlənməyən", meaningTR: "Yenisi çıktığı için artık kullanılmayan", example: "That format is obsolete." },
    ],
    idioms: [
      { phrase: "Crystal ball", meaning: "A way to predict the future (often impossible)", meaningAZ: "Gələcəyi proqnozlaşdırmağın bir yolu (çox vaxt mümkün deyil)", meaningTR: "Geleceği görme aracı (çoğu zaman imkânsız)", example: "I don't have a crystal ball, but I think it will succeed." },
      { phrase: "Shape the future", meaning: "To influence what happens next", meaningAZ: "Sonrakılara təsir etmək", meaningTR: "Bundan sonrasını etkilemek", example: "Young people will shape the future." },
      { phrase: "A matter of time", meaning: "Something that will definitely happen eventually", meaningAZ: "Sonda mütləq baş verəcək bir şey", meaningTR: "Er ya da geç mutlaka olacak şey", example: "It's only a matter of time before everything goes digital." },
    ],
    questions: {
      easy: [
        "Where do you see yourself in five years?",
        "What do you think the world will look like in 2050?",
        "Would you like to live on another planet?",
        "What invention do you hope will exist in the future?",
        "Are you optimistic or pessimistic about the future?",
        "What do you hope will change in your city?",
        "Do you make plans or decide day by day?",
        "What job do you think will disappear soon?",
        "How do you think shopping will look in 20 years?",
        "What would you like to learn in the future?",
      ],
      hard: [
        "Will humans ever live on Mars? Should we try?",
        "How will climate change affect the world in 50 years?",
        "Is technological progress always a good thing?",
        "Will AI ever replace teachers, doctors, or lawyers?",
        "What is the biggest challenge humanity will face in the future?",
        "Should we let machines make important decisions about people?",
        "Will future generations live better or worse than us?",
        "How should countries prepare for jobs that do not exist yet?",
        "Is it dangerous to be too optimistic about the future?",
        "If you could send one message to the year 2100, what would it say?",
      ],
    },
  },
  {
    day: 29,
    topic: "Family & Home 🏡",
    imageKeywords: [
      "family dinner table together home",
      "grandparents playing with grandchildren",
      "cozy living room family evening",
      "parents helping children homework",
      "siblings cooking kitchen laughing"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Sibling", meaning: "A brother or a sister", meaningAZ: "Bacı və ya qardaş", meaningTR: "Erkek ya da kız kardeş", example: "I have three siblings, all older than me." },
      { word: "Upbringing", meaning: "The way a child is raised by parents", meaningAZ: "Uşağın valideynlər tərəfindən böyüdülmə tərzi", meaningTR: "Bir çocuğun ailesi tarafından yetiştirilme biçimi", example: "Her strict upbringing made her very disciplined." },
      { word: "Household", meaning: "All the people living together in one home", meaningAZ: "Bir evdə birlikdə yaşayan hamı", meaningTR: "Aynı evde yaşayan herkes, hane", example: "In our household, everyone shares the chores." },
      { word: "Relative", meaning: "A member of your extended family", meaningAZ: "Geniş ailənizin bir üzvü (qohum)", meaningTR: "Geniş aileden bir kişi, akraba", example: "All our relatives come over for the holidays." },
      { word: "Bond", meaning: "A close emotional connection", meaningAZ: "Yaxın emosional bağ", meaningTR: "Yakın duygusal bağ", example: "The bond between the twins is very strong." },
      { word: "Chores", meaning: "Regular tasks done at home", meaningAZ: "Evdə müntəzəm görülən işlər", meaningTR: "Evde düzenli yapılan işler", example: "The chores are shared on a list." },
      { word: "Spoil", meaning: "To give a child too much", meaningAZ: "Uşağa həddən artıq nazı ilə oynamaq", meaningTR: "Bir çocuğu fazla şımartmak", example: "Grandparents are allowed to spoil them." },
      { word: "Family tree", meaning: "A drawing of who is related to whom", meaningAZ: "Kimin kimlə qohum olduğunu göstərən sxem, soy ağacı", meaningTR: "Kimin kiminle akraba olduğunu gösteren şema, soy ağacı", example: "We built a family tree with the children." },
    ],
    idioms: [
      { phrase: "The apple doesn't fall far from the tree", meaning: "Children resemble their parents", meaningAZ: "Uşaqlar valideynlərinə oxşayır", meaningTR: "Armut dibine düşer", example: "He's stubborn like his dad — the apple doesn't fall far from the tree." },
      { phrase: "Under one roof", meaning: "Living together in the same home", meaningAZ: "Eyni evdə birlikdə yaşamaq", meaningTR: "Aynı evde birlikte yaşamak", example: "Three generations live under one roof in their house." },
      { phrase: "Flesh and blood", meaning: "A close family member", meaningAZ: "Yaxın ailə üzvü (öz qanından)", meaningTR: "Çok yakın aile bireyi", example: "I have to help him — he's my own flesh and blood." },
    ],
    questions: {
      easy: [
        "How many people are there in your family?",
        "Who are you closest to in your family?",
        "What do you usually do together at home?",
        "Do you prefer a big family or a small family?",
        "What is your favourite room in your home and why?",
        "Who does the cooking in your home?",
        "Do you live near your relatives?",
        "What do you do together on special days?",
        "Do you help with housework?",
        "What makes a house feel like a home?",
      ],
      hard: [
        "How has the idea of 'family' changed over the last 50 years?",
        "Should adult children take care of their elderly parents at home?",
        "Is it better to grow up with siblings or as an only child? Why?",
        "How does the home environment shape a person's character?",
        "Do you think living with extended family is a good idea? Discuss.",
        "Should parents be strict or friendly with their children?",
        "At what age should young people leave the family home?",
        "How do you keep family peace when opinions are very different?",
        "Is it fair that housework is often unequally shared?",
        "How much should family influence big life decisions?",
      ],
    },
  },
  {
    day: 30,
    topic: "Holidays & Celebrations 🎉",
    imageKeywords: [
      "people celebrating festival colorful lights",
      "birthday party friends cake candles",
      "traditional wedding celebration dance",
      "new year fireworks crowd night",
      "family holiday gift giving table"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Festivity", meaning: "A joyful celebration or event", meaningAZ: "Sevincli bayram və ya tədbir", meaningTR: "Neşeli bir kutlama ya da etkinlik", example: "The whole town joined the festivities." },
      { word: "Tradition", meaning: "A custom passed down over time", meaningAZ: "Zamanla ötürülən adət-ənənə", meaningTR: "Zamanla aktarılan âdet, gelenek", example: "Lighting candles is a family tradition for us." },
      { word: "Gathering", meaning: "A meeting of people, often social", meaningAZ: "İnsanların toplantısı (çox vaxt sosial)", meaningTR: "İnsanların bir araya gelmesi, toplantı", example: "We had a big family gathering for the holiday." },
      { word: "Feast", meaning: "A large, special meal", meaningAZ: "Böyük, xüsusi yemək (ziyafət)", meaningTR: "Büyük ve özel bir yemek, ziyafet", example: "Grandma prepared a feast for everyone." },
      { word: "Anniversary", meaning: "The yearly date of a past event", meaningAZ: "Keçmiş bir hadisənin illik tarixi", meaningTR: "Geçmiş bir olayın yıl dönümü", example: "They celebrated their tenth wedding anniversary." },
      { word: "Decorate", meaning: "To make a place look festive", meaningAZ: "Bir yeri bayram görkəminə salmaq", meaningTR: "Bir yeri bayram havasına sokmak, süslemek", example: "We decorate the house every December." },
      { word: "Fireworks", meaning: "Explosions of colour in the night sky", meaningAZ: "Gecə səmasındakı rəngli atəşfəşanlıq", meaningTR: "Gece göğündeki renkli havai fişekler", example: "The fireworks lasted ten minutes." },
      { word: "Leftovers", meaning: "Food remaining after a celebration", meaningAZ: "Bayramdan sonra qalan yemək", meaningTR: "Kutlamadan sonra artan yemek", example: "We ate leftovers for three days." },
    ],
    idioms: [
      { phrase: "Paint the town red", meaning: "To go out and celebrate energetically", meaningAZ: "Çölə çıxıb coşğun şəkildə əylənmək", meaningTR: "Dışarı çıkıp coşkuyla eğlenmek", example: "After the exams, we painted the town red." },
      { phrase: "Ring in the new year", meaning: "To celebrate the start of the new year", meaningAZ: "Yeni ili qarşılamaq / bayram etmək", meaningTR: "Yeni yılı kutlamak", example: "We rang in the new year with fireworks." },
      { phrase: "The more the merrier", meaning: "More people make it more fun", meaningAZ: "Nə qədər çox olsa, o qədər əyləncəli", meaningTR: "Ne kadar çok kişi olursa o kadar iyi", example: "Invite your friends too — the more the merrier!" },
    ],
    questions: {
      easy: [
        "What is your favourite holiday and why?",
        "How do you usually celebrate your birthday?",
        "What special food do you eat during celebrations?",
        "Do you prefer big parties or small gatherings?",
        "What was the best celebration you have ever been to?",
        "When is the next holiday in your country?",
        "Do you give presents or prefer to receive them?",
        "Who organises the celebrations in your family?",
        "What do you wear on special days?",
        "Do you decorate your home for holidays?",
      ],
      hard: [
        "How do celebrations bring a community closer together?",
        "Have holidays become too commercial these days? Discuss.",
        "Why is it important to keep cultural traditions alive?",
        "Should new global holidays be created? Which one would you add?",
        "How do the holidays a country celebrates reflect its values?",
        "Should workers be paid more for working on public holidays?",
        "Do we celebrate the right things as a society?",
        "Is it acceptable to skip a family celebration? When?",
        "How do celebrations change when people move abroad?",
        "Should countries have fewer but longer public holidays?",
      ],
    },
  },
  {
    day: 31,
    topic: "Neighbours & Community 🏘️",
    imageKeywords: [
      "neighbours talking over fence",
      "community street party",
      "elderly man balcony watching street",
      "people carrying furniture into building",
      "children playing in courtyard"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Neighbourhood", meaning: "The area around where you live", meaningAZ: "Yaşadığın yerin ətrafındakı ərazi", meaningTR: "Oturduğunuz yerin çevresindeki bölge", example: "Our neighbourhood is quiet at night." },
      { word: "Tenant", meaning: "Someone who rents a home from an owner", meaningAZ: "Evi sahibindən kirayə götürən adam", meaningTR: "Bir evi sahibinden kiralayan kişi", example: "The new tenant moved in last week." },
      { word: "Landlord", meaning: "The person who owns the home you rent", meaningAZ: "Kirayə götürdüyün evin sahibi", meaningTR: "Kiraladığınız evin sahibi", example: "The landlord fixed the heating in a day." },
      { word: "Courtyard", meaning: "An open space surrounded by buildings", meaningAZ: "Binalarla əhatə olunmuş açıq sahə", meaningTR: "Binalarla çevrili açık alan", example: "The children play football in the courtyard." },
      { word: "Noise complaint", meaning: "A report that someone is being too loud", meaningAZ: "Kiminsə çox səs-küy saldığına dair şikayət", meaningTR: "Birinin çok gürültü yaptığına dair şikâyet", example: "They got a noise complaint after midnight." },
      { word: "Look after", meaning: "To take care of something or someone", meaningAZ: "Bir şeyə və ya kiməsə qulluq etmək", meaningTR: "Bir şeye ya da birine bakmak", example: "Our neighbour looks after our cat when we travel." },
      { word: "Get along", meaning: "To have a friendly relationship", meaningAZ: "Yola getmək, mehriban münasibətdə olmaq", meaningTR: "İyi geçinmek", example: "We get along with everyone on our floor." },
      { word: "Community", meaning: "A group of people who live in the same place", meaningAZ: "Eyni yerdə yaşayan insanlar qrupu", meaningTR: "Aynı yerde yaşayan insan topluluğu", example: "The whole community helped after the flood." },
    ],
    idioms: [
      { phrase: "The walls have ears", meaning: "Someone may be listening", meaningAZ: "Divarın da qulağı var — kimsə eşidə bilər", meaningTR: "Duvarın kulağı var — biri dinliyor olabilir", example: "Speak quietly here, the walls have ears." },
      { phrase: "Keep yourself to yourself", meaning: "To stay private and not mix with others", meaningAZ: "Öz işinlə məşğul olmaq, qarışmamaq", meaningTR: "Kendi hâlinde kalmak, karışmamak", example: "He keeps himself to himself, we rarely see him." },
      { phrase: "Lend a hand", meaning: "To help someone", meaningAZ: "Kömək etmək, əl tutmaq", meaningTR: "Yardım etmek, el uzatmak", example: "Everyone lent a hand when they moved in." },
    ],
    questions: {
      easy: [
        "Do you know your neighbours' names?",
        "What is the best thing about where you live?",
        "Is your street noisy or quiet?",
        "Have you ever asked a neighbour for help?",
        "Do people in your building greet each other?",
        "What do children do outside in your area?",
        "Would you rather live in a house or a flat? Why?",
        "How long have you lived in your neighbourhood?",
        "Is there a shop near you that you go to often?",
        "What would make your street a better place?",
      ],
      hard: [
        "What turns a group of neighbours into a real community?",
        "Should people have the right to complain about a neighbour's noise? Where is the line?",
        "Has city life made people care less about their neighbours?",
        "Is it a neighbour's business if something looks wrong in the flat next door?",
        "Should a building's residents be forced to pay for shared repairs?",
        "Do online neighbourhood groups bring people together or create conflict?",
        "How much should you help a neighbour before it becomes too much?",
        "Are gated communities good or bad for a city?",
        "Should older people be able to stay in their homes with community support instead of care homes?",
        "What responsibility do you have for a stranger who lives on your street?",
      ],
    },
  },
  {
    day: 32,
    topic: "Weather & Seasons 🌦️",
    imageKeywords: [
      "person running through heavy rain",
      "snow covered street morning light",
      "storm clouds over field",
      "people sheltering under umbrellas",
      "sunlight through autumn leaves"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Downpour", meaning: "A sudden heavy rain", meaningAZ: "Qəfil güclü yağış", meaningTR: "Ani ve şiddetli yağmur", example: "We got caught in a downpour on the way home." },
      { word: "Drizzle", meaning: "Light, fine rain", meaningAZ: "Narın, yüngül yağış", meaningTR: "Hafif, ince yağmur", example: "It was only a drizzle, so we kept walking." },
      { word: "Heatwave", meaning: "A long period of very hot weather", meaningAZ: "Uzun sürən şiddətli isti dövr", meaningTR: "Uzun süren aşırı sıcak dönem", example: "The heatwave lasted two weeks." },
      { word: "Forecast", meaning: "A prediction of future weather", meaningAZ: "Hava proqnozu", meaningTR: "Hava tahmini", example: "The forecast says snow on Friday." },
      { word: "Humid", meaning: "Air that feels wet and heavy", meaningAZ: "Rütubətli, ağır hava", meaningTR: "Nemli ve ağır hava", example: "August here is hot and humid." },
      { word: "Freezing", meaning: "Extremely cold", meaningAZ: "Dondurucu soyuq", meaningTR: "Dondurucu soğuk", example: "It was freezing on the balcony." },
      { word: "Breeze", meaning: "A light, pleasant wind", meaningAZ: "Yüngül, xoş külək", meaningTR: "Hafif, hoş rüzgâr", example: "There was a breeze off the sea." },
      { word: "Puddle", meaning: "A small pool of water on the ground", meaningAZ: "Yerdə yığılan kiçik su gölməçəsi", meaningTR: "Yerde biriken küçük su birikintisi", example: "The child jumped in every puddle." },
    ],
    idioms: [
      { phrase: "Under the weather", meaning: "Feeling slightly ill", meaningAZ: "Bir az xəstə hiss etmək", meaningTR: "Kendini biraz hasta hissetmek", example: "I'm a bit under the weather today." },
      { phrase: "Come rain or shine", meaning: "Whatever happens", meaningAZ: "Nə olursa olsun", meaningTR: "Ne olursa olsun", example: "He walks the dog come rain or shine." },
      { phrase: "A storm in a teacup", meaning: "A lot of anger about something small", meaningAZ: "Kiçik şeyə görə qopan böyük səs-küy", meaningTR: "Küçük bir şey için kopan büyük gürültü", example: "The argument was a storm in a teacup." },
    ],
    questions: {
      easy: [
        "What is your favourite season and why?",
        "What do you do on a rainy day?",
        "Do you check the weather before you go out?",
        "What is the weather like today where you are?",
        "Do you prefer hot weather or cold weather?",
        "What do you wear when it is very cold?",
        "Have you ever been caught in heavy rain?",
        "Does the weather change your mood?",
        "What is the best month in your country?",
        "Do you like snow? Why or why not?",
      ],
      hard: [
        "How much does the weather really affect how people feel and behave?",
        "Should cities be redesigned for hotter summers?",
        "Is it fair that some countries suffer most from weather they did not cause?",
        "Would you move to another country for a better climate?",
        "How should a city prepare for a flood that comes once in fifty years?",
        "Do weather forecasts make people more prepared or more anxious?",
        "Should outdoor workers be sent home during a heatwave, even if they lose pay?",
        "Has air conditioning changed how societies live?",
        "Do seasons shape a nation's character, or is that just a story we tell?",
        "What would you miss most if your country had only one season?",
      ],
    },
  },
  {
    day: 33,
    topic: "Traffic & Commuting 🚦",
    imageKeywords: [
      "crowded metro carriage morning",
      "driver stuck in traffic jam",
      "cyclist weaving through cars",
      "bus stop in the rain",
      "empty road at dawn"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Rush hour", meaning: "The busiest travel time of the day", meaningAZ: "Günün ən sıx nəqliyyat saatı", meaningTR: "Günün en yoğun trafik saati", example: "Avoid the metro at rush hour." },
      { word: "Commute", meaning: "The regular journey to work or school", meaningAZ: "İşə və ya məktəbə gündəlik gediş-gəliş", meaningTR: "İşe ya da okula düzenli gidiş geliş", example: "My commute takes forty minutes." },
      { word: "Traffic jam", meaning: "A long line of cars that cannot move", meaningAZ: "Tıxac, hərəkət edə bilməyən uzun maşın sırası", meaningTR: "Trafik sıkışıklığı", example: "We sat in a traffic jam for an hour." },
      { word: "Pedestrian", meaning: "A person walking in the street", meaningAZ: "Piyada", meaningTR: "Yaya", example: "The driver stopped for a pedestrian." },
      { word: "Fare", meaning: "The price of a journey on public transport", meaningAZ: "İctimai nəqliyyatda gediş haqqı", meaningTR: "Toplu taşımada yolculuk ücreti", example: "The bus fare went up again." },
      { word: "Detour", meaning: "A longer route that avoids a problem", meaningAZ: "Problemi yan keçən daha uzun yol", meaningTR: "Sorunu dolaşan daha uzun yol", example: "We took a detour around the accident." },
      { word: "Overtake", meaning: "To pass a vehicle moving in front of you", meaningAZ: "Qabaqdakı maşını ötmək", meaningTR: "Öndeki aracı sollamak", example: "Never overtake on a bend." },
      { word: "Honk", meaning: "To sound a car horn", meaningAZ: "Siqnal vermək", meaningTR: "Korna çalmak", example: "Drivers honk at everything here." },
    ],
    idioms: [
      { phrase: "In the fast lane", meaning: "Living in an exciting, busy way", meaningAZ: "Sürətli, gərgin həyat tərzi ilə yaşamaq", meaningTR: "Hızlı ve yoğun bir hayat sürmek", example: "After the promotion he lives life in the fast lane." },
      { phrase: "Hit a roadblock", meaning: "To meet an obstacle that stops progress", meaningAZ: "İrəliləməyi dayandıran maneə ilə qarşılaşmaq", meaningTR: "İlerlemeyi durduran bir engelle karşılaşmak", example: "The project hit a roadblock in June." },
      { phrase: "Back seat driver", meaning: "Someone who gives advice they were not asked for", meaningAZ: "Soruşulmadan məsləhət verən adam", meaningTR: "Sorulmadan akıl veren kişi", example: "Stop being a back seat driver, I know the way." },
    ],
    questions: {
      easy: [
        "How do you usually get to work or school?",
        "How long is your journey every day?",
        "Do you like public transport? Why or why not?",
        "Can you drive? When did you learn?",
        "What do you do while you travel?",
        "Is traffic bad in your city?",
        "Do you prefer walking or taking the bus?",
        "Have you ever missed a bus or a train?",
        "What is the most crowded place you travel through?",
        "Would you rather drive or be driven?",
      ],
      hard: [
        "Should city centres ban private cars?",
        "Is a long commute worth it for a better job?",
        "How would your city change if public transport were free?",
        "Who should pay for roads — drivers or everyone?",
        "Are self-driving cars a solution to traffic or a new problem?",
        "Should people who work from home pay less tax for using fewer roads?",
        "Why do calm people become aggressive behind the wheel?",
        "Is cycling in a big city a right or a risk people take on themselves?",
        "Should cities charge more to drive at busy hours?",
        "How much of your life is acceptable to spend travelling to work?",
      ],
    },
  },
  {
    day: 34,
    topic: "Cooking at Home 🍳",
    imageKeywords: [
      "hands kneading dough flour",
      "father and child cooking together",
      "steam rising from pot kitchen",
      "burnt food in pan",
      "grandmother stirring soup"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Recipe", meaning: "Instructions for making a dish", meaningAZ: "Yeməyin hazırlanma təlimatı", meaningTR: "Bir yemeğin yapılış tarifi", example: "I followed my mother's recipe exactly." },
      { word: "Ingredient", meaning: "One of the foods used in a dish", meaningAZ: "Yeməyə qatılan məhsullardan biri", meaningTR: "Yemekte kullanılan malzemelerden biri", example: "The only ingredient I forgot was salt." },
      { word: "Simmer", meaning: "To cook gently just below boiling", meaningAZ: "Qaynamağa çatmadan yavaş bişirmək", meaningTR: "Kaynamaya yakın, hafif ateşte pişirmek", example: "Let the sauce simmer for twenty minutes." },
      { word: "Chop", meaning: "To cut food into pieces", meaningAZ: "Yeməyi hissələrə doğramaq", meaningTR: "Yiyeceği parçalara doğramak", example: "Chop the onions finely." },
      { word: "Leftovers", meaning: "Food left after a meal", meaningAZ: "Yeməkdən sonra qalan qida", meaningTR: "Yemekten arta kalan yiyecek", example: "We ate leftovers for two days." },
      { word: "Burnt", meaning: "Cooked too long until black", meaningAZ: "Həddən artıq bişib yanmış", meaningTR: "Fazla pişip yanmış", example: "The bottom of the rice was burnt." },
      { word: "Seasoning", meaning: "Salt, pepper and spices added for taste", meaningAZ: "Dad üçün əlavə olunan duz, istiot və ədviyyat", meaningTR: "Tat için eklenen tuz, biber ve baharat", example: "It needs more seasoning." },
      { word: "Washing-up", meaning: "The dirty dishes after cooking", meaningAZ: "Bişirdikdən sonra yuyulası qablar", meaningTR: "Yemekten sonra yıkanacak bulaşık", example: "I cook, he does the washing-up." },
    ],
    idioms: [
      { phrase: "Too many cooks spoil the broth", meaning: "Too many people ruin the work", meaningAZ: "Aşpaz çox olanda xörək xarab olar", meaningTR: "Aşçı çok olunca yemek bozulur", example: "Let her finish — too many cooks spoil the broth." },
      { phrase: "From scratch", meaning: "Made completely from basic ingredients", meaningAZ: "Sıfırdan, əsas məhsullardan hazırlanmış", meaningTR: "Sıfırdan, temel malzemelerle yapılmış", example: "She bakes bread from scratch every Sunday." },
      { phrase: "Have a lot on your plate", meaning: "To have too much to deal with", meaningAZ: "Həddən artıq çox işi olmaq", meaningTR: "Başından aşkın işi olmak", example: "Ask someone else, he has a lot on his plate." },
    ],
    questions: {
      easy: [
        "Can you cook? What is your best dish?",
        "Who cooks in your family?",
        "What did you eat yesterday evening?",
        "Do you follow recipes or cook from memory?",
        "What food do you never get tired of?",
        "Have you ever burnt something while cooking?",
        "Do you like washing dishes?",
        "What is the first thing you learned to cook?",
        "Do you cook more at the weekend?",
        "What smell from a kitchen do you love?",
      ],
      hard: [
        "Is cooking at home a skill everyone should have?",
        "Why do people watch cooking shows but order food anyway?",
        "Should schools teach cooking instead of another academic subject?",
        "Has the delivery app changed family life?",
        "Is an expensive kitchen tool ever worth the money?",
        "Does cooking for someone say something that words cannot?",
        "Should traditional recipes be protected, or is every change welcome?",
        "Is eating alone in front of a screen a problem or just modern life?",
        "Who should do the cooking in a home, and how is that decided?",
        "What is lost when a family stops eating at the same table?",
      ],
    },
  },
  {
    day: 35,
    topic: "Childhood Memories 🧸",
    imageKeywords: [
      "old family photograph album hands",
      "child on swing golden light",
      "worn teddy bear on bed",
      "children running through sprinkler",
      "school desk carved initials"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Memory", meaning: "Something you remember from the past", meaningAZ: "Keçmişdən yadda qalan şey", meaningTR: "Geçmişten hatırladığın şey", example: "My first memory is of my grandmother's garden." },
      { word: "Nostalgia", meaning: "A warm, sad feeling for the past", meaningAZ: "Keçmişə qarşı isti, kədərli hiss", meaningTR: "Geçmişe duyulan tatlı hüzün", example: "That song fills me with nostalgia." },
      { word: "Grow up", meaning: "To become an adult", meaningAZ: "Böyümək, yetkinləşmək", meaningTR: "Büyümek, yetişkin olmak", example: "I grew up in a small town." },
      { word: "Playground", meaning: "An outdoor area where children play", meaningAZ: "Uşaqların oynadığı açıq meydança", meaningTR: "Çocukların oynadığı açık alan", example: "We spent every evening at the playground." },
      { word: "Spoiled", meaning: "Given too much and badly behaved", meaningAZ: "Həddən artıq əzizlənmiş və nazlı", meaningTR: "Fazla şımartılmış", example: "He was the youngest and a bit spoiled." },
      { word: "Strict", meaning: "Demanding obedience to rules", meaningAZ: "Qaydalara ciddi əməl tələb edən", meaningTR: "Kurallara uymayı sıkı biçimde isteyen", example: "My father was strict about homework." },
      { word: "Imaginary", meaning: "Existing only in the mind", meaningAZ: "Yalnız təxəyyüldə mövcud olan", meaningTR: "Sadece hayalde var olan", example: "She had an imaginary friend until she was six." },
      { word: "Scar", meaning: "A mark left on skin after a wound", meaningAZ: "Yaradan sonra dəridə qalan iz", meaningTR: "Yaradan sonra deride kalan iz", example: "I still have a scar from that bike." },
    ],
    idioms: [
      { phrase: "Like it was yesterday", meaning: "Remembered very clearly", meaningAZ: "Sanki dünən olub kimi aydın xatırlamaq", meaningTR: "Sanki dün olmuş gibi net hatırlamak", example: "I remember that day like it was yesterday." },
      { phrase: "Take a trip down memory lane", meaning: "To talk about happy old times", meaningAZ: "Xoş keçmişi xatırlayıb danışmaq", meaningTR: "Güzel eski günleri anıp konuşmak", example: "The photos took us down memory lane." },
      { phrase: "Child's play", meaning: "Something very easy", meaningAZ: "Çox asan iş", meaningTR: "Çok kolay bir iş", example: "After that exam, this one is child's play." },
    ],
    questions: {
      easy: [
        "What is your earliest memory?",
        "What games did you play as a child?",
        "Where did you grow up?",
        "Did you have a favourite toy?",
        "Who was your best friend at school?",
        "What food reminds you of childhood?",
        "Were your parents strict or relaxed?",
        "What did you want to be when you were little?",
        "Did you have pets when you were young?",
        "What is a happy day you still remember?",
      ],
      hard: [
        "How much of who you are was decided before you were ten?",
        "Are childhood memories reliable, or do we rewrite them?",
        "Should parents post photos of their children online?",
        "Is a strict childhood better preparation for life than a free one?",
        "What should every child get to experience, whatever their family's money?",
        "Do children today lose something by playing indoors?",
        "How do you forgive your parents for the mistakes they made?",
        "Should difficult childhood experiences be talked about or left alone?",
        "Is it fair to expect adults to 'get over' what happened to them as children?",
        "What childhood tradition would you want to pass on?",
      ],
    },
  },
  {
    day: 36,
    topic: "Job Interviews 🤝",
    imageKeywords: [
      "nervous candidate waiting corridor",
      "handshake across desk",
      "person adjusting tie mirror",
      "interview panel taking notes",
      "video call interview laptop"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Candidate", meaning: "A person applying for a job", meaningAZ: "İşə müraciət edən şəxs", meaningTR: "Bir işe başvuran kişi", example: "They interviewed six candidates." },
      { word: "CV", meaning: "A document listing your experience", meaningAZ: "Təcrübəni sadalayan sənəd", meaningTR: "Deneyimini listeleyen belge", example: "Keep your CV to two pages." },
      { word: "Qualification", meaning: "A skill or certificate that makes you suitable", meaningAZ: "Səni uyğun edən bacarıq və ya sənəd", meaningTR: "Seni uygun kılan beceri ya da belge", example: "The job needs no formal qualification." },
      { word: "Strength", meaning: "Something you are good at", meaningAZ: "Güclü olduğun cəhət", meaningTR: "İyi olduğun yön", example: "My biggest strength is staying calm." },
      { word: "Weakness", meaning: "Something you are not good at", meaningAZ: "Zəif olduğun cəhət", meaningTR: "Zayıf olduğun yön", example: "They always ask about your weaknesses." },
      { word: "Salary", meaning: "The money paid for a job", meaningAZ: "İş üçün ödənilən maaş", meaningTR: "Bir iş için ödenen maaş", example: "We did not discuss salary in the first interview." },
      { word: "Probation", meaning: "A trial period in a new job", meaningAZ: "Yeni işdə sınaq müddəti", meaningTR: "Yeni işte deneme süresi", example: "There is a three-month probation." },
      { word: "Turn down", meaning: "To refuse an offer", meaningAZ: "Təklifi rədd etmək", meaningTR: "Bir teklifi geri çevirmek", example: "She turned down the offer and stayed." },
    ],
    idioms: [
      { phrase: "Put your best foot forward", meaning: "To try to make the best impression", meaningAZ: "Ən yaxşı təəssüratı yaratmağa çalışmaq", meaningTR: "En iyi izlenimi bırakmaya çalışmak", example: "Wear something smart and put your best foot forward." },
      { phrase: "Land a job", meaning: "To successfully get a job", meaningAZ: "İşi əldə etmək", meaningTR: "Bir işi kapmak", example: "He landed a job two weeks after graduating." },
      { phrase: "Think on your feet", meaning: "To react quickly and well", meaningAZ: "Tez və düzgün reaksiya vermək", meaningTR: "Anında doğru tepki verebilmek", example: "In that interview you have to think on your feet." },
    ],
    questions: {
      easy: [
        "Have you ever had a job interview?",
        "What do you wear to an interview?",
        "Do you get nervous before important meetings?",
        "What job would you love to be interviewed for?",
        "How do you prepare for something important?",
        "What was your first job?",
        "Do you prefer working alone or in a team?",
        "What question would you find hardest to answer?",
        "Who gives you advice about work?",
        "Would you like to work in another country?",
      ],
      hard: [
        "Is the interview a fair way to choose the right person?",
        "Should employers see your name and photo before they meet you?",
        "Is it acceptable to exaggerate slightly on a CV?",
        "Should salary be printed in every job advert?",
        "Do personality tests tell an employer anything real?",
        "Should AI be allowed to filter job applications?",
        "Is experience or attitude more important in a new hire?",
        "How should someone explain a long gap in their work history?",
        "Are unpaid internships exploitation or an opportunity?",
        "What would a fairer hiring process actually look like?",
      ],
    },
  },
  {
    day: 37,
    topic: "Mistakes & Regrets 🤦",
    imageKeywords: [
      "person head in hands desk",
      "broken glass on floor",
      "crumpled paper overflowing bin",
      "student looking at failed exam",
      "apology flowers on doorstep"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Regret", meaning: "To feel sorry about something you did", meaningAZ: "Etdiyin bir şeyə görə peşman olmaq", meaningTR: "Yaptığın bir şeye pişman olmak", example: "I regret not saying goodbye." },
      { word: "Apologise", meaning: "To say sorry", meaningAZ: "Üzr istəmək", meaningTR: "Özür dilemek", example: "He apologised the next morning." },
      { word: "Blame", meaning: "To say someone caused something bad", meaningAZ: "Pis bir şeyin səbəbkarı saymaq", meaningTR: "Kötü bir şeyin sorumlusu saymak", example: "Don't blame the weather." },
      { word: "On purpose", meaning: "Done deliberately", meaningAZ: "Qəsdən edilmiş", meaningTR: "Bilerek yapılmış", example: "I didn't do it on purpose." },
      { word: "Careless", meaning: "Not paying enough attention", meaningAZ: "Kifayət qədər diqqət göstərməyən", meaningTR: "Yeterince dikkat etmeyen", example: "It was a careless mistake." },
      { word: "Make up for", meaning: "To do something good to fix a wrong", meaningAZ: "Səhvi düzəltmək üçün yaxşı bir şey etmək", meaningTR: "Hatayı telafi edecek bir şey yapmak", example: "He worked all weekend to make up for it." },
      { word: "Lesson", meaning: "Something useful learned from experience", meaningAZ: "Təcrübədən öyrənilən faydalı şey", meaningTR: "Deneyimden öğrenilen faydalı şey", example: "That job was an expensive lesson." },
      { word: "Forgive", meaning: "To stop being angry with someone", meaningAZ: "Bağışlamaq, acığını saxlamamaq", meaningTR: "Affetmek, kızgınlığı bırakmak", example: "She forgave him, but she remembers." },
    ],
    idioms: [
      { phrase: "Spilled milk", meaning: "A past problem you cannot change", meaningAZ: "Dəyişdirə bilmədiyin keçmiş problem", meaningTR: "Değiştiremeyeceğin geçmiş bir sorun", example: "It's spilled milk now — think about next week." },
      { phrase: "Learn the hard way", meaning: "To learn through a painful experience", meaningAZ: "Acı təcrübə ilə öyrənmək", meaningTR: "Acı bir deneyimle öğrenmek", example: "I learned the hard way not to lend money." },
      { phrase: "Bite your tongue", meaning: "To stop yourself from speaking", meaningAZ: "Dilini saxlamaq, deməmək", meaningTR: "Dilini tutmak, söylememek", example: "I bit my tongue and said nothing." },
    ],
    questions: {
      easy: [
        "What is a small mistake you made this week?",
        "Is it easy for you to say sorry?",
        "Do you forgive people quickly?",
        "Have you ever broken something by accident?",
        "What do you do when you make a mistake at work?",
        "Do you write things down so you don't forget?",
        "Have you ever sent a message to the wrong person?",
        "What mistake do you make again and again?",
        "Who do you tell when something goes wrong?",
        "Do you laugh at your own mistakes later?",
      ],
      hard: [
        "Is regret useful or just painful?",
        "Should a person be judged forever for one serious mistake?",
        "Is an apology worth anything without a change in behaviour?",
        "Do we learn more from failure than from success, or is that a comforting story?",
        "When is it right to admit a mistake publicly?",
        "Should children be protected from failing?",
        "Is it possible to forgive someone who never apologised?",
        "Do organisations hide mistakes because of the law or because of shame?",
        "What is the difference between a mistake and a bad decision?",
        "Which is worse: the thing you did, or the thing you never tried?",
      ],
    },
  },
  {
    day: 38,
    topic: "Luck & Superstitions 🍀",
    imageKeywords: [
      "hand holding four leaf clover",
      "black cat crossing street",
      "lottery ticket on table",
      "person crossing fingers close up",
      "broken mirror reflection"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Superstition", meaning: "A belief that an action brings luck", meaningAZ: "Hansısa hərəkətin uğur gətirdiyinə inam", meaningTR: "Bir davranışın şans getirdiğine inanma", example: "Not whistling indoors is a superstition here." },
      { word: "Coincidence", meaning: "Two things happening together by chance", meaningAZ: "Təsadüfən üst-üstə düşən iki hadisə", meaningTR: "Rastlantı sonucu üst üste gelen iki olay", example: "Meeting there was a complete coincidence." },
      { word: "Fate", meaning: "A power that decides what happens", meaningAZ: "Baş verənləri müəyyən edən qüvvə, tale", meaningTR: "Olacakları belirleyen güç, kader", example: "He believes in fate, I believe in work." },
      { word: "Charm", meaning: "An object believed to bring luck", meaningAZ: "Uğur gətirdiyinə inanılan əşya", meaningTR: "Şans getirdiğine inanılan nesne", example: "She carries a lucky charm in her bag." },
      { word: "Jinx", meaning: "To bring bad luck by speaking too soon", meaningAZ: "Vaxtından əvvəl deyib uğursuzluq gətirmək", meaningTR: "Erken konuşup uğursuzluk getirmek", example: "Don't say we've won — you'll jinx it." },
      { word: "Odds", meaning: "The chance that something will happen", meaningAZ: "Bir şeyin baş vermə ehtimalı", meaningTR: "Bir şeyin gerçekleşme olasılığı", example: "The odds were against them." },
      { word: "Gamble", meaning: "To risk money on an uncertain result", meaningAZ: "Qeyri-müəyyən nəticəyə pul riskə atmaq", meaningTR: "Belirsiz bir sonuca para yatırmak", example: "Buying that flat was a gamble." },
      { word: "Omen", meaning: "A sign of something to come", meaningAZ: "Gələcək hadisənin əlaməti", meaningTR: "Gelecek bir olayın işareti", example: "They took the rain as a bad omen." },
    ],
    idioms: [
      { phrase: "Touch wood", meaning: "Said to keep good luck", meaningAZ: "Uğuru qorumaq üçün deyilən söz", meaningTR: "Şansı korumak için söylenen söz", example: "The car still runs, touch wood." },
      { phrase: "Beginner's luck", meaning: "Early success without skill", meaningAZ: "Bacarıq olmadan gələn ilk uğur", meaningTR: "Beceri olmadan gelen ilk başarı", example: "He won the first game — beginner's luck." },
      { phrase: "Against all odds", meaning: "Despite very little chance", meaningAZ: "Çox az şans olmasına baxmayaraq", meaningTR: "Şans çok az olmasına rağmen", example: "Against all odds, the small team won." },
    ],
    questions: {
      easy: [
        "Do you believe in luck?",
        "Do you have a lucky number or object?",
        "What superstitions exist in your country?",
        "Have you ever won anything?",
        "Do you play the lottery?",
        "Is there something you always do before an exam?",
        "What is the luckiest thing that happened to you?",
        "Do you believe in bad luck days?",
        "Would you walk under a ladder?",
        "Has a small coincidence ever surprised you?",
      ],
      hard: [
        "How much of success is luck and how much is work?",
        "Why do intelligent people keep superstitions they say they do not believe?",
        "Should gambling be advertised?",
        "Is it fair that where you were born decides so much?",
        "Do superstitions do any harm, or are they harmless comfort?",
        "Is 'being lucky' partly a skill — noticing and taking chances?",
        "Should successful people admit how much luck they had?",
        "Do lotteries take most money from those who can least afford it?",
        "Can a society be designed so that luck matters less?",
        "Would you want to know your future if you could?",
      ],
    },
  },
  {
    day: 39,
    topic: "Rules & Laws ⚖️",
    imageKeywords: [
      "no entry sign weathered wall",
      "police officer directing traffic",
      "queue of people waiting patiently",
      "courtroom empty chairs",
      "hand signing official document"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Law", meaning: "A rule made by a government", meaningAZ: "Dövlət tərəfindən qoyulan qayda", meaningTR: "Devletin koyduğu kural", example: "The law changed last year." },
      { word: "Fine", meaning: "Money you pay as a punishment", meaningAZ: "Cəza olaraq ödənilən pul", meaningTR: "Ceza olarak ödenen para", example: "He got a fine for parking there." },
      { word: "Forbidden", meaning: "Not allowed", meaningAZ: "Qadağan olunmuş", meaningTR: "Yasaklanmış", example: "Smoking is forbidden inside." },
      { word: "Permit", meaning: "An official document allowing something", meaningAZ: "Bir şeyə icazə verən rəsmi sənəd", meaningTR: "Bir şeye izin veren resmî belge", example: "You need a permit to build here." },
      { word: "Enforce", meaning: "To make people obey a rule", meaningAZ: "Qaydaya əməl olunmasını təmin etmək", meaningTR: "Bir kurala uyulmasını sağlamak", example: "Nobody enforces that rule." },
      { word: "Witness", meaning: "A person who saw what happened", meaningAZ: "Baş verəni görən şəxs, şahid", meaningTR: "Olanı gören kişi, tanık", example: "There were two witnesses." },
      { word: "Fair", meaning: "Treating everyone equally", meaningAZ: "Hamıya bərabər yanaşan, ədalətli", meaningTR: "Herkese eşit davranan, adil", example: "The decision was not fair." },
      { word: "Loophole", meaning: "A gap in a rule people use to escape it", meaningAZ: "Qaydadan yayınmaq üçün istifadə olunan boşluq", meaningTR: "Kuraldan kaçmak için kullanılan boşluk", example: "They found a loophole in the contract." },
    ],
    idioms: [
      { phrase: "Bend the rules", meaning: "To allow a small exception", meaningAZ: "Qaydanı bir az yumşaltmaq", meaningTR: "Kuralı biraz esnetmek", example: "They bent the rules for a regular customer." },
      { phrase: "Get away with it", meaning: "To do something wrong without punishment", meaningAZ: "Cəza almadan yaxa qurtarmaq", meaningTR: "Ceza almadan yırtmak", example: "He got away with it because nobody complained." },
      { phrase: "Take the law into your own hands", meaning: "To punish someone yourself", meaningAZ: "Cəzanı özün vermək, qanunu öz əlinə almaq", meaningTR: "Cezayı kendin vermek, kanunu eline almak", example: "Call the police, don't take the law into your own hands." },
    ],
    questions: {
      easy: [
        "What rules did you have at home as a child?",
        "Is there a rule at work you find annoying?",
        "Have you ever paid a fine?",
        "Do people queue politely in your country?",
        "What is one law you think is very good?",
        "Do you always wear a seatbelt?",
        "What rules do people break most often?",
        "Are there rules in your building?",
        "Do you read contracts before signing?",
        "What rule would you make for your city?",
      ],
      hard: [
        "When is it right to break a law?",
        "Should the same crime get the same punishment for everyone?",
        "Do harsher punishments actually reduce crime?",
        "Should some laws expire automatically after ten years?",
        "Is it a citizen's duty to report a neighbour breaking the law?",
        "Should courts consider a person's circumstances or only the act?",
        "Are fines a fair punishment when the same amount means nothing to a rich person?",
        "Who should decide what is fair when the law and morality disagree?",
        "Should young offenders' records ever be erased?",
        "Is a society with fewer rules freer, or only freer for the strong?",
      ],
    },
  },
  {
    day: 40,
    topic: "Fixing Things & DIY 🔧",
    imageKeywords: [
      "hands repairing bicycle chain",
      "toolbox open on wooden floor",
      "person painting wall roller",
      "broken chair being glued",
      "watch repair magnifying glass"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Repair", meaning: "To fix something broken", meaningAZ: "Sınmış şeyi düzəltmək", meaningTR: "Bozuk bir şeyi onarmak", example: "I repaired the tap myself." },
      { word: "Tool", meaning: "An object used to do work with your hands", meaningAZ: "Əl işi üçün istifadə olunan alət", meaningTR: "El işi için kullanılan alet", example: "Pass me that tool, please." },
      { word: "Spare part", meaning: "A replacement piece for a machine", meaningAZ: "Maşın üçün ehtiyat hissə", meaningTR: "Bir makine için yedek parça", example: "The spare part took a month to arrive." },
      { word: "Leak", meaning: "Liquid escaping through a hole", meaningAZ: "Deşikdən su sızması", meaningTR: "Delikten sıvı sızması", example: "There is a leak under the sink." },
      { word: "Loose", meaning: "Not fixed tightly", meaningAZ: "Bərk bağlanmamış, boş", meaningTR: "Sıkı tutturulmamış, gevşek", example: "The handle is loose." },
      { word: "Worn out", meaning: "Damaged from long use", meaningAZ: "Uzun istifadədən köhnəlmiş", meaningTR: "Uzun kullanımdan yıpranmış", example: "These shoes are worn out." },
      { word: "Handy", meaning: "Good at practical work", meaningAZ: "Əl işində bacarıqlı", meaningTR: "El işinde becerikli", example: "My uncle is very handy." },
      { word: "Temporary fix", meaning: "A repair that will not last", meaningAZ: "Uzun sürməyəcək müvəqqəti təmir", meaningTR: "Kalıcı olmayan geçici tamir", example: "The tape is just a temporary fix." },
    ],
    idioms: [
      { phrase: "If it ain't broke, don't fix it", meaning: "Do not change what works", meaningAZ: "İşləyən şeyə toxunma", meaningTR: "Çalışan şeye dokunma", example: "The old system is fine — if it ain't broke, don't fix it." },
      { phrase: "Jack of all trades", meaning: "Someone who can do many things", meaningAZ: "Hər işdən bir az bacaran adam", meaningTR: "Her işten biraz anlayan kişi", example: "He's a jack of all trades around the house." },
      { phrase: "Cut corners", meaning: "To do something cheaply and badly", meaningAZ: "Ucuz və keyfiyyətsiz görmək", meaningTR: "Ucuza ve baştan savma yapmak", example: "They cut corners and it broke again." },
    ],
    questions: {
      easy: [
        "Can you fix things at home?",
        "What was the last thing you repaired?",
        "Do you have tools in your house?",
        "Would you rather repair something or buy a new one?",
        "Who fixes things in your family?",
        "Have you ever put together furniture from a box?",
        "What is broken in your home right now?",
        "Do you watch videos to learn how to fix things?",
        "Have you ever made a repair worse?",
        "What skill would you like to learn with your hands?",
      ],
      hard: [
        "Should products be built so that anyone can repair them?",
        "Why do people throw away things that could be fixed?",
        "Is 'do it yourself' a real saving or a false economy?",
        "Should companies be forced to sell spare parts for ten years?",
        "Has the ability to fix things been lost in one generation?",
        "Is there value in repairing an object that is not worth the money?",
        "Should schools teach practical repair skills?",
        "Do you own a device you are not allowed to open? Is that acceptable?",
        "Is buying second-hand and repairing it a political act?",
        "What would change if repairing were cheaper than replacing?",
      ],
    },
  },
  {
    day: 41,
    topic: "Crowds & Public Places 🚇",
    imageKeywords: [
      "packed train platform rush",
      "festival crowd hands in air",
      "stadium full of supporters",
      "protest march banners street",
      "person alone in busy square"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Crowd", meaning: "A large group of people together", meaningAZ: "Bir yerə yığılmış böyük insan kütləsi", meaningTR: "Bir araya toplanmış büyük insan kalabalığı", example: "A crowd gathered outside the theatre." },
      { word: "Queue", meaning: "A line of people waiting", meaningAZ: "Gözləyən adamların növbəsi", meaningTR: "Bekleyen insanların sırası", example: "The queue went round the corner." },
      { word: "Packed", meaning: "Completely full of people", meaningAZ: "Adamla tamamilə dolu", meaningTR: "İnsanla tamamen dolu", example: "The bus was packed at eight." },
      { word: "Bump into", meaning: "To meet someone by chance", meaningAZ: "Təsadüfən rastlaşmaq", meaningTR: "Tesadüfen karşılaşmak", example: "I bumped into an old classmate there." },
      { word: "Push through", meaning: "To move forward through people", meaningAZ: "Adamların arasından irəli keçmək", meaningTR: "İnsanların arasından ilerlemek", example: "He pushed through to the front." },
      { word: "Announcement", meaning: "Public information said out loud", meaningAZ: "Ucadan deyilən ictimai məlumat", meaningTR: "Yüksek sesle yapılan duyuru", example: "Nobody understood the announcement." },
      { word: "Overwhelming", meaning: "Too strong or too much to handle", meaningAZ: "Həddən artıq güclü, adamı boğan", meaningTR: "Başa çıkılamayacak kadar yoğun", example: "The noise was overwhelming." },
      { word: "Space", meaning: "Empty area around a person", meaningAZ: "İnsanın ətrafındakı boş sahə", meaningTR: "Kişinin çevresindeki boş alan", example: "I need a bit of space." },
    ],
    idioms: [
      { phrase: "Stand out in a crowd", meaning: "To be easily noticed", meaningAZ: "Kütlədə dərhal seçilmək", meaningTR: "Kalabalıkta hemen göze çarpmak", example: "With that jacket he stands out in a crowd." },
      { phrase: "Follow the crowd", meaning: "To do what everyone else does", meaningAZ: "Hamının etdiyini etmək", meaningTR: "Herkesin yaptığını yapmak", example: "She never follows the crowd." },
      { phrase: "Packed like sardines", meaning: "Extremely crowded", meaningAZ: "Sıx-sıx, iynə atsan yerə düşməz", meaningTR: "Balık istifi gibi kalabalık", example: "We were packed like sardines on the metro." },
    ],
    questions: {
      easy: [
        "Do you like crowded places?",
        "Where is the most crowded place in your city?",
        "Have you ever been to a concert or a match?",
        "How do you feel in a packed bus?",
        "Do you prefer shopping when it is quiet or busy?",
        "Have you ever lost someone in a crowd?",
        "Do people queue politely where you live?",
        "What event brings the most people together in your country?",
        "Do you like festivals?",
        "Where do you go when you want to be around people?",
      ],
      hard: [
        "Why do people behave differently in a crowd than alone?",
        "Should cities limit how many people can enter a popular place?",
        "Is it ever safe to be in a very large crowd?",
        "What makes a public space feel welcoming rather than hostile?",
        "Should public squares be places for protest, or only for leisure?",
        "Has watching events on a screen replaced being there?",
        "Who is responsible when a crowd turns dangerous?",
        "Do cameras in public places protect people or watch them?",
        "Why can someone feel most alone in a crowded city?",
        "What does a country's behaviour in queues say about it?",
      ],
    },
  },
  {
    day: 42,
    topic: "Being Alone 🌙",
    imageKeywords: [
      "person reading alone by window",
      "single figure walking empty beach",
      "empty chair lamp late night",
      "woman having coffee alone cafe",
      "man fishing alone at dawn"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Solitude", meaning: "Being alone in a peaceful way", meaningAZ: "Dinc şəkildə tək qalmaq", meaningTR: "Huzurlu bir şekilde yalnız kalma", example: "He goes to the mountains for solitude." },
      { word: "Lonely", meaning: "Sad because you are alone", meaningAZ: "Tək olduğu üçün kədərli", meaningTR: "Yalnız olduğu için üzgün", example: "The first month abroad was lonely." },
      { word: "Recharge", meaning: "To get your energy back", meaningAZ: "Enerjini bərpa etmək", meaningTR: "Enerjini geri kazanmak", example: "I need a quiet weekend to recharge." },
      { word: "Introvert", meaning: "Someone who gains energy alone", meaningAZ: "Tək qalanda enerji toplayan adam", meaningTR: "Yalnızken enerji toplayan kişi", example: "As an introvert, she left the party early." },
      { word: "Silence", meaning: "Complete absence of sound", meaningAZ: "Tam sükut", meaningTR: "Tam sessizlik", example: "The silence in the house was strange." },
      { word: "Routine", meaning: "The regular way you do things", meaningAZ: "İşləri gördüyün adi qayda", meaningTR: "İşleri yaptığın olağan düzen", example: "Living alone, my routine is my own." },
      { word: "Miss", meaning: "To feel sad that someone is not there", meaningAZ: "Kiminsə yoxluğunu hiss etmək, darıxmaq", meaningTR: "Birinin yokluğunu hissetmek, özlemek", example: "I miss the noise of my family." },
      { word: "Independent", meaning: "Able to manage without help", meaningAZ: "Kömək olmadan öz işini görə bilən", meaningTR: "Yardım almadan kendi işini görebilen", example: "Living alone made me independent." },
    ],
    idioms: [
      { phrase: "Me time", meaning: "Time for yourself", meaningAZ: "Özün üçün ayırdığın vaxt", meaningTR: "Kendine ayırdığın zaman", example: "Sunday morning is my me time." },
      { phrase: "Lost in thought", meaning: "Thinking deeply and not noticing others", meaningAZ: "Fikrə dalıb ətrafı görməmək", meaningTR: "Düşüncelere dalıp çevreyi fark etmemek", example: "He sat lost in thought for an hour." },
      { phrase: "Keep your own company", meaning: "To be comfortable alone", meaningAZ: "Tək qalmaqdan rahat olmaq", meaningTR: "Yalnız kalmaktan rahatsız olmamak", example: "She is happy to keep her own company." },
    ],
    questions: {
      easy: [
        "Do you like being alone?",
        "What do you do when you are home alone?",
        "Do you ever eat in a restaurant alone?",
        "How much quiet time do you need in a day?",
        "Have you ever travelled alone?",
        "Do you listen to music when you are alone?",
        "Where do you go to think?",
        "Do you live alone or with others?",
        "When do you feel lonely?",
        "What is the best thing about having the house to yourself?",
      ],
      hard: [
        "What is the difference between being alone and being lonely?",
        "Can a person be happy without close relationships?",
        "Is loneliness a health problem a government should treat?",
        "Have phones made solitude impossible?",
        "Should people be taught how to be alone?",
        "Why is eating alone in public still uncomfortable for many?",
        "Does living alone make a person more selfish or more capable?",
        "Is silence something modern life has taken away?",
        "Do introverts have a harder time in the workplace?",
        "How long could you go without speaking to anyone?",
      ],
    },
  },
  {
    day: 43,
    topic: "Games & Puzzles 🎲",
    imageKeywords: [
      "hands moving chess piece",
      "family playing board game table",
      "child solving rubiks cube",
      "cards being dealt close up",
      "dominoes falling in a line"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Opponent", meaning: "The person you play against", meaningAZ: "Qarşı oynadığın rəqib", meaningTR: "Karşında oynayan rakip", example: "My opponent was much faster." },
      { word: "Turn", meaning: "The moment when it is your time to play", meaningAZ: "Oyunda sənin növbən", meaningTR: "Oyunda senin sıran", example: "It's your turn." },
      { word: "Cheat", meaning: "To break the rules secretly", meaningAZ: "Gizlicə qaydanı pozmaq", meaningTR: "Gizlice kural çiğnemek", example: "He cheats at cards every time." },
      { word: "Strategy", meaning: "A plan for winning", meaningAZ: "Qazanmaq üçün plan", meaningTR: "Kazanmak için plan", example: "Her strategy was to wait." },
      { word: "Draw", meaning: "A result where nobody wins", meaningAZ: "Heç kəsin qazanmadığı nəticə, heç-heçə", meaningTR: "Kimsenin kazanmadığı sonuç, berabere", example: "The match ended in a draw." },
      { word: "Clue", meaning: "A piece of information that helps you solve something", meaningAZ: "Həll etməyə kömək edən ipucu", meaningTR: "Çözmeye yardım eden ipucu", example: "The last clue was too hard." },
      { word: "Give up", meaning: "To stop trying", meaningAZ: "Cəhdi dayandırmaq, təslim olmaq", meaningTR: "Denemeyi bırakmak, pes etmek", example: "I gave up after twenty minutes." },
      { word: "Addictive", meaning: "Hard to stop doing", meaningAZ: "Dayandırmaq çətin olan, aludəçi", meaningTR: "Bırakması zor, bağımlılık yapan", example: "That game is dangerously addictive." },
    ],
    idioms: [
      { phrase: "Play your cards right", meaning: "To act cleverly to succeed", meaningAZ: "Uğur üçün ağıllı davranmaq", meaningTR: "Başarı için akıllıca davranmak", example: "Play your cards right and you'll get the job." },
      { phrase: "Beat someone at their own game", meaning: "To defeat someone using their own method", meaningAZ: "Kimisə öz üsulu ilə məğlub etmək", meaningTR: "Birini kendi yöntemiyle yenmek", example: "She beat them at their own game." },
      { phrase: "Poker face", meaning: "A face that shows no emotion", meaningAZ: "Heç nə bildirməyən sifət ifadəsi", meaningTR: "Hiçbir şey belli etmeyen yüz ifadesi", example: "Keep a poker face when they ask." },
    ],
    questions: {
      easy: [
        "What games did you play as a child?",
        "Do you play games on your phone?",
        "Are you good at chess?",
        "Do you like card games?",
        "Who in your family is the most competitive?",
        "Do you enjoy crosswords or puzzles?",
        "What is the last game you played with someone?",
        "Do you play to win or to have fun?",
        "Have you ever played a game for hours?",
        "What game would you teach a foreign friend?",
      ],
      hard: [
        "Do games teach children anything that school cannot?",
        "Should video games be treated like a sport?",
        "Is losing an important experience for a child?",
        "Why can adults not play as easily as children?",
        "Should games with money prizes be regulated as gambling?",
        "Do puzzle games really keep the mind sharp, or is that marketing?",
        "Is playing against a computer as satisfying as against a person?",
        "Should screen games be limited by law for young children?",
        "What does the way someone plays reveal about them?",
        "Can competition make a friendship stronger or does it damage it?",
      ],
    },
  },
  {
    day: 44,
    topic: "Gifts & Giving 🎁",
    imageKeywords: [
      "hands passing wrapped present",
      "child opening gift surprise face",
      "volunteer serving food kitchen",
      "flowers left on doorstep",
      "donation box coins hand"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Generous", meaning: "Willing to give freely", meaningAZ: "Əliaçıq, səxavətli", meaningTR: "Eli açık, cömert", example: "She is generous with her time." },
      { word: "Thoughtful", meaning: "Showing care in what you choose or do", meaningAZ: "Diqqətlə, qayğı ilə seçilmiş", meaningTR: "Özenle, düşünülerek seçilmiş", example: "It was a small but thoughtful gift." },
      { word: "Wrap", meaning: "To cover a gift in paper", meaningAZ: "Hədiyyəni kağıza bükmək", meaningTR: "Hediyeyi kâğıda sarmak", example: "I wrapped it badly, as usual." },
      { word: "Donate", meaning: "To give money or goods to help", meaningAZ: "Kömək məqsədilə pul və ya əşya vermək", meaningTR: "Yardım amacıyla para ya da eşya vermek", example: "They donated the old computers." },
      { word: "Charity", meaning: "An organisation that helps people", meaningAZ: "İnsanlara kömək edən təşkilat", meaningTR: "İnsanlara yardım eden kuruluş", example: "The charity works with refugees." },
      { word: "Owe", meaning: "To have a duty to give something back", meaningAZ: "Qarşılığını qaytarmaq borcu olmaq", meaningTR: "Karşılığını verme borcu olmak", example: "I owe her a favour." },
      { word: "Refuse", meaning: "To say no to something offered", meaningAZ: "Təklif olunan şeyi qəbul etməmək", meaningTR: "Sunulan bir şeyi kabul etmemek", example: "It is rude to refuse food here." },
      { word: "Gesture", meaning: "An action showing a feeling", meaningAZ: "Hissi göstərən davranış, jest", meaningTR: "Bir duyguyu gösteren davranış", example: "Sending flowers was a kind gesture." },
    ],
    idioms: [
      { phrase: "It's the thought that counts", meaning: "The intention matters more than the gift", meaningAZ: "Hədiyyənin özü yox, niyyəti vacibdir", meaningTR: "Önemli olan hediye değil, niyettir", example: "The cake collapsed, but it's the thought that counts." },
      { phrase: "Give and take", meaning: "Mutual compromise", meaningAZ: "Qarşılıqlı güzəşt", meaningTR: "Karşılıklı ödün verme", example: "Every marriage needs give and take." },
      { phrase: "Go the extra mile", meaning: "To do more than is expected", meaningAZ: "Gözləniləndən artığını etmək", meaningTR: "Beklenenden fazlasını yapmak", example: "He goes the extra mile for his students." },
    ],
    questions: {
      easy: [
        "What was the best gift you ever received?",
        "Do you enjoy choosing presents for people?",
        "When do people give gifts in your country?",
        "Is money an acceptable gift where you live?",
        "What would you buy for a friend with very little money?",
        "Do you keep gifts you do not like?",
        "Have you ever given something homemade?",
        "Who is the most generous person you know?",
        "Do you donate to charity?",
        "What small kindness do you remember from a stranger?",
      ],
      hard: [
        "Is a gift ever truly free, or does it always create an obligation?",
        "Should giving to charity be private or public?",
        "Do expensive gifts damage friendships?",
        "Is volunteering more valuable than donating money?",
        "Should rich people be expected to give a fixed share away?",
        "Do charities solve problems or make them permanent?",
        "Is it right to refuse a gift that makes you uncomfortable?",
        "Are wedding gift lists practical or greedy?",
        "Why is it harder for some people to receive than to give?",
        "What is the most useful thing you could give someone who has nothing?",
      ],
    },
  },
  {
    day: 45,
    topic: "Accidents & Emergencies 🚑",
    imageKeywords: [
      "ambulance lights wet street night",
      "person with bandaged hand",
      "firefighters on a ladder",
      "car with broken windscreen",
      "first aid kit open table"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Emergency", meaning: "A dangerous situation needing fast action", meaningAZ: "Tez müdaxilə tələb edən təhlükəli vəziyyət", meaningTR: "Hızlı müdahale gerektiren tehlikeli durum", example: "Call this number in an emergency." },
      { word: "Injury", meaning: "Damage to the body", meaningAZ: "Bədənə dəyən zədə", meaningTR: "Vücutta oluşan yaralanma", example: "Luckily it was a minor injury." },
      { word: "Ambulance", meaning: "A vehicle that takes people to hospital", meaningAZ: "Xəstəni xəstəxanaya aparan avtomobil", meaningTR: "Hastayı hastaneye götüren araç", example: "The ambulance arrived in six minutes." },
      { word: "First aid", meaning: "Basic help given before a doctor arrives", meaningAZ: "Həkim gələnə qədər göstərilən ilk yardım", meaningTR: "Doktor gelene kadar yapılan ilk yardım", example: "Everyone should know basic first aid." },
      { word: "Panic", meaning: "Sudden uncontrolled fear", meaningAZ: "Qəfil, idarə olunmayan qorxu", meaningTR: "Ani ve kontrolsüz korku", example: "Try not to panic and call for help." },
      { word: "Rescue", meaning: "To save someone from danger", meaningAZ: "Kimisə təhlükədən xilas etmək", meaningTR: "Birini tehlikeden kurtarmak", example: "Neighbours rescued the cat from the roof." },
      { word: "Bleeding", meaning: "Losing blood from a wound", meaningAZ: "Yaradan qan axması", meaningTR: "Yaradan kan gelmesi", example: "The bleeding stopped quickly." },
      { word: "Recover", meaning: "To become well again", meaningAZ: "Sağalmaq, özünə gəlmək", meaningTR: "İyileşmek, kendine gelmek", example: "He recovered in three weeks." },
    ],
    idioms: [
      { phrase: "A close call", meaning: "Something bad that almost happened", meaningAZ: "Az qala baş verəcək pis hadisə", meaningTR: "Az kalsın olacak kötü bir olay", example: "That was a close call on the motorway." },
      { phrase: "Keep a cool head", meaning: "To stay calm under pressure", meaningAZ: "Təzyiq altında sakit qalmaq", meaningTR: "Baskı altında sakin kalmak", example: "She kept a cool head and called for help." },
      { phrase: "Better safe than sorry", meaning: "It is better to be careful", meaningAZ: "Ehtiyatlı olmaq peşman olmaqdan yaxşıdır", meaningTR: "Tedbirli olmak pişman olmaktan iyidir", example: "Take the umbrella — better safe than sorry." },
    ],
    questions: {
      easy: [
        "Do you know the emergency number in your country?",
        "Have you ever called an ambulance?",
        "Do you have a first aid kit at home?",
        "Have you ever broken a bone?",
        "What do you do when you cut your finger?",
        "Are you calm in stressful situations?",
        "Have you ever helped someone who fell?",
        "Do you drive carefully in bad weather?",
        "What accident happened in your home recently?",
        "Who would you call first if something went wrong?",
      ],
      hard: [
        "Should first aid be a required subject in every school?",
        "Do people help strangers less than they used to?",
        "Should someone who tries to help and makes it worse be protected by law?",
        "Is it right to film an accident instead of helping?",
        "How should a hospital decide who is treated first?",
        "Should emergency services be free in every country?",
        "Are safety rules at work usually followed or ignored until something happens?",
        "How much risk should a person be allowed to take with their own life?",
        "Do you become a different person in an emergency?",
        "What would make your city safer in a real disaster?",
      ],
    },
  },
  {
    day: 46,
    topic: "Manners & Politeness 🙇",
    imageKeywords: [
      "man holding door for stranger",
      "people bowing greeting",
      "dinner table formal setting hands",
      "person giving up seat bus",
      "loud phone call in quiet cafe"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Polite", meaning: "Behaving with respect for others", meaningAZ: "Başqalarına hörmətlə davranan", meaningTR: "Başkalarına saygıyla davranan", example: "He was polite but distant." },
      { word: "Rude", meaning: "Not showing respect", meaningAZ: "Hörmətsiz, kobud", meaningTR: "Saygısız, kaba", example: "Interrupting like that is rude." },
      { word: "Manners", meaning: "Accepted ways of behaving", meaningAZ: "Qəbul olunmuş davranış qaydaları", meaningTR: "Kabul görmüş davranış kuralları", example: "His table manners are perfect." },
      { word: "Respect", meaning: "Treating someone as important", meaningAZ: "Kimisə dəyərli sayıb ona ehtiram göstərmək", meaningTR: "Birine değer verip saygı göstermek", example: "Respect is earned slowly." },
      { word: "Interrupt", meaning: "To speak while someone else is speaking", meaningAZ: "Başqası danışarkən sözünü kəsmək", meaningTR: "Başkası konuşurken sözünü kesmek", example: "Please don't interrupt me." },
      { word: "Apology", meaning: "Words said to express regret", meaningAZ: "Peşmanlığı bildirən üzrxahlıq", meaningTR: "Pişmanlığı belirten özür", example: "A short apology was enough." },
      { word: "Offend", meaning: "To upset someone by what you say or do", meaningAZ: "Söz və ya hərəkətlə kimisə incitmək", meaningTR: "Söz ya da davranışla birini incitmek", example: "I hope I didn't offend her." },
      { word: "Small talk", meaning: "Light conversation about unimportant things", meaningAZ: "Əhəmiyyətsiz mövzularda yüngül söhbət", meaningTR: "Önemsiz konularda hafif sohbet", example: "He is terrible at small talk." },
    ],
    idioms: [
      { phrase: "Mind your manners", meaning: "Behave properly", meaningAZ: "Davranışına fikir ver", meaningTR: "Davranışlarına dikkat et", example: "Mind your manners at your aunt's house." },
      { phrase: "Bite your tongue", meaning: "To stay silent although you want to speak", meaningAZ: "Demək istəsən də susmaq", meaningTR: "Söylemek istesen de susmak", example: "I bit my tongue and let him finish." },
      { phrase: "Rub someone up the wrong way", meaning: "To annoy someone without meaning to", meaningAZ: "İstəmədən kimisə əsəbiləşdirmək", meaningTR: "İstemeden birini rahatsız etmek", example: "His jokes rub people up the wrong way." },
    ],
    questions: {
      easy: [
        "What do you say when you meet someone for the first time?",
        "Is it polite to be late in your country?",
        "Do you give up your seat on the bus?",
        "What table manners did your parents teach you?",
        "How do people greet each other where you live?",
        "Is it rude to use your phone at dinner?",
        "Do you say please and thank you often?",
        "What behaviour annoys you in public?",
        "How do you politely end a conversation?",
        "What is considered rude in your culture but normal elsewhere?",
      ],
      hard: [
        "Are manners disappearing or just changing?",
        "Is politeness sometimes dishonest?",
        "Should schools teach manners, or is that the family's job?",
        "Who decides what is rude when two cultures disagree?",
        "Is it better to be honest or to be kind?",
        "Has the internet made people ruder in real life?",
        "Should service staff have to be polite to rude customers?",
        "Is punctuality a moral question or just a habit?",
        "Do formal manners protect people or keep them at a distance?",
        "What one rule of politeness would you make universal?",
      ],
    },
  },
  {
    day: 47,
    topic: "Weddings & Big Days 💍",
    imageKeywords: [
      "bride adjusting dress mirror",
      "guests throwing confetti",
      "hands exchanging rings close up",
      "long table outdoor celebration",
      "grandparents dancing wedding"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Ceremony", meaning: "A formal event with traditions", meaningAZ: "Ənənələrlə keçirilən rəsmi mərasim", meaningTR: "Geleneklerle yapılan resmî tören", example: "The ceremony lasted half an hour." },
      { word: "Guest", meaning: "A person invited to an event", meaningAZ: "Tədbirə dəvət olunan şəxs", meaningTR: "Etkinliğe davet edilen kişi", example: "There were three hundred guests." },
      { word: "Bride", meaning: "The woman getting married", meaningAZ: "Evlənən qadın, gəlin", meaningTR: "Evlenen kadın, gelin", example: "The bride arrived late, of course." },
      { word: "Groom", meaning: "The man getting married", meaningAZ: "Evlənən kişi, bəy", meaningTR: "Evlenen erkek, damat", example: "The groom could not stop smiling." },
      { word: "Toast", meaning: "A short speech before drinking together", meaningAZ: "Birlikdə içməzdən əvvəl deyilən qısa nitq, sağlıq", meaningTR: "Birlikte içmeden önce yapılan kısa konuşma", example: "His toast made everyone cry." },
      { word: "Engaged", meaning: "Having agreed to marry", meaningAZ: "Nişanlı, evlənməyə söz vermiş", meaningTR: "Nişanlı, evlenmeye söz vermiş", example: "They got engaged in winter." },
      { word: "Anniversary", meaning: "The yearly date of an important event", meaningAZ: "Mühüm hadisənin illik tarixi", meaningTR: "Önemli bir olayın yıl dönümü", example: "It is their tenth anniversary." },
      { word: "Tradition", meaning: "A custom passed down over time", meaningAZ: "Nəsillərdən keçən adət", meaningTR: "Kuşaktan kuşağa geçen gelenek", example: "That dance is an old tradition." },
    ],
    idioms: [
      { phrase: "Tie the knot", meaning: "To get married", meaningAZ: "Evlənmək", meaningTR: "Evlenmek, dünya evine girmek", example: "They tied the knot last spring." },
      { phrase: "Steal the show", meaning: "To get all the attention", meaningAZ: "Bütün diqqəti üzərinə çəkmək", meaningTR: "Tüm dikkati üstüne çekmek", example: "The little girl stole the show." },
      { phrase: "Go off without a hitch", meaning: "To happen with no problems", meaningAZ: "Heç bir problemsiz keçmək", meaningTR: "Hiçbir aksilik olmadan geçmek", example: "The whole day went off without a hitch." },
    ],
    questions: {
      easy: [
        "Have you been to a wedding recently?",
        "What do people wear to weddings in your country?",
        "What food is served at celebrations where you live?",
        "Do you like dancing at parties?",
        "How many guests is normal at a wedding in your culture?",
        "What music is always played at celebrations?",
        "Do you enjoy big events or small gatherings?",
        "What was the best celebration you attended?",
        "Do people give money or gifts at weddings?",
        "What tradition from your culture would surprise a foreigner?",
      ],
      hard: [
        "Are expensive weddings worth the money?",
        "Should families have a say in who someone marries?",
        "Has marriage lost its meaning, or changed its meaning?",
        "Should a couple share all debts and money after marriage?",
        "Is a big celebration for the couple or for the families?",
        "Should traditions be kept even when nobody remembers why?",
        "Is it acceptable to go into debt for one day?",
        "How do you decide which family's traditions to follow?",
        "Should weddings be posted on social media?",
        "What would a meaningful wedding look like with almost no money?",
      ],
    },
  },
  {
    day: 48,
    topic: "Street Life & Markets 🛒",
    imageKeywords: [
      "market seller weighing vegetables",
      "street musician playing evening",
      "steam from street food stall",
      "old man selling flowers corner",
      "crowded bazaar colourful spices"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Stall", meaning: "A small open shop in a market", meaningAZ: "Bazarda kiçik açıq satış yeri", meaningTR: "Pazardaki küçük açık tezgâh", example: "Her stall sells only cheese." },
      { word: "Bargain", meaning: "To argue about a price", meaningAZ: "Qiymətə görə sövdələşmək", meaningTR: "Fiyat için pazarlık etmek", example: "You are expected to bargain here." },
      { word: "Vendor", meaning: "A person selling things", meaningAZ: "Satıcı", meaningTR: "Satıcı", example: "The vendor gave us an extra apple." },
      { word: "Fresh", meaning: "Recently produced or picked", meaningAZ: "Təzə, yeni dərilmiş", meaningTR: "Taze, yeni toplanmış", example: "The bread is still fresh and warm." },
      { word: "Busker", meaning: "A musician who plays in the street for money", meaningAZ: "Küçədə pul üçün ifa edən musiqiçi", meaningTR: "Sokakta para için çalan müzisyen", example: "A busker played outside the station." },
      { word: "Crowded", meaning: "Full of people", meaningAZ: "İzdihamlı, adamla dolu", meaningTR: "Kalabalık, insan dolu", example: "The market is crowded on Saturdays." },
      { word: "Rip off", meaning: "To charge far too much", meaningAZ: "Həddən artıq baha satmaq, aldatmaq", meaningTR: "Fahiş fiyat isteyip kazıklamak", example: "Twenty for that? It's a rip off." },
      { word: "Local", meaning: "From the nearby area", meaningAZ: "Yerli, yaxın ərazidən olan", meaningTR: "Yerel, yakın bölgeden", example: "We only buy local honey." },
    ],
    idioms: [
      { phrase: "Drive a hard bargain", meaning: "To negotiate strongly", meaningAZ: "Qiymətdə sərt danışıq aparmaq", meaningTR: "Pazarlıkta sert davranmak", example: "She drives a hard bargain." },
      { phrase: "Go for a song", meaning: "To be sold very cheaply", meaningAZ: "Su qiymətinə satılmaq", meaningTR: "Çok ucuza gitmek", example: "The old table went for a song." },
      { phrase: "Word of mouth", meaning: "Information passed between people", meaningAZ: "Ağızdan-ağıza yayılan məlumat", meaningTR: "Ağızdan ağıza yayılan bilgi", example: "That stall became famous by word of mouth." },
    ],
    questions: {
      easy: [
        "Do you shop at markets or supermarkets?",
        "What is sold at the market near you?",
        "Do you bargain over prices?",
        "Have you ever bought street food?",
        "What is the busiest street in your city?",
        "Do you like street music?",
        "What do you buy fresh every week?",
        "Is there a shop you have used for years?",
        "What would a visitor find strange in your local market?",
        "Do you prefer shopping in person or online?",
      ],
      hard: [
        "Are traditional markets worth protecting when supermarkets are cheaper?",
        "Should street vendors need a licence?",
        "What does a city lose when small shops close?",
        "Is bargaining fairer than fixed prices, or does it punish the shy?",
        "Should street performers be allowed anywhere?",
        "Do tourists save local markets or destroy them?",
        "Is it possible to buy only local food in a modern city?",
        "Should cities give cheap space to small traders?",
        "What does street life tell you about a country that statistics cannot?",
        "Will physical shops exist in thirty years?",
      ],
    },
  },
  {
    day: 49,
    topic: "The Sea & Rivers 🌊",
    imageKeywords: [
      "fisherman pulling net boat",
      "children jumping into river",
      "waves hitting rocks spray",
      "old harbour boats sunset",
      "person swimming open water"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Shore", meaning: "The land at the edge of water", meaningAZ: "Suyun kənarındakı quru, sahil", meaningTR: "Suyun kıyısındaki kara, sahil", example: "We walked along the shore." },
      { word: "Tide", meaning: "The rise and fall of the sea", meaningAZ: "Dənizin qalxıb-enməsi", meaningTR: "Denizin yükselip alçalması", example: "The tide comes in fast here." },
      { word: "Current", meaning: "Water moving in one direction", meaningAZ: "Bir istiqamətdə axan su, cərəyan", meaningTR: "Tek yöne akan su, akıntı", example: "The current is stronger than it looks." },
      { word: "Harbour", meaning: "A safe place where boats stay", meaningAZ: "Qayıqların dayandığı təhlükəsiz yer, liman", meaningTR: "Teknelerin durduğu güvenli yer, liman", example: "Three boats left the harbour at dawn." },
      { word: "Drown", meaning: "To die under water", meaningAZ: "Suda boğulmaq", meaningTR: "Suda boğulmak", example: "Never swim alone — people drown every summer." },
      { word: "Float", meaning: "To stay on the surface of water", meaningAZ: "Suyun üzündə qalmaq", meaningTR: "Suyun yüzeyinde kalmak", example: "Just relax and float." },
      { word: "Bank", meaning: "The land along a river", meaningAZ: "Çayın kənarındakı torpaq, sahil", meaningTR: "Nehrin kenarındaki kara, kıyı", example: "We sat on the river bank." },
      { word: "Catch", meaning: "The fish taken in one trip", meaningAZ: "Bir səfərdə tutulan balıq", meaningTR: "Bir seferde tutulan balık", example: "It was a poor catch that morning." },
    ],
    idioms: [
      { phrase: "Go with the flow", meaning: "To accept how things develop", meaningAZ: "Axına uyğun getmək, vəziyyəti qəbul etmək", meaningTR: "Akışına bırakmak", example: "Plans changed, so we went with the flow." },
      { phrase: "Plenty more fish in the sea", meaning: "There are other opportunities or people", meaningAZ: "Dünya bir nəfərdən ibarət deyil, başqa imkanlar var", meaningTR: "Denizde başka balık çok, başka fırsatlar var", example: "Forget him — plenty more fish in the sea." },
      { phrase: "In deep water", meaning: "In serious trouble", meaningAZ: "Ciddi çətinlikdə olmaq", meaningTR: "Başı ciddi dertte olmak", example: "After the audit they were in deep water." },
    ],
    questions: {
      easy: [
        "Can you swim? Where did you learn?",
        "Do you prefer the sea or a river?",
        "When did you last go to the beach?",
        "Have you ever been on a boat?",
        "Do you like eating fish?",
        "Is there water near your city?",
        "Do you feel calm near the sea?",
        "Have you ever been fishing?",
        "What do you take to the beach?",
        "Would you like to live by the water?",
      ],
      hard: [
        "Should every child be taught to swim?",
        "Who owns a beach — the public, the hotel, or the state?",
        "Is fishing as a sport acceptable?",
        "How should countries share a river that crosses borders?",
        "Should tourists pay a fee to protect a coastline?",
        "Is it too late to clean the sea?",
        "Are small fishing communities worth saving with public money?",
        "Should dangerous beaches be closed or should people decide for themselves?",
        "Why does water calm people?",
        "What would your region lose first if its water disappeared?",
      ],
    },
  },
  {
    day: 50,
    topic: "Working Late & Night Shifts 🌃",
    imageKeywords: [
      "office window lit at night",
      "nurse in corridor night shift",
      "security guard monitors screens",
      "taxi driver waiting late",
      "person asleep on desk"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Shift", meaning: "A period of work in the day", meaningAZ: "Günün müəyyən iş vaxtı, növbə", meaningTR: "Günün belirli çalışma dilimi, vardiya", example: "My shift ends at six in the morning." },
      { word: "Overtime", meaning: "Extra hours worked", meaningAZ: "Əlavə iş saatları", meaningTR: "Fazla mesai", example: "He does overtime every weekend." },
      { word: "Exhausted", meaning: "Extremely tired", meaningAZ: "Tamam yorğun, taqətsiz", meaningTR: "Bitkin, çok yorgun", example: "I was exhausted by Friday." },
      { word: "Deadline", meaning: "The time by which work must be done", meaningAZ: "İşin bitməli olduğu son vaxt", meaningTR: "İşin bitmesi gereken son zaman", example: "The deadline moved to Monday." },
      { word: "Burnout", meaning: "Exhaustion caused by long stress", meaningAZ: "Uzun stresin yaratdığı tükənmişlik", meaningTR: "Uzun stresin yol açtığı tükenmişlik", example: "Two of them left with burnout." },
      { word: "Nap", meaning: "A short sleep", meaningAZ: "Qısa yuxu", meaningTR: "Kısa uyku, şekerleme", example: "A twenty-minute nap saves me." },
      { word: "On call", meaning: "Ready to work if needed", meaningAZ: "Lazım olsa işə çağırıla bilən vəziyyətdə", meaningTR: "Gerekirse çağrılmaya hazır durumda", example: "She is on call this weekend." },
      { word: "Cover", meaning: "To do someone else's work while they are away", meaningAZ: "Başqasının işini onun əvəzinə görmək", meaningTR: "Birinin yerine onun işini yapmak", example: "Can you cover my shift on Thursday?" },
    ],
    idioms: [
      { phrase: "Burn the midnight oil", meaning: "To work very late", meaningAZ: "Gecə yarısına qədər işləmək", meaningTR: "Gece geç saatlere kadar çalışmak", example: "She burned the midnight oil before the exam." },
      { phrase: "Call it a day", meaning: "To stop working for now", meaningAZ: "İşi bugünlük bitirmək", meaningTR: "İşi bugünlük bitirmek", example: "It's late — let's call it a day." },
      { phrase: "Run on empty", meaning: "To continue with no energy left", meaningAZ: "Enerjisi bitsə də davam etmək", meaningTR: "Enerjisi bittiği hâlde devam etmek", example: "By Friday I am running on empty." },
    ],
    questions: {
      easy: [
        "Do you work better in the morning or at night?",
        "Have you ever worked at night?",
        "What time do you usually go to bed?",
        "Do you take naps?",
        "What do you drink to stay awake?",
        "Have you ever stayed up all night for work or study?",
        "Which jobs in your city work at night?",
        "How do you relax after a long day?",
        "Do you check messages after work hours?",
        "What helps you sleep well?",
      ],
      hard: [
        "Should night work be paid much more than day work?",
        "Is it healthy for a society to run twenty-four hours?",
        "Should employers be banned from contacting staff after work hours?",
        "Is burnout the worker's problem or the company's?",
        "Would a four-day week actually work in your industry?",
        "Do people work long hours for money or for identity?",
        "Should hospitals limit how long a doctor can work without sleep?",
        "Is being 'always available' a new kind of poverty?",
        "How do you know when a job is costing more than it pays?",
        "What would you change about how your country works?",
      ],
    },
  },
  {
    day: 51,
    topic: "Growing Older 👵",
    imageKeywords: [
      "wrinkled hands holding cup",
      "elderly couple walking park",
      "grandmother teaching child",
      "old man laughing with friends",
      "birthday candles many years"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Retire", meaning: "To stop working at the end of a career", meaningAZ: "Karyeranın sonunda işi dayandırmaq, təqaüdə çıxmaq", meaningTR: "Kariyer sonunda çalışmayı bırakmak, emekli olmak", example: "He retired at sixty-five." },
      { word: "Pension", meaning: "Money paid regularly after you retire", meaningAZ: "Təqaüdə çıxandan sonra müntəzəm ödənilən pul", meaningTR: "Emeklilikten sonra düzenli ödenen para", example: "Her pension is not enough." },
      { word: "Wrinkle", meaning: "A line in the skin from age", meaningAZ: "Yaşla dəridə yaranan qırışıq", meaningTR: "Yaşla ciltte oluşan kırışıklık", example: "He has laughter wrinkles around his eyes." },
      { word: "Generation", meaning: "All people born around the same time", meaningAZ: "Təxminən eyni vaxtda doğulan insanlar, nəsil", meaningTR: "Yaklaşık aynı dönemde doğan insanlar, kuşak", example: "My generation grew up without phones." },
      { word: "Wisdom", meaning: "Good judgement gained from experience", meaningAZ: "Təcrübədən gələn müdriklik", meaningTR: "Deneyimden gelen bilgelik", example: "There is wisdom in waiting." },
      { word: "Care home", meaning: "A place where older people are looked after", meaningAZ: "Yaşlılara qulluq edilən yer", meaningTR: "Yaşlıların bakıldığı yer", example: "He refused to move to a care home." },
      { word: "Memory loss", meaning: "Difficulty remembering things", meaningAZ: "Yadda saxlamada çətinlik", meaningTR: "Hatırlamada güçlük", example: "Memory loss frightened her more than pain." },
      { word: "Respect elders", meaning: "To treat older people with honour", meaningAZ: "Yaşlılara hörmətlə yanaşmaq", meaningTR: "Yaşlılara saygıyla davranmak", example: "Children here are taught to respect elders." },
    ],
    idioms: [
      { phrase: "Over the hill", meaning: "Too old for something", meaningAZ: "Bir şey üçün yaşı ötmüş", meaningTR: "Bir şey için yaşı geçmiş", example: "At forty he joked he was over the hill." },
      { phrase: "Young at heart", meaning: "Old in years but lively in spirit", meaningAZ: "Yaşca böyük, ruhca cavan", meaningTR: "Yaşça büyük, ruhça genç", example: "My grandfather is eighty and young at heart." },
      { phrase: "Act your age", meaning: "Behave in a way suitable for your age", meaningAZ: "Yaşına uyğun davran", meaningTR: "Yaşına uygun davran", example: "Stop jumping on the sofa and act your age." },
    ],
    questions: {
      easy: [
        "Who is the oldest person in your family?",
        "What did your grandparents teach you?",
        "At what age do people retire in your country?",
        "Do you look forward to getting older?",
        "What do older people do for fun where you live?",
        "Do you live near your parents?",
        "What advice did an older person give you?",
        "Do you think you look your age?",
        "What would you like to be doing at seventy?",
        "Who do older people in your family live with?",
      ],
      hard: [
        "Should adult children be legally responsible for their parents?",
        "Is a care home a failure of the family or a practical solution?",
        "Should there be an upper age limit for driving, or for leading a country?",
        "Does society waste the experience of older people?",
        "Would you want to live to a hundred if your health allowed it?",
        "Should retirement age rise as people live longer?",
        "Is the fear of ageing created or sold to us?",
        "How should a country pay for a population that keeps getting older?",
        "What does your culture get right about old age that others do not?",
        "What do you hope someone says about you at eighty?",
      ],
    },
  },
  {
    day: 52,
    topic: "Moving House 📦",
    imageKeywords: [
      "cardboard boxes empty room",
      "family carrying sofa stairs",
      "keys handed over doorway",
      "person taping box tired",
      "empty room sunlight floor"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Move out", meaning: "To leave a home you lived in", meaningAZ: "Yaşadığın evdən çıxmaq", meaningTR: "Oturduğun evden çıkmak", example: "We move out at the end of the month." },
      { word: "Deposit", meaning: "Money left with the owner as security", meaningAZ: "Ev sahibinə təminat kimi qoyulan pul", meaningTR: "Ev sahibine güvence olarak bırakılan para", example: "We never got the deposit back." },
      { word: "Furniture", meaning: "Tables, beds, chairs in a home", meaningAZ: "Evdəki masa, çarpayı, stul — mebel", meaningTR: "Evdeki masa, yatak, sandalye — mobilya", example: "The flat came with furniture." },
      { word: "Pack", meaning: "To put things into boxes or bags", meaningAZ: "Əşyaları qutulara yığmaq", meaningTR: "Eşyaları kutulara yerleştirmek", example: "I packed the kitchen in one night." },
      { word: "Settle in", meaning: "To get comfortable in a new place", meaningAZ: "Yeni yerdə rahatlaşmaq, alışmaq", meaningTR: "Yeni yere alışmak, yerleşmek", example: "It took a month to settle in." },
      { word: "Rent", meaning: "Money paid monthly for a home", meaningAZ: "Ev üçün aylıq ödənilən kirayə", meaningTR: "Ev için aylık ödenen kira", example: "Rent went up twice this year." },
      { word: "Storage", meaning: "A place to keep things you cannot take", meaningAZ: "Apara bilmədiyin əşyaların saxlandığı yer", meaningTR: "Götüremediğin eşyaların saklandığı yer", example: "Half our things are still in storage." },
      { word: "Declutter", meaning: "To remove things you do not need", meaningAZ: "Lazımsız əşyalardan qurtulmaq", meaningTR: "Gereksiz eşyalardan kurtulmak", example: "Moving forces you to declutter." },
    ],
    idioms: [
      { phrase: "Put down roots", meaning: "To settle permanently somewhere", meaningAZ: "Bir yerdə həmişəlik yerləşmək", meaningTR: "Bir yere kalıcı olarak yerleşmek", example: "After ten years they put down roots here." },
      { phrase: "A fresh start", meaning: "A new beginning", meaningAZ: "Təzə başlanğıc", meaningTR: "Yeni bir başlangıç", example: "The move gave them a fresh start." },
      { phrase: "Home sweet home", meaning: "Said with relief on returning home", meaningAZ: "Evə qayıdanda deyilən rahatlıq sözü", meaningTR: "Eve dönünce söylenen rahatlama sözü", example: "Two weeks away — home sweet home." },
    ],
    questions: {
      easy: [
        "How many times have you moved house?",
        "Do you like your current home?",
        "What is the hardest part of moving?",
        "Who helps you when you move?",
        "What would you never throw away?",
        "Do you rent or own your home?",
        "How long did it take to feel at home there?",
        "What is the first thing you unpack?",
        "Have you ever lived in another city?",
        "What does 'home' mean to you?",
      ],
      hard: [
        "Should young people be able to afford to buy a home?",
        "Is renting for life acceptable, or does a society need owners?",
        "Should landlords be limited in how much they can raise rent?",
        "Does moving often make a person more open or less attached?",
        "Is it better for children to stay in one place their whole childhood?",
        "Should empty second homes be taxed heavily?",
        "What makes a house become a home?",
        "Would you move abroad permanently for a better life?",
        "Is owning fewer things a real freedom or a fashion?",
        "Who is responsible for housing: the market or the state?",
      ],
    },
  },
  {
    day: 53,
    topic: "Crafts & Handmade Things 🧶",
    imageKeywords: [
      "hands knitting wool close up",
      "potter shaping clay wheel",
      "carpenter sanding wood dust",
      "sewing machine fabric hands",
      "handmade jewellery workbench"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Handmade", meaning: "Made by hand, not by machine", meaningAZ: "Maşınla yox, əllə düzəldilmiş", meaningTR: "Makineyle değil, elle yapılmış", example: "Every bowl here is handmade." },
      { word: "Craft", meaning: "A skill of making things with your hands", meaningAZ: "Əl ilə bir şey düzəltmə bacarığı, sənət", meaningTR: "Elle bir şey yapma becerisi, zanaat", example: "Weaving is an old craft." },
      { word: "Pattern", meaning: "A repeated design", meaningAZ: "Təkrarlanan naxış", meaningTR: "Tekrarlanan desen", example: "The pattern comes from her village." },
      { word: "Workshop", meaning: "A room where things are made", meaningAZ: "Əşyaların hazırlandığı emalatxana", meaningTR: "Eşyaların yapıldığı atölye", example: "His workshop smells of wood." },
      { word: "Apprentice", meaning: "Someone learning a trade from an expert", meaningAZ: "Ustadan sənət öyrənən şagird", meaningTR: "Ustadan zanaat öğrenen çırak", example: "He started as an apprentice at sixteen." },
      { word: "Imperfect", meaning: "Having small faults", meaningAZ: "Kiçik qüsurları olan", meaningTR: "Küçük kusurları olan", example: "Handmade things are beautifully imperfect." },
      { word: "Patience", meaning: "The ability to wait calmly", meaningAZ: "Sakit gözləyə bilmə bacarığı, səbir", meaningTR: "Sakin bekleyebilme yeteneği, sabır", example: "This work needs patience more than talent." },
      { word: "Mass-produced", meaning: "Made in large quantities by machine", meaningAZ: "Maşınla kütləvi istehsal olunmuş", meaningTR: "Makineyle seri üretilmiş", example: "It looks handmade but it is mass-produced." },
    ],
    idioms: [
      { phrase: "A labour of love", meaning: "Work done for pleasure, not money", meaningAZ: "Pul üçün yox, sevgi ilə görülən iş", meaningTR: "Para için değil, sevgiyle yapılan iş", example: "The whole quilt was a labour of love." },
      { phrase: "Learn the ropes", meaning: "To learn how something is done", meaningAZ: "İşin qaydasını öyrənmək", meaningTR: "İşin nasıl yapıldığını öğrenmek", example: "Give him a month to learn the ropes." },
      { phrase: "Made to last", meaning: "Built to survive many years", meaningAZ: "Uzun illər davam etsin deyə hazırlanmış", meaningTR: "Uzun yıllar dayansın diye yapılmış", example: "That chair was made to last." },
    ],
    questions: {
      easy: [
        "Can you make anything with your hands?",
        "Did anyone in your family sew or build things?",
        "Do you own something handmade?",
        "What craft would you like to learn?",
        "Is handmade better than factory-made?",
        "Have you ever given a handmade gift?",
        "What traditional crafts exist in your country?",
        "Do you have patience for slow work?",
        "What is the most beautiful object in your home?",
        "Would you pay more for something handmade?",
      ],
      hard: [
        "Are traditional crafts worth saving if nobody buys them?",
        "Should governments pay craftspeople to keep old skills alive?",
        "Has 'handmade' become a marketing word rather than a fact?",
        "Is there real value in an imperfect object?",
        "Do machines make better products than people?",
        "Should schools teach a craft to every student?",
        "Why do people who work on screens want to work with their hands?",
        "Can a craft survive if the young leave the village?",
        "Is selling a traditional design to a big brand a betrayal?",
        "What skill would disappear if your grandparents' generation did not pass it on?",
      ],
    },
  },
  {
    day: 54,
    topic: "News & Rumours 📰",
    imageKeywords: [
      "people reading newspapers cafe",
      "journalist microphones press conference",
      "two women whispering street",
      "breaking news screen glow",
      "stack of old newspapers"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Headline", meaning: "The title of a news story", meaningAZ: "Xəbərin başlığı", meaningTR: "Haberin başlığı", example: "The headline said more than the article." },
      { word: "Source", meaning: "Where information comes from", meaningAZ: "Məlumatın gəldiyi mənbə", meaningTR: "Bilginin geldiği kaynak", example: "Always check the source." },
      { word: "Rumour", meaning: "A story passed around that may be untrue", meaningAZ: "Doğru olmaya bilən yayılmış söz-söhbət", meaningTR: "Doğru olmayabilecek yayılmış söylenti", example: "It was only a rumour." },
      { word: "Biased", meaning: "Unfairly favouring one side", meaningAZ: "Bir tərəfi ədalətsiz şəkildə dəstəkləyən", meaningTR: "Bir tarafı haksızca tutan, taraflı", example: "That channel is openly biased." },
      { word: "Eyewitness", meaning: "A person who saw an event", meaningAZ: "Hadisəni öz gözü ilə görən şəxs", meaningTR: "Olayı kendi gözüyle gören kişi", example: "An eyewitness described the crash." },
      { word: "Spread", meaning: "To travel quickly from person to person", meaningAZ: "Adamdan-adama sürətlə yayılmaq", meaningTR: "Kişiden kişiye hızla yayılmak", example: "The story spread in hours." },
      { word: "Censor", meaning: "To block information from being published", meaningAZ: "Məlumatın yayılmasının qarşısını almaq", meaningTR: "Bilginin yayımlanmasını engellemek", example: "The report was censored." },
      { word: "Gossip", meaning: "Talk about other people's private lives", meaningAZ: "Başqalarının şəxsi həyatı barədə söhbət, qeybət", meaningTR: "Başkalarının özel hayatı hakkında dedikodu", example: "The office runs on gossip." },
    ],
    idioms: [
      { phrase: "Take it with a pinch of salt", meaning: "Do not fully believe it", meaningAZ: "Tam inanma, şübhə ilə yanaş", meaningTR: "Tamamen inanma, şüpheyle yaklaş", example: "Take his version with a pinch of salt." },
      { phrase: "The talk of the town", meaning: "What everyone is discussing", meaningAZ: "Hamının danışdığı mövzu", meaningTR: "Herkesin konuştuğu konu", example: "The new café is the talk of the town." },
      { phrase: "Break the news", meaning: "To tell someone something important first", meaningAZ: "Mühüm xəbəri ilk dəfə çatdırmaq", meaningTR: "Önemli haberi ilk kez iletmek", example: "Nobody wanted to break the news to her." },
    ],
    questions: {
      easy: [
        "Where do you get your news?",
        "Do you read newspapers?",
        "How often do you check the news?",
        "Do you talk about the news with friends?",
        "Do you trust what you read online?",
        "What kind of news do you avoid?",
        "Do you follow news from other countries?",
        "Has a rumour about you ever been wrong?",
        "Do you share news articles with people?",
        "What was the last big story in your country?",
      ],
      hard: [
        "Can news ever be completely neutral?",
        "Should social media companies decide what is true?",
        "Is too much news bad for mental health?",
        "Should journalists be allowed to protect their sources always?",
        "Who should pay for serious journalism?",
        "Is gossip harmless or a form of damage?",
        "Should a person be able to remove old news about themselves from the internet?",
        "Do people want the truth or a story that fits their beliefs?",
        "Is a free press possible in every country?",
        "How would you check whether a shocking story is real?",
      ],
    },
  },
  {
    day: 55,
    topic: "Speed & Thrills 🎢",
    imageKeywords: [
      "rollercoaster riders screaming",
      "skateboarder mid air",
      "motorbike leaning fast corner",
      "person bungee jumping bridge",
      "sprinter starting blocks"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Thrill", meaning: "A sudden feeling of excitement", meaningAZ: "Qəfil həyəcan hissi", meaningTR: "Ani heyecan duygusu", example: "The drop gives you a real thrill." },
      { word: "Adrenaline", meaning: "The chemical your body makes when excited or afraid", meaningAZ: "Həyəcan və qorxu anında bədənin ifraz etdiyi maddə", meaningTR: "Heyecan ya da korku anında vücudun salgıladığı madde", example: "Adrenaline kept him going." },
      { word: "Reckless", meaning: "Taking dangerous risks without thinking", meaningAZ: "Düşünmədən təhlükəli risk edən", meaningTR: "Düşünmeden tehlikeli risk alan", example: "Reckless driving caused it." },
      { word: "Dare", meaning: "To challenge someone to do something risky", meaningAZ: "Kimisə riskli işə çağırmaq", meaningTR: "Birine riskli bir şey yapmaya meydan okumak", example: "They dared him to jump." },
      { word: "Helmet", meaning: "Hard protection for the head", meaningAZ: "Baş üçün bərk qoruyucu, dəbilqə", meaningTR: "Baş için sert koruyucu, kask", example: "No helmet, no ride." },
      { word: "Speed limit", meaning: "The fastest legal speed", meaningAZ: "İcazə verilən maksimal sürət", meaningTR: "İzin verilen azami hız", example: "He was twenty over the speed limit." },
      { word: "Terrified", meaning: "Extremely frightened", meaningAZ: "Həddən artıq qorxmuş", meaningTR: "Aşırı derecede korkmuş", example: "I was terrified and laughing at once." },
      { word: "Rush", meaning: "A strong sudden feeling of energy", meaningAZ: "Qəfil güclü enerji hissi", meaningTR: "Ani ve güçlü bir enerji hissi", example: "The first jump is the best rush." },
    ],
    idioms: [
      { phrase: "Live on the edge", meaning: "To live in a risky way", meaningAZ: "Riskli həyat sürmək", meaningTR: "Riskli bir hayat yaşamak", example: "He lives on the edge every weekend." },
      { phrase: "Take the plunge", meaning: "To finally do something frightening", meaningAZ: "Nəhayət qorxduğun addımı atmaq", meaningTR: "Sonunda korktuğun adımı atmak", example: "She took the plunge and quit her job." },
      { phrase: "Play it safe", meaning: "To avoid any risk", meaningAZ: "Riskdən tamamilə qaçmaq", meaningTR: "Hiç risk almamak", example: "I played it safe and took the train." },
    ],
    questions: {
      easy: [
        "Do you like rollercoasters?",
        "What is the fastest you have travelled?",
        "Are you afraid of heights?",
        "Have you ever done something dangerous for fun?",
        "Do you drive fast?",
        "What sport looks too scary to try?",
        "Would you try skydiving?",
        "What makes your heart beat faster?",
        "Do you prefer calm holidays or exciting ones?",
        "Have you ever been on a motorbike?",
      ],
      hard: [
        "Why do people pay money to feel afraid?",
        "Should extreme sports be insured by the person, not the public?",
        "Is risk-taking necessary for a full life?",
        "Should rescue teams charge people who ignore warnings?",
        "Do young men take more risks because of biology or culture?",
        "Should social media platforms be responsible for dangerous challenges?",
        "Is speed on the road a right or a privilege?",
        "Where is the line between brave and stupid?",
        "Has modern life become so safe that people invent danger?",
        "What risk have you taken that you would take again?",
      ],
    },
  },
  {
    day: 56,
    topic: "Farming & Where Food Comes From 🚜",
    imageKeywords: [
      "farmer hands holding soil",
      "tractor ploughing field dust",
      "cows in a barn morning",
      "greenhouse tomatoes rows",
      "harvest crates of apples"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Harvest", meaning: "The gathering of crops", meaningAZ: "Məhsulun yığılması", meaningTR: "Ürünün toplanması, hasat", example: "The harvest was late this year." },
      { word: "Crop", meaning: "A plant grown for food", meaningAZ: "Qida üçün becərilən bitki", meaningTR: "Gıda için yetiştirilen bitki", example: "Wheat is the main crop here." },
      { word: "Soil", meaning: "The earth plants grow in", meaningAZ: "Bitkilərin bitdiyi torpaq", meaningTR: "Bitkilerin yetiştiği toprak", example: "The soil is too dry." },
      { word: "Livestock", meaning: "Farm animals kept for food or work", meaningAZ: "Qida və ya iş üçün saxlanılan mal-qara", meaningTR: "Gıda ya da iş için beslenen çiftlik hayvanları", example: "They sold half the livestock." },
      { word: "Organic", meaning: "Grown without artificial chemicals", meaningAZ: "Süni kimyəvi maddələr olmadan becərilmiş", meaningTR: "Yapay kimyasallar olmadan yetiştirilmiş", example: "Organic food costs more here." },
      { word: "Drought", meaning: "A long period without rain", meaningAZ: "Uzun müddət yağış olmayan quraqlıq", meaningTR: "Uzun süre yağmur yağmaması, kuraklık", example: "The drought ruined two harvests." },
      { word: "Rural", meaning: "Belonging to the countryside", meaningAZ: "Kəndə aid olan", meaningTR: "Kırsala ait", example: "Rural schools are closing." },
      { word: "Supply chain", meaning: "The path food takes from farm to shop", meaningAZ: "Qidanın fermadan mağazaya gedən yolu", meaningTR: "Gıdanın çiftlikten mağazaya giden yolu", example: "The supply chain broke during the crisis." },
    ],
    idioms: [
      { phrase: "Reap what you sow", meaning: "You get the result of your actions", meaningAZ: "Nə əkirsənsə, onu da biçirsən", meaningTR: "Ne ekersen onu biçersin", example: "He never studied, so he reaped what he sowed." },
      { phrase: "Make hay while the sun shines", meaning: "Use a good opportunity quickly", meaningAZ: "Fürsət varkən istifadə et", meaningTR: "Fırsat varken değerlendir", example: "Orders are high — make hay while the sun shines." },
      { phrase: "Down to earth", meaning: "Practical and modest", meaningAZ: "Sadə, ayaqları yerdə olan", meaningTR: "Sade, ayakları yere basan", example: "She is famous but completely down to earth." },
    ],
    questions: {
      easy: [
        "Have you ever visited a farm?",
        "Do you know where your food is grown?",
        "Do you grow anything at home?",
        "What fruit grows in your region?",
        "Do you buy organic food?",
        "Have you ever picked fruit or vegetables?",
        "Do you have relatives in the countryside?",
        "What animal would you keep if you had land?",
        "What food is your region famous for?",
        "Do you waste food at home?",
      ],
      hard: [
        "Should countries be able to feed themselves?",
        "Is cheap food worth its real cost?",
        "Should farmers be paid to protect nature rather than to produce more?",
        "Is large-scale farming compatible with animal welfare?",
        "Should supermarkets be forced to give away unsold food?",
        "Would you pay double for food if farmers earned properly?",
        "Is rural life disappearing, and does it matter?",
        "Should meat be taxed like tobacco?",
        "Who should own farmland — families, companies or the state?",
        "What would your country eat if imports stopped tomorrow?",
      ],
    },
  },
  {
    day: 57,
    topic: "Old & Second-hand Things 🕰️",
    imageKeywords: [
      "flea market old objects table",
      "dusty pocket watch hands",
      "second hand bookshop shelves",
      "vintage car being polished",
      "inherited jewellery box open"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Antique", meaning: "An old and valuable object", meaningAZ: "Köhnə və dəyərli əşya", meaningTR: "Eski ve değerli nesne", example: "That clock is a real antique." },
      { word: "Second-hand", meaning: "Owned by someone before you", meaningAZ: "Səndən əvvəl başqasına məxsus olmuş", meaningTR: "Senden önce başkasının kullandığı", example: "All my furniture is second-hand." },
      { word: "Inherit", meaning: "To receive something from someone who died", meaningAZ: "Vəfat edən adamdan miras almaq", meaningTR: "Vefat eden birinden miras almak", example: "She inherited the house from her aunt." },
      { word: "Vintage", meaning: "From an earlier period and admired", meaningAZ: "Keçmiş dövrə aid, dəyər verilən", meaningTR: "Eski döneme ait, beğenilen", example: "He collects vintage cameras." },
      { word: "Worth", meaning: "The value of something", meaningAZ: "Bir şeyin dəyəri", meaningTR: "Bir şeyin değeri", example: "Nobody knows what it is worth." },
      { word: "Dusty", meaning: "Covered in dust", meaningAZ: "Toz basmış", meaningTR: "Tozla kaplanmış", example: "The attic was full of dusty boxes." },
      { word: "Restore", meaning: "To return something to its old condition", meaningAZ: "Əvvəlki vəziyyətinə qaytarmaq, bərpa etmək", meaningTR: "Eski hâline döndürmek, restore etmek", example: "He restored the chair himself." },
      { word: "Keepsake", meaning: "A small object kept to remember someone", meaningAZ: "Kimisə xatırlamaq üçün saxlanan kiçik əşya", meaningTR: "Birini hatırlamak için saklanan küçük eşya", example: "The ring is a keepsake from my mother." },
    ],
    idioms: [
      { phrase: "One man's trash is another man's treasure", meaning: "What one person throws away another values", meaningAZ: "Birinin atdığı, başqası üçün qiymətlidir", meaningTR: "Birinin attığı, başkası için değerlidir", example: "He found it in a skip — one man's trash is another man's treasure." },
      { phrase: "Gather dust", meaning: "To stay unused for a long time", meaningAZ: "Uzun müddət işlənmədən qalmaq", meaningTR: "Uzun süre kullanılmadan durmak", example: "The guitar just gathers dust." },
      { phrase: "Stand the test of time", meaning: "To remain good over many years", meaningAZ: "İllər keçsə də dəyərini itirməmək", meaningTR: "Yıllar geçse de değerini yitirmemek", example: "That design has stood the test of time." },
    ],
    questions: {
      easy: [
        "Do you buy second-hand things?",
        "What is the oldest object you own?",
        "Have you inherited anything from your family?",
        "Do you like old markets?",
        "Is there something you keep but never use?",
        "Do you prefer new or old furniture?",
        "Have you ever sold something used?",
        "What object reminds you of a person?",
        "Do you throw things away easily?",
        "Would you wear second-hand clothes?",
      ],
      hard: [
        "Why do we give objects emotional value?",
        "Is buying second-hand a moral choice or just a cheaper one?",
        "Should families keep possessions or let them go?",
        "Who should own historical objects taken from other countries?",
        "Is it wrong to sell something that was a gift?",
        "Does owning fewer things make people happier?",
        "Should there be a tax on throwing away repairable goods?",
        "Is nostalgia for old products just marketing?",
        "What should happen to a person's things after they die?",
        "What object of yours would you want kept for a hundred years?",
      ],
    },
  },
  {
    day: 58,
    topic: "Art & Museums 🖼️",
    imageKeywords: [
      "visitor looking at painting alone",
      "child drawing on pavement",
      "sculptor working marble dust",
      "street mural being painted",
      "museum hall light shadows"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Exhibition", meaning: "A public show of art", meaningAZ: "İncəsənət əsərlərinin ictimai sərgisi", meaningTR: "Sanat eserlerinin halka açık sergisi", example: "The exhibition closes on Sunday." },
      { word: "Masterpiece", meaning: "An artist's greatest work", meaningAZ: "Sənətkarın ən böyük əsəri", meaningTR: "Sanatçının en büyük eseri", example: "Everyone queues for one masterpiece." },
      { word: "Sculpture", meaning: "Art made in three dimensions", meaningAZ: "Üçölçülü sənət əsəri, heykəl", meaningTR: "Üç boyutlu sanat eseri, heykel", example: "The sculpture is made of scrap metal." },
      { word: "Canvas", meaning: "The cloth a painting is made on", meaningAZ: "Rəsmin çəkildiyi parça, kətan", meaningTR: "Resmin yapıldığı kumaş, tuval", example: "A huge blank canvas waited in the corner." },
      { word: "Gallery", meaning: "A place where art is shown or sold", meaningAZ: "İncəsənət nümayiş olunan və ya satılan yer", meaningTR: "Sanatın sergilendiği ya da satıldığı yer", example: "The gallery is free on Thursdays." },
      { word: "Abstract", meaning: "Not showing things realistically", meaningAZ: "Real görüntünü təsvir etməyən, mücərrəd", meaningTR: "Gerçekçi göstermeyen, soyut", example: "I don't understand abstract art." },
      { word: "Inspire", meaning: "To give someone an idea or energy to create", meaningAZ: "Yaratmaq üçün ilham vermək", meaningTR: "Yaratmak için ilham vermek", example: "That trip inspired the whole series." },
      { word: "Forgery", meaning: "A fake copy sold as real", meaningAZ: "Əsl kimi satılan saxta nüsxə", meaningTR: "Gerçek gibi satılan sahte kopya", example: "It turned out to be a forgery." },
    ],
    idioms: [
      { phrase: "Worth a thousand words", meaning: "An image says more than speech", meaningAZ: "Bir şəkil min sözə dəyər", meaningTR: "Bir resim bin söze bedeldir", example: "That photo is worth a thousand words." },
      { phrase: "Paint a picture", meaning: "To describe something vividly", meaningAZ: "Bir şeyi canlı şəkildə təsvir etmək", meaningTR: "Bir şeyi canlı biçimde anlatmak", example: "He painted a picture of life back then." },
      { phrase: "In the eye of the beholder", meaning: "Value depends on who is looking", meaningAZ: "Dəyər baxanın gözündədir", meaningTR: "Değer, bakanın gözündedir", example: "Beauty is in the eye of the beholder." },
    ],
    questions: {
      easy: [
        "Do you like visiting museums?",
        "Can you draw or paint?",
        "What is the last exhibition you saw?",
        "Do you have art in your home?",
        "Is there street art in your city?",
        "What colour do you like most?",
        "Did you enjoy art classes at school?",
        "Who is a famous artist from your country?",
        "Do you take photos as a hobby?",
        "What kind of art do you not understand?",
      ],
      hard: [
        "Should museums be free for everyone?",
        "Is graffiti art or damage?",
        "Can something made by AI be art?",
        "Should museums return objects to the countries they came from?",
        "Why is some art worth millions and other art worth nothing?",
        "Should governments fund artists?",
        "Does art need to be understood to be valuable?",
        "Is a photograph of a painting the same experience?",
        "Should art that offends people be shown publicly?",
        "What would a city be without any art in it?",
      ],
    },
  },
  {
    day: 59,
    topic: "Sharing Space & Roommates 🛋️",
    imageKeywords: [
      "messy shared kitchen sink dishes",
      "two friends on sofa laughing",
      "chore list on fridge",
      "shared bathroom queue morning",
      "people eating together small flat"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Roommate", meaning: "A person you share a home with", meaningAZ: "Evi birlikdə bölüşdüyün adam", meaningTR: "Evi paylaştığın kişi", example: "My roommate works nights." },
      { word: "Chore", meaning: "A regular task at home", meaningAZ: "Evdə müntəzəm görülən iş", meaningTR: "Evde düzenli yapılan iş", example: "We split the chores." },
      { word: "Tidy", meaning: "Neat and in order", meaningAZ: "Səliqəli, yerli-yerində", meaningTR: "Düzenli, yerli yerinde", example: "He is tidier than me." },
      { word: "Mess", meaning: "A dirty or untidy state", meaningAZ: "Səliqəsiz, dağınıq vəziyyət", meaningTR: "Dağınık ve kirli hâl", example: "The kitchen was a mess." },
      { word: "Split", meaning: "To divide something between people", meaningAZ: "Bir şeyi adamlar arasında bölmək", meaningTR: "Bir şeyi kişiler arasında bölüşmek", example: "We split the bills equally." },
      { word: "Privacy", meaning: "Being free from others watching", meaningAZ: "Başqalarının nəzarətindən azad olmaq, məxfilik", meaningTR: "Başkalarının gözünden uzak olma, mahremiyet", example: "In a shared flat privacy is rare." },
      { word: "Compromise", meaning: "An agreement where both sides give something", meaningAZ: "Hər iki tərəfin güzəştə getdiyi razılaşma", meaningTR: "İki tarafın da ödün verdiği anlaşma", example: "We reached a compromise about the music." },
      { word: "Passive-aggressive", meaning: "Showing anger indirectly", meaningAZ: "Qəzəbini dolayı yolla göstərən", meaningTR: "Öfkesini dolaylı yoldan gösteren", example: "The note on the fridge was passive-aggressive." },
    ],
    idioms: [
      { phrase: "Pull your weight", meaning: "To do your fair share of work", meaningAZ: "Öz payına düşən işi görmək", meaningTR: "Kendi payına düşen işi yapmak", example: "He never pulls his weight in the kitchen." },
      { phrase: "Get on someone's nerves", meaning: "To irritate someone", meaningAZ: "Kiminsə əsəbinə toxunmaq", meaningTR: "Birinin sinirine dokunmak", example: "The dripping tap gets on my nerves." },
      { phrase: "Clear the air", meaning: "To talk and remove tension", meaningAZ: "Danışıb gərginliyi aradan qaldırmaq", meaningTR: "Konuşup gerginliği gidermek", example: "One honest conversation cleared the air." },
    ],
    questions: {
      easy: [
        "Have you ever shared a flat with someone?",
        "Are you tidy or messy?",
        "Who does the cleaning in your home?",
        "What habit of others annoys you most?",
        "Do you like cooking for other people?",
        "Would you share a home with a stranger?",
        "How do you divide bills with others?",
        "Do you need quiet to sleep?",
        "What makes a good roommate?",
        "Have you ever argued about housework?",
      ],
      hard: [
        "Is sharing a home with strangers a normal stage of life or a sign of a housing problem?",
        "How should housework be divided fairly between people who earn differently?",
        "Should couples keep separate money?",
        "Is it possible to live with someone and keep real privacy?",
        "Why does washing-up cause more arguments than serious matters?",
        "Should young adults live with their parents longer to save money?",
        "Is it better to confront a problem immediately or wait?",
        "Do people reveal their true character only when sharing space?",
        "Should cities build more shared housing for single people?",
        "What one rule would make any shared home work?",
      ],
    },
  },
  {
    day: 60,
    topic: "Goodbyes & Reunions 👋",
    imageKeywords: [
      "family hugging airport arrivals",
      "hand waving from train window",
      "empty platform after departure",
      "soldier reunited with child",
      "friends embracing after years"
    ],
    manualImageUrls: [],
    vocabulary: [
      { word: "Farewell", meaning: "A goodbye, often formal", meaningAZ: "Vida, rəsmi sağollaşma", meaningTR: "Veda, resmî bir vedalaşma", example: "They held a farewell dinner." },
      { word: "Reunion", meaning: "A meeting after a long time apart", meaningAZ: "Uzun ayrılıqdan sonra görüş", meaningTR: "Uzun ayrılıktan sonra buluşma", example: "The school reunion was strange and lovely." },
      { word: "Homesick", meaning: "Sad because you are away from home", meaningAZ: "Evdən uzaq olduğu üçün darıxan", meaningTR: "Evden uzak olduğu için özlem çeken", example: "I was homesick for months." },
      { word: "Wave", meaning: "To move your hand in greeting", meaningAZ: "Salamlaşmaq üçün əl yelləmək", meaningTR: "Selamlamak için el sallamak", example: "She waved until the bus turned." },
      { word: "Emigrate", meaning: "To leave your country to live elsewhere", meaningAZ: "Başqa ölkədə yaşamaq üçün vətəni tərk etmək", meaningTR: "Başka ülkede yaşamak için ülkeyi terk etmek", example: "His brother emigrated in 2019." },
      { word: "Keep in touch", meaning: "To stay in contact", meaningAZ: "Əlaqəni kəsməmək", meaningTR: "İletişimi sürdürmek", example: "We promised to keep in touch." },
      { word: "Drift apart", meaning: "To slowly lose a friendship", meaningAZ: "Yavaş-yavaş uzaqlaşmaq", meaningTR: "Yavaş yavaş uzaklaşmak", example: "After university we drifted apart." },
      { word: "Bittersweet", meaning: "Happy and sad at the same time", meaningAZ: "Həm sevincli, həm kədərli", meaningTR: "Hem tatlı hem hüzünlü", example: "The last day was bittersweet." },
    ],
    idioms: [
      { phrase: "Say your goodbyes", meaning: "To take leave of people", meaningAZ: "Adamlarla sağollaşmaq", meaningTR: "İnsanlarla vedalaşmak", example: "Say your goodbyes, the taxi is here." },
      { phrase: "Absence makes the heart grow fonder", meaning: "Being apart increases affection", meaningAZ: "Ayrılıq sevgini artırır", meaningTR: "Ayrılık sevgiyi artırır", example: "A year apart — absence makes the heart grow fonder." },
      { phrase: "Part ways", meaning: "To separate and go in different directions", meaningAZ: "Ayrılıb fərqli yollara getmək", meaningTR: "Ayrılıp farklı yollara gitmek", example: "They parted ways after ten years together." },
    ],
    questions: {
      easy: [
        "Are you good at saying goodbye?",
        "Have you ever lived far from your family?",
        "Who do you miss most right now?",
        "Do you keep in touch with old school friends?",
        "Have you met someone again after many years?",
        "Do you cry at airports?",
        "How do you stay in contact with people abroad?",
        "What do you do on your last day somewhere?",
        "Has a friend moved away from you?",
        "What would you say to someone you will not see for years?",
      ],
      hard: [
        "Is it easier to be the one who leaves or the one who stays?",
        "Do video calls really keep a relationship alive?",
        "Should people move abroad for work if it separates families?",
        "Why do friendships end without an argument?",
        "Is it possible to return home after many years and belong again?",
        "Should you tell someone how you feel before they leave?",
        "What does a country lose when its young people emigrate?",
        "Are goodbyes easier now that everyone is reachable?",
        "Is it fair to ask someone to wait for you?",
        "What makes a reunion joyful for some and painful for others?",
      ],
    },
  },
];

// The current topic index. It now comes from the server-driven global cycle
// (appConfig/cycle → cycleCache), which only advances on session days. Until
// that doc has loaded (cold start / offline) it falls back to the old LOCAL
// calendar-day formula so the app is never blank. As before, anything that must
// stay in sync across a call should write getTodayIndex() into the call doc
// once and have both sides read content via getContentByIndex().
export function getTodayIndex() {
  const n = weeklyContent.length;
  const cycle = getCachedCycle();
  if (cycle && Number.isFinite(cycle.currentTopicIndex)) {
    return ((cycle.currentTopicIndex % n) + n) % n;
  }
  const d = new Date();
  const localDays = Math.floor(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()) / 86400000);
  return ((localDays % n) + n) % n;
}

export function getContentByIndex(index) {
  const i = Number.isFinite(index) ? Math.abs(Math.trunc(index)) : 0;
  return weeklyContent[i % weeklyContent.length];
}

export function getTodayContent() {
  return getContentByIndex(getTodayIndex());
}

